var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _mask, _path52, _path53, _path54, _mask2, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _mask3, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _mask4, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _mask5, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _mask6, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _mask7, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _mask8, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _mask9, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _mask10, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _mask11, _path375, _path376, _path377, _path378, _mask12, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _mask13, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _mask14, _path395, _path396, _path397, _path398, _mask15, _path399, _path400, _mask16, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _mask17, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _mask18, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _mask19, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _mask20, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _mask21, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _mask22, _path490, _path491, _path492, _path493, _mask23, _path494, _path495, _path496, _path497, _path498, _path499, _mask24, _path500, _path501, _path502, _mask25, _path503, _path504, _path505, _path506, _mask26, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _mask27, _path516, _path517, _path518, _path519, _mask28, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _mask29, _path530, _path531, _path532, _path533, _mask30, _path534, _path535, _path536, _mask31, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _mask32, _path546, _path547, _path548, _path549, _path550, _path551, _mask33, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _mask34, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _mask35, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _mask36, _path588, _path589, _path590, _mask37, _path591, _path592, _path593, _mask38, _path594, _path595, _path596, _mask39, _path597, _path598, _mask40, _path599, _path600, _path601, _path602, _path603, _mask41, _path604, _mask42, _path605, _mask43, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _mask44, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _mask45, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _mask46, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _mask47, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _mask48, _path660, _path661, _path662, _path663, _path664, _path665, _mask49, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _mask50, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _mask51, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _mask52, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _mask53, _path728, _path729, _path730, _path731, _path732, _path733, _mask54, _path734, _path735, _path736, _mask55, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _mask56, _path744, _path745, _path746, _path747, _mask57, _path748, _path749, _path750, _path751, _mask58, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _mask59, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _mask60, _path782, _path783, _mask61, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _mask62, _path792, _mask63, _path793, _path794, _mask64, _path795, _path796, _path797, _path798, _path799, _path800, _mask65, _path801, _mask66, _path802, _path803, _mask67, _path804, _mask68, _path805, _mask69, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _path816, _path817, _mask70, _path818, _path819, _path820, _path821, _mask71, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _mask72, _path829, _path830, _mask73, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844, _path845, _path846, _path847, _mask74, _path848, _mask75, _path849, _mask76, _path850, _path851, _path852, _mask77, _path853, _path854, _path855, _path856, _mask78, _path857, _path858, _path859, _path860, _path861, _path862, _path863, _path864, _path865, _mask79, _path866, _path867, _path868, _path869, _path870, _path871, _path872, _path873, _path874, _path875, _path876, _path877, _mask80, _path878, _mask81, _path879, _path880, _path881, _path882, _mask82, _path883, _path884, _mask83, _path885, _path886, _path887, _path888, _path889, _path890, _path891, _path892, _mask84, _path893, _path894, _path895, _mask85, _path896, _path897, _path898, _path899, _path900, _path901, _path902, _path903, _mask86, _path904, _path905, _path906, _path907, _path908, _mask87, _path909, _path910, _path911, _path912, _path913, _mask88, _path914, _mask89, _path915, _path916, _path917, _path918, _path919, _path920, _path921, _path922, _path923, _path924, _path925, _path926, _path927, _path928, _path929, _mask90, _path930, _path931, _path932, _path933, _path934, _path935, _path936, _mask91, _path937, _path938, _path939, _path940, _path941, _mask92, _path942, _path943, _path944, _path945, _path946, _path947, _path948, _path949, _path950, _path951, _path952, _path953, _path954, _mask93, _path955, _path956, _mask94, _path957, _path958, _path959, _path960, _path961, _path962, _path963, _path964, _path965, _path966, _mask95, _path967, _path968, _path969, _path970, _path971, _path972, _path973, _path974, _path975, _path976, _path977, _path978, _path979, _path980, _mask96, _path981, _mask97, _path982, _path983, _path984, _path985, _path986, _path987, _path988, _path989, _path990, _path991, _path992, _mask98, _path993, _mask99, _path994, _mask100, _path995, _path996, _path997, _path998, _path999, _path1000, _mask101, _path1001, _path1002, _path1003, _path1004, _path1005, _path1006, _path1007, _path1008, _path1009, _path1010, _path1011, _path1012, _path1013, _path1014, _path1015, _path1016, _path1017, _path1018, _path1019, _path1020, _path1021, _path1022, _path1023, _path1024, _path1025, _path1026, _path1027, _path1028, _path1029, _path1030, _path1031, _path1032, _path1033, _path1034, _path1035, _path1036, _path1037, _path1038, _path1039, _path1040, _path1041, _path1042, _path1043, _path1044, _path1045, _path1046, _path1047, _path1048, _path1049, _path1050, _mask102, _path1051, _path1052, _path1053, _path1054, _path1055, _path1056, _path1057, _path1058, _path1059, _path1060, _path1061, _path1062, _path1063, _path1064, _path1065, _path1066, _path1067, _path1068, _path1069, _mask103, _path1070, _path1071, _path1072, _mask104, _path1073, _path1074, _path1075, _path1076, _mask105, _path1077, _path1078, _path1079, _mask106, _path1080, _path1081, _path1082, _path1083, _path1084, _path1085, _mask107, _path1086, _mask108, _path1087, _path1088, _path1089, _path1090, _path1091, _path1092, _path1093, _path1094, _path1095, _path1096, _mask109, _path1097, _path1098, _path1099, _path1100, _path1101, _path1102, _path1103, _path1104, _path1105, _path1106, _path1107, _path1108, _path1109, _path1110, _path1111, _path1112, _path1113, _path1114, _path1115, _path1116, _path1117, _path1118, _path1119, _path1120, _path1121, _mask110, _path1122, _mask111, _path1123, _path1124, _path1125, _path1126, _path1127, _mask112, _path1128, _path1129, _path1130, _path1131, _path1132, _path1133, _path1134, _path1135, _path1136, _path1137, _path1138, _path1139, _path1140, _path1141, _path1142, _mask113, _path1143, _path1144, _path1145, _path1146, _mask114, _path1147, _path1148, _mask115, _path1149, _path1150, _path1151, _path1152, _path1153, _path1154, _path1155, _path1156, _mask116, _path1157, _path1158, _path1159, _path1160, _path1161, _path1162, _path1163, _path1164, _path1165, _path1166, _path1167, _path1168, _path1169, _path1170, _path1171, _path1172, _path1173, _path1174, _path1175, _path1176, _path1177, _path1178, _path1179, _path1180, _path1181, _path1182, _mask117, _path1183, _path1184, _path1185, _mask118, _path1186, _path1187, _path1188, _path1189, _path1190, _path1191, _path1192, _path1193, _path1194, _path1195, _path1196, _path1197, _path1198, _mask119, _path1199, _path1200, _mask120, _path1201, _path1202, _path1203, _path1204, _path1205, _path1206, _path1207, _path1208, _path1209, _path1210, _path1211, _path1212, _path1213, _path1214, _path1215, _path1216, _path1217, _path1218, _path1219, _path1220, _path1221, _path1222, _path1223, _path1224, _path1225, _path1226, _mask121, _path1227, _path1228, _path1229, _path1230, _path1231, _path1232, _path1233, _path1234, _path1235, _path1236, _path1237, _path1238, _path1239, _mask122, _path1240, _path1241, _path1242, _path1243, _path1244, _path1245, _path1246, _path1247, _path1248, _path1249, _path1250, _path1251, _mask123, _path1252, _path1253, _path1254, _path1255, _path1256, _path1257, _path1258, _path1259, _path1260, _path1261, _path1262, _path1263, _mask124, _path1264, _path1265, _path1266, _path1267, _path1268, _path1269, _path1270, _path1271, _path1272, _path1273, _path1274, _path1275, _path1276, _path1277, _mask125, _path1278, _path1279, _path1280, _path1281, _path1282, _path1283, _path1284, _path1285, _path1286, _path1287, _path1288, _path1289, _path1290, _path1291, _path1292, _path1293, _path1294, _path1295, _path1296, _path1297, _path1298, _path1299, _path1300, _path1301, _path1302, _mask126, _path1303, _path1304, _path1305, _path1306, _path1307, _path1308, _path1309, _path1310, _path1311, _path1312, _mask127, _path1313, _path1314, _path1315, _path1316, _path1317, _path1318, _path1319, _path1320, _path1321, _path1322, _path1323, _path1324, _path1325, _path1326, _path1327, _path1328, _path1329, _path1330, _path1331, _path1332, _path1333, _path1334, _path1335, _path1336, _path1337, _path1338, _path1339, _mask128, _path1340, _path1341, _path1342, _path1343, _path1344, _path1345, _path1346, _path1347, _path1348, _path1349, _path1350, _path1351, _mask129, _path1352, _path1353, _path1354, _path1355, _path1356, _path1357, _path1358, _mask130, _path1359, _path1360, _path1361, _path1362, _path1363, _path1364, _path1365, _path1366, _path1367, _path1368, _path1369, _path1370, _path1371, _path1372, _path1373, _path1374, _path1375, _path1376, _path1377, _path1378, _path1379, _path1380, _path1381, _path1382, _path1383, _path1384, _path1385, _path1386, _path1387, _path1388, _path1389, _mask131, _path1390, _path1391, _mask132, _path1392, _path1393, _path1394, _path1395, _path1396, _path1397, _path1398, _path1399, _path1400, _path1401, _path1402, _path1403, _path1404, _path1405, _path1406, _path1407, _path1408, _path1409, _path1410, _path1411, _path1412, _path1413, _path1414, _path1415, _path1416, _mask133, _path1417, _path1418, _path1419, _path1420, _path1421, _path1422, _path1423, _path1424, _mask134, _path1425, _path1426, _path1427, _path1428, _path1429, _path1430, _path1431, _path1432, _path1433, _mask135, _path1434, _path1435, _path1436, _path1437, _path1438, _path1439, _mask136, _path1440, _path1441, _path1442, _path1443, _path1444, _path1445, _path1446, _path1447, _path1448, _path1449, _path1450, _path1451, _path1452, _path1453, _path1454, _path1455, _mask137, _path1456, _path1457, _path1458, _path1459, _path1460, _path1461, _mask138, _path1462, _path1463, _path1464, _path1465, _path1466, _mask139, _path1467, _path1468, _path1469, _path1470, _path1471, _path1472, _path1473, _mask140, _path1474, _path1475, _path1476, _path1477, _path1478, _path1479, _path1480, _path1481, _mask141, _path1482, _path1483, _path1484, _path1485, _path1486, _path1487, _path1488, _path1489, _path1490, _path1491, _path1492, _path1493, _path1494, _path1495, _path1496, _path1497, _path1498, _path1499, _path1500, _path1501, _path1502, _path1503, _path1504, _path1505, _path1506, _path1507, _path1508, _path1509, _path1510, _path1511, _path1512, _path1513, _path1514, _path1515, _path1516, _path1517, _path1518, _path1519, _path1520, _path1521, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrvUsd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    rx: 96,
    fill: "url(#paint0_linear_1396_24002)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.476 104.291L88.9378 107.583L80.974 109.336L80.0452 105.833L88.476 104.291Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6558 105.922L80.5887 109.44L73.7081 111.776L72.2906 108.089L79.6558 105.922Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0034 99.9782L88.4237 103.89L79.9504 105.44L79.1015 101.291L88.0034 99.9782Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7106 101.367L79.5623 105.53L72.1596 107.708L70.8647 103.351L78.7106 101.367Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0011 107.978L89.4863 110.562L82.0669 112.485L81.0917 109.719L89.0011 107.978Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7068 109.822L81.6881 112.605L75.3663 115.066L73.8735 112.141L80.7068 109.822Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6022 95.1527L87.9672 99.5819L79.0317 100.9L78.29 96.2121L87.6022 95.1527Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8958 96.2746L78.6395 100.975L70.7637 102.967L69.6314 98.0498L77.8958 96.2746Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0347 103.32L98.0652 106.355L89.3316 107.515L88.8716 104.236L98.0347 103.32Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5761 110.95L90.0607 112.758L83.2066 114.813L82.2292 112.854L89.5761 110.95Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9134 108.233L73.3372 111.935L67.742 114.804L65.8394 110.983L71.9134 108.233Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.842 112.976L82.8299 114.956L77.092 117.506L75.5822 115.413L81.842 112.976Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0086 99.2852L98.0317 102.913L88.8228 103.834L88.4037 99.9349L98.0086 99.2852Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4844 103.48L71.7831 107.85L65.679 110.614L63.9436 106.101L70.4844 103.48Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0706 106.755L98.1066 109.113L89.8796 110.477L89.3968 107.906L98.0706 106.755Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5017 112.3L75.0046 115.244L69.9545 118.187L67.9436 115.15L73.5017 112.3Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.275 89.9171L87.573 94.7493L78.2345 95.8116L77.6228 90.7042L87.275 89.9171Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2263 90.7602L77.8396 95.8797L69.5517 97.6599L68.6156 92.3064L77.2263 90.7602Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9908 94.7616L98.0059 98.8862L88.365 99.5383L88.0011 95.1216L97.9908 94.7616Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2447 98.1622L70.3797 103.091L63.8147 105.721L62.2977 100.627L69.2447 98.1622Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1133 109.517L98.1526 111.13L90.4482 112.661L89.9678 110.868L98.1133 109.517Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1935 113.135L90.6329 114.122L84.3564 116.267L83.4482 115.158L90.1935 113.135Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2129 115.585L76.7414 117.704L72.2608 120.686L70.21 118.501L75.2129 115.585Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0453 115.298L83.9774 116.436L78.8439 119.03L77.3986 117.807L83.0453 115.298Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9842 89.8485L97.9904 94.3603L87.9729 94.7212L87.6757 89.9017L97.9842 89.8485Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2275 92.4017L69.1653 97.765L62.1993 100.237L60.9446 94.6882L68.2275 92.4017Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M98.168 111.535L98.2047 112.353L91.0198 114.008L90.5888 113.041L98.168 111.535Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M87.033 84.4082L87.2551 89.5181L77.583 90.3069L77.1197 84.9109L87.033 84.4082Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M107.904 102.966L107.558 105.723L98.4631 106.312L98.4328 103.288L107.904 102.966Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7198 84.9534L77.184 90.361L68.5556 91.9104L67.8433 86.2557L76.7198 84.9534Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M107.499 106.128L107.148 108.243L98.5051 109.061L98.4691 106.713L107.499 106.128Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M108.277 99.2432L107.952 102.566L98.4315 102.89L98.4084 99.2731L108.277 99.2432Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4922 111.178L67.4017 115.013L63.1766 118.328L60.8196 114.431L65.4922 111.178Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5863 106.288L65.3252 110.811L60.6325 114.078L58.4863 109.469L63.5863 106.288Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0113 118.003L78.4966 119.259L74.6045 122.237L72.5963 120.941L77.0113 118.003Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M67.606 115.364L69.6294 118.42L65.9046 121.754L63.4052 118.66L67.606 115.364Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8649 114.462L91.1011 114.647L85.4748 116.808L84.8343 116.523L90.8649 114.462Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M107.061 108.657L106.728 110.064L98.5519 111.071L98.5128 109.467L107.061 108.657Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M108.605 95.0458L108.312 98.842L98.4061 98.8721L98.391 94.7598L108.605 95.0458Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M84.294 116.724L85.0284 117.051L80.5709 119.604L79.3459 119.224L84.294 116.724Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9859 84.667L97.9831 89.4477L87.6536 89.5009L87.4322 84.4035L97.9859 84.667Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9339 100.799L63.4525 105.899L58.3363 109.09L56.4616 103.881L61.9339 100.799Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3564 114.344L98.1334 112.783L91.5484 114.495L91.3564 114.344Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9539 120.941L68.7504 124.263L66.1836 122.039L69.8792 118.73L71.9539 120.941Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.45 86.3375L68.1634 92.0005L60.8666 94.2914L59.9103 88.4275L67.45 86.3375Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M106.579 110.483L106.319 111.129L98.6026 112.281L98.5662 111.471L106.579 110.483Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8795 78.7579L87.0183 84.0126L77.0909 84.5161L76.7901 78.9707L86.8795 78.7579Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M108.881 90.4774L108.63 94.6455L98.388 94.3587L98.3817 89.8596L108.881 90.4774Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3902 78.9973L76.6916 84.5533L67.8029 85.8574L67.3358 80.0465L76.3902 78.9973Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8547 119.489L80.1974 119.906L76.9279 122.806L75.0738 122.382L78.8547 119.489Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5689 94.8502L61.8244 100.401L56.3399 103.491L54.7898 97.8096L60.5689 94.8502Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-53-inside-1_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.087 114.285L86.617 116.613L85.47 117.028L91.503 114.71L92.087 114.285Z"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M92.087 114.285L92.3223 114.609L91.9304 113.917L92.087 114.285ZM86.617 116.613L86.7531 116.989L86.7634 116.985L86.7736 116.981L86.617 116.613ZM85.47 117.028L85.3266 116.654L85.6061 117.404L85.47 117.028ZM91.503 114.71L91.6464 115.083L91.6957 115.065L91.7383 115.033L91.503 114.71ZM91.9304 113.917L86.4604 116.245L86.7736 116.981L92.2436 114.653L91.9304 113.917ZM86.4809 116.237L85.3339 116.651L85.6061 117.404L86.7531 116.989L86.4809 116.237ZM85.6135 117.401L91.6464 115.083L91.3595 114.337L85.3266 116.654L85.6135 117.401ZM91.7383 115.033L92.3223 114.609L91.8516 113.962L91.2677 114.387L91.7383 115.033Z",
    fill: "white",
    mask: "url(#path-53-inside-1_1396_24002)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M72.26 121.204L74.3168 122.531L71.6464 125.806L69.0934 124.488L72.26 121.204Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M97.9982 79.3479L97.9863 84.2712L87.4178 84.0073L87.2793 78.7652L97.9982 79.3479Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-57-inside-2_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.04 111.597L98.4715 112.898L98.4126 112.509L106.462 111.307L106.04 111.597Z"
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M106.04 111.597L106.108 111.991L106.195 111.976L106.267 111.926L106.04 111.597ZM98.4715 112.898L98.076 112.958L98.1371 113.361L98.5392 113.292L98.4715 112.898ZM98.4126 112.509L98.3535 112.114L97.9571 112.173L98.0171 112.569L98.4126 112.509ZM106.462 111.307L106.688 111.637L106.402 110.912L106.462 111.307ZM105.973 111.202L98.4037 112.503L98.5392 113.292L106.108 111.991L105.973 111.202ZM98.8669 112.838L98.8081 112.449L98.0171 112.569L98.076 112.958L98.8669 112.838ZM98.4717 112.905L106.521 111.703L106.402 110.912L98.3535 112.114L98.4717 112.905ZM106.235 110.978L105.814 111.267L106.267 111.926L106.688 111.637L106.235 110.978Z",
    fill: "white",
    mask: "url(#path-57-inside-2_1396_24002)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M117.599 103.17L116.943 105.64L107.964 105.71L108.308 102.962L117.599 103.17Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M116.814 106.041L116.149 107.905L107.558 108.219L107.908 106.112L116.814 106.041Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2427 119.206L81.9453 119.28L83.5466 118.363L82.2427 119.206Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.105 85.6529L108.904 90.0815L98.3833 89.4625L98.3862 84.6952L109.105 85.6529Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M97.598 112.92L98.2937 112.721L98.2911 112.74L97.598 112.92Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M118.31 99.7688L117.696 102.773L108.354 102.564L108.678 99.252L118.31 99.7688Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9413 80.122L67.4089 85.9397L59.8604 88.0321L59.231 82.0022L66.9413 80.122Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M115.955 108.312L115.332 109.51L107.148 110.025L107.48 108.622L115.955 108.312Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8813 118.614L59.9971 122.251L57.2472 118.348L60.5215 114.713L62.8813 118.614Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6322 122.053L63.1746 125.657L60.2499 122.57L63.1235 118.947L65.6322 122.053Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8199 73.0936L86.8711 78.3543L76.7734 78.5673L76.6448 73.0179L86.8199 73.0936Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M118.931 95.9169L118.382 99.3719L108.711 98.853L109.003 95.0685L118.931 95.9169Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1692 109.731L60.3142 114.338L57.0312 117.982L54.5312 113.351L58.1692 109.731Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M59.53 88.5791L60.4861 94.4428L54.699 97.4063L53.5175 91.3943L59.53 88.5791Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2471 73.0341L76.3759 78.594L67.3148 79.6439L67.1075 73.8272L76.2471 73.0341Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M114.969 109.932L114.523 110.412L106.769 111.08L107.03 110.433L114.969 109.932Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6915 120.001L81.6968 119.75L79.181 122.364L77.6768 122.675L80.6915 120.001Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6895 122.707L76.6545 123.156L74.5239 126.331L72.0712 125.918L74.6895 122.707Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9214 122.338L68.5096 124.581L66.4952 128.128L63.4759 125.924L65.9214 122.338Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7043 112.654L98.71 112.612L105.557 111.316L105.67 111.457L98.7043 112.654Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1289 104.137L58.0004 109.338L54.3561 112.964L52.1748 107.717L56.1289 104.137Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0206 74.0099L97.9995 78.9443L87.2717 78.3612L87.2205 73.1131L98.0206 74.0099Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M109.266 80.6773L109.12 85.2479L98.3867 84.2889L98.3987 79.3795L109.266 80.6773Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M119.452 91.7097L118.986 95.5211L109.03 94.6702L109.28 90.5147L119.452 91.7097Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2707 116.118L87.8294 115.42L92.2577 113.367L91.9356 114.133L87.2707 116.118Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4344 113.979L92.7903 113.133L98.3827 111.426L98.3405 112.292L92.4344 113.979Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-85-inside-3_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.79 110.786L106.04 111.597L106.461 111.308L114.617 110.605L113.79 110.786Z"
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M113.79 110.786L113.832 111.183L113.854 111.181L113.875 111.176L113.79 110.786ZM106.04 111.597L105.814 111.267L106.082 111.995L106.04 111.597ZM106.461 111.308L106.427 110.909L106.322 110.918L106.235 110.978L106.461 111.308ZM114.617 110.605L114.702 110.996L114.582 110.207L114.617 110.605ZM113.748 110.388L105.998 111.199L106.082 111.995L113.832 111.183L113.748 110.388ZM106.267 111.927L106.688 111.637L106.235 110.978L105.814 111.267L106.267 111.927ZM106.495 111.706L114.651 111.004L114.582 110.207L106.427 110.909L106.495 111.706ZM114.532 110.215L113.705 110.395L113.875 111.176L114.702 110.996L114.532 110.215Z",
    fill: "white",
    mask: "url(#path-85-inside-3_1396_24002)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5771 117.048L86.6199 116.291L86.4828 116.462L85.5771 117.048Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7082 73.8913L66.9157 79.7133L59.2019 81.5943L58.919 75.5539L66.7082 73.8913Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8439 124.806L71.4402 126.146L69.8758 129.609L66.8436 128.327L68.8439 124.806Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4432 98.0568L55.9894 103.723L52.0319 107.306L50.2297 101.569L54.4432 98.0568Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8423 82.1369L59.4715 88.1639L53.4557 90.9807L52.6775 84.7904L58.8423 82.1369Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M119.861 87.2477L119.494 91.3116L109.302 90.1142L109.502 85.6992L119.861 87.2477Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8577 67.5691L86.8195 72.6948L76.6419 72.6191L76.6902 67.2134L86.8577 67.5691Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M98.744 112.2L98.7871 111.317L105.125 110.051L105.384 110.944L98.744 112.2Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1035 123.203L78.9052 122.83L77.318 125.817L75.0528 126.259L77.1035 123.203Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M125.503 106.416L124.601 108.03L116.574 107.904L117.237 106.045L125.503 106.416Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M126.596 103.845L125.702 106.026L117.354 105.652L118.007 103.19L126.596 103.845Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M109.36 75.6897L109.276 80.2788L98.4002 78.9801L98.4211 74.0597L109.36 75.6897Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2903 67.2184L76.242 72.6337L67.1015 73.427L67.1617 67.7591L76.2903 67.2184Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M113.234 110.642L106.127 111.386L106.021 111.254L112.945 110.441L113.234 110.642Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3167 120.909L80.7906 121.27L82.2798 119.723L81.3167 120.909Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M124.295 108.426L123.465 109.42L115.788 109.499L116.411 108.302L124.295 108.426Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M127.58 100.772L126.741 103.456L118.097 102.797L118.71 99.8026L127.58 100.772Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0528 68.7985L98.0236 73.6103L87.2207 72.7133L87.2587 67.6002L98.0528 68.7985Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8181 126.281L74.3547 126.709L73.2375 130.056L70.2712 129.706L71.8181 126.281Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0957 114.855L88.8483 113.136L92.8596 111.153L92.4681 112.829L88.0957 114.855Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M122.855 109.827L122.329 110.158L115.089 110.391L115.544 109.902L122.855 109.827Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9162 112.678L93.3213 110.944L98.4512 109.322L98.4008 111.003L92.9162 112.678Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M128.439 97.2687L127.69 100.38L118.781 99.4065L119.328 95.9631L128.439 97.2687Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M120.147 82.6399L119.892 86.8461L109.519 85.2956L109.664 80.7395L120.147 82.6399Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1592 91.6351L54.3366 97.626L50.1234 101.138L48.7509 95.0568L53.1592 91.6351Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7569 122.605L58.0843 126.409L55.0344 122.577L57.0164 118.716L59.7569 122.605Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0478 122.938L62.9706 126.022L61.628 129.75L58.375 126.742L60.0478 122.938Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6784 117.204L85.5997 115.744L88.1836 113.657L87.5403 115.127L84.6784 117.204Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7652 118.334L54.7848 122.192L52.018 117.625L54.2794 113.729L56.7652 118.334Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7623 67.8128L66.702 73.4846L58.9152 75.1466L58.989 69.2554L66.7623 67.8128Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-117-inside-4_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.242 110.423L113.791 110.786L114.617 110.605L122.392 110.355L121.242 110.423Z"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M121.242 110.423L121.261 110.823L121.266 110.823L121.242 110.423ZM113.791 110.786L113.705 110.395L113.81 111.185L113.791 110.786ZM114.617 110.605L114.604 110.206L114.568 110.207L114.532 110.215L114.617 110.605ZM122.392 110.355L122.416 110.755L122.379 109.956L122.392 110.355ZM121.223 110.024L113.771 110.386L113.81 111.185L121.261 110.823L121.223 110.024ZM113.876 111.176L114.702 110.996L114.532 110.215L113.705 110.395L113.876 111.176ZM114.63 111.005L122.405 110.755L122.379 109.956L114.604 110.206L114.63 111.005ZM122.369 109.956L121.218 110.024L121.266 110.823L122.416 110.755L122.369 109.956Z",
    fill: "white",
    mask: "url(#path-117-inside-4_1396_24002)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M112.672 110.073L105.784 110.882L105.525 109.99L112.153 109.178L112.672 110.073Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5249 75.6836L58.8075 81.7176L52.6446 84.3703L52.2937 78.1618L58.5249 75.6836Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2985 126.29L66.3283 128.501L65.3294 132.135L61.9568 130.015L63.2985 126.29Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8026 110.904L98.8533 109.208L104.77 108.019L105.038 109.659L98.8026 110.904Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M129.156 93.4225L128.524 96.8737L119.385 95.5641L119.849 91.7661L129.156 93.4225Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M109.386 70.802L109.365 75.2832L98.4233 73.6529L98.4526 68.8557L109.386 70.802Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9924 62.3199L86.8655 67.1703L76.7017 66.8147L76.9265 61.6999L86.9924 62.3199Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4346 122.685L81.023 121.594L79.9619 124.266L77.9615 125.457L79.4346 122.685Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0618 113.304L51.8041 117.194L49.3941 112.001L51.8966 108.095L54.0618 113.304Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5262 61.6953L76.301 66.8189L67.1777 67.3593L67.5052 61.9936L76.5262 61.6953Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0927 63.8407L98.0558 68.3968L87.2652 67.1989L87.3919 62.3613L98.0927 63.8407Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7729 126.721L77.1922 126.249L76.5062 129.439L73.6763 130.006L74.7729 126.721Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M120.302 78.0054L120.165 82.2378L109.673 80.336L109.758 75.7628L120.302 78.0054Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M120.525 110.26L113.849 110.584L113.587 110.402L120.093 110.022L120.525 110.26Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-133-inside-5_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.4486 115.61L83.4399 118.579L81.4532 121.058L83.9551 117.977L85.4486 115.61Z"
  }))), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4486 115.61L85.7869 115.823L85.1173 115.386L85.4486 115.61ZM83.4399 118.579L83.752 118.829L83.7621 118.817L83.7712 118.803L83.4399 118.579ZM81.4532 121.058L81.1411 120.808L81.7637 121.31L81.4532 121.058ZM83.9551 117.977L84.2656 118.229L84.2806 118.211L84.2934 118.191L83.9551 117.977ZM85.1173 115.386L83.1085 118.355L83.7712 118.803L85.7799 115.834L85.1173 115.386ZM83.1277 118.329L81.1411 120.808L81.7653 121.308L83.752 118.829L83.1277 118.329ZM81.7637 121.31L84.2656 118.229L83.6446 117.725L81.1427 120.806L81.7637 121.31ZM84.2934 118.191L85.7869 115.823L85.1103 115.396L83.6168 117.764L84.2934 118.191Z",
    fill: "white",
    mask: "url(#path-133-inside-5_1396_24002)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6892 128.696L69.75 129.99L69.1006 133.512L65.6924 132.322L66.6892 128.696Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3043 85.0281L53.0792 91.1907L48.6757 94.6086L47.7728 88.3367L52.3043 85.0281Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M129.714 89.33L129.219 93.0258L119.892 91.3659L120.257 87.3168L129.714 89.33Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3976 110.497L93.7838 107.934L98.5143 106.445L98.4623 108.897L93.3976 110.497Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0079 112.61L89.7405 109.988L93.3477 108.137L92.9688 110.652L89.0079 112.61Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M111.993 108.795L105.435 109.598L105.167 107.96L111.459 107.214L111.993 108.795Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9313 101.953L51.7169 107.636L49.2209 111.532L47.2335 105.842L49.9313 101.953Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M133.061 107.165L131.998 108.541L125.045 108.053L125.945 106.442L133.061 107.165Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M131.585 108.914L130.626 109.721L123.973 109.436L124.806 108.438L131.585 108.914Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M134.389 104.889L133.328 106.792L126.121 106.06L127.012 103.885L134.389 104.889Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8633 108.799L98.9157 106.337L104.474 105.275L104.717 107.623L98.8633 108.799Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9204 114.973L86.9327 112.455L89.197 110.451L88.5199 112.875L85.9204 114.973Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M119.737 109.641L113.109 110.028L112.596 109.142L119.018 108.756L119.737 109.641Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M109.34 66.1502L109.382 70.3979L98.4532 68.4524L98.4901 63.9115L109.34 66.1502Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1385 130.093L73.1587 130.449L72.8557 133.839L69.4922 133.598L70.1385 130.093Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5864 69.3754L58.5127 75.2562L52.2896 77.7311L52.3784 71.6694L58.5864 69.3754Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M129.77 110.085L129.247 110.298L123.061 110.169L123.613 109.821L129.77 110.085Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1012 62.0377L66.7736 67.4051L59.0093 68.846L59.4399 63.264L67.1012 62.0377Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M135.58 102.135L134.583 104.509L127.149 103.497L127.984 100.822L135.58 102.135Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M130.099 85.0942L129.758 88.9322L120.288 86.9164L120.543 82.7267L130.099 85.0942Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M120.322 73.4546L120.308 77.5952L109.763 75.3524L109.785 70.8881L120.322 73.4546Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2194 57.4834L87.0071 61.9217L76.952 61.3024L77.347 56.622L87.2194 57.4834Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6276 121.158L82.9976 119.449L82.3914 121.699L80.6975 123.5L81.6276 121.158Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-158-inside-6_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.894 110.457L121.24 110.423L122.391 110.355L129.283 110.499L127.894 110.457Z"
  }))), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M127.894 110.457L127.906 110.057L127.896 110.057L127.894 110.457ZM121.24 110.423L121.217 110.024L121.238 110.823L121.24 110.423ZM122.391 110.355L122.399 109.956L122.383 109.955L122.367 109.956L122.391 110.355ZM129.283 110.499L129.275 110.899L129.295 110.099L129.283 110.499ZM127.896 110.057L121.243 110.023L121.238 110.823L127.892 110.857L127.896 110.057ZM121.264 110.823L122.414 110.755L122.367 109.956L121.217 110.024L121.264 110.823ZM122.382 110.755L129.275 110.899L129.291 110.099L122.399 109.956L122.382 110.755ZM129.295 110.099L127.906 110.057L127.882 110.857L129.271 110.899L129.295 110.099Z",
    fill: "white",
    mask: "url(#path-158-inside-6_1396_24002)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6278 126.122L79.8868 124.777L79.597 127.769L76.961 129.222L77.6278 126.122Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M136.615 98.9789L135.724 101.754L128.089 100.434L128.835 97.3345L136.615 98.9789Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1395 59.2666L98.0958 63.4376L87.4055 61.9596L87.6172 57.5338L98.1395 59.2666Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M105.114 107.563L104.871 105.219L110.865 104.596L111.354 106.824L105.114 107.563Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9468 56.6022L76.5509 61.2905L67.5427 61.5883L68.1289 56.6748L76.9468 56.6022Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9051 78.3992L52.2539 84.5714L47.7331 87.8721L47.3269 81.5746L51.9051 78.3992Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4292 95.445L49.786 101.457L47.0988 105.331L45.5888 99.2887L48.4292 95.445Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1216 115.736L85.3672 115.257L85.3949 115.207L85.2711 115.515L85.1216 115.736Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M118.796 108.368L112.399 108.753L111.868 107.181L118.058 106.855L118.796 108.368Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2897 127.206L61.5082 130.182L61.2306 133.687L57.8806 130.762L58.2897 127.206Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9278 123.082L57.9258 126.848L57.5223 130.356L54.4025 126.635L54.9278 123.082Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8345 107.499L94.1731 104.178L98.5736 102.866L98.5226 106.024L93.8345 107.499Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M127.029 110.252L121.293 110.223L120.913 110.015L126.515 109.998L127.029 110.252Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8446 109.489L90.488 106.051L93.7517 104.374L93.4173 107.656L89.8446 109.489Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M137.475 95.4952L136.724 98.5935L128.919 96.9435L129.548 93.5066L137.475 95.4952Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8886 130.447L65.2475 132.558L65.1045 136.043L61.6078 133.99L61.8886 130.447Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5611 130.436L76.4743 129.852L76.5034 133.088L73.2608 133.795L73.5611 130.436Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M130.301 80.8183L130.125 84.6905L120.563 82.3216L120.7 78.1075L130.301 80.8183Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8884 118.184L54.5896 122.643L54.0729 126.138L51.2623 121.717L51.8884 118.184Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9247 105.929L98.9757 102.767L104.239 101.882L104.44 104.876L98.9247 105.929Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M109.228 61.8477L109.333 65.74L98.4953 63.5038L98.5388 59.3482L109.228 61.8477Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M120.206 69.1119L120.316 73.0429L109.785 70.478L109.743 66.248L120.206 69.1119Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1315 111.746L88.048 108.333L89.9996 106.486L89.3891 109.748L87.1315 111.746Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6407 132.728L69.0569 133.921L69.0536 137.37L65.4967 136.24L65.6407 132.728Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M126.085 109.602L120.234 109.619L119.529 108.751L125.235 108.739L126.085 109.602Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0299 63.3787L58.6004 68.9456L52.4085 71.2337L52.9364 65.4845L59.0299 63.3787Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M138.141 91.7737L137.555 95.1076L129.611 93.1147L130.104 89.4357L138.141 91.7737Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M67.7218 56.711L67.1356 61.6237L59.4917 62.8472L60.2675 57.7305L67.7218 56.711Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2427 112.618L51.5776 117.649L50.9638 121.113L48.5349 116.11L49.2427 112.618Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91 106.464L111.754 106.788L111.267 104.57L117.233 104.364L117.91 106.464Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M104.836 104.819L104.635 101.833L110.383 101.386L110.793 104.2L104.836 104.819Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5353 53.1875L87.2445 57.0846L77.3913 56.2248L77.9443 52.1141L87.5353 53.1875Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4257 88.7411L48.3158 94.9243L45.492 98.7456L44.5021 92.5105L47.4257 88.7411Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3157 124.491L82.3799 122.295L82.4332 125.071L80.0363 127.375L80.3157 124.491Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1925 55.197L98.1439 58.8605L87.6408 57.1308L87.9306 53.2454L98.1925 55.197Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6272 118.649L84.8114 116.338L84.5369 118.167L83.1321 120.486L83.6272 118.649Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M130.315 76.6056L130.309 80.4027L120.709 77.6923L120.723 73.5716L130.315 76.6056Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M137.376 109.696L136.344 110.343L131.181 109.776L132.152 108.96L137.376 109.696Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M139.036 108.203L137.876 109.365L132.46 108.601L133.525 107.223L139.036 108.203Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9755 71.9093L51.8874 77.925L47.3278 81.0875L47.4315 74.9347L51.9755 71.9093Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M135.31 110.634L134.801 110.77L130.129 110.372L130.722 110.13L135.31 110.634Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M140.521 106.207L139.358 107.853L133.751 106.857L134.81 104.958L140.521 106.207Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5433 52.0842L76.9896 56.2015L68.1936 56.2739L69.0203 51.9545L77.5433 52.0842Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2069 103.748L94.48 99.7581L98.6274 98.6629L98.5799 102.444L94.2069 103.748Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M69.456 133.994L72.8456 134.237L72.9821 137.63L69.4527 137.453L69.456 133.994Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8728 129.727L79.6184 128.214L79.9535 131.278L76.9016 132.917L76.8728 129.727Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M124.96 108.338L119.233 108.35L118.501 106.851L124.081 106.901L124.96 108.338Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1086 113.103L86.8439 110.96L87.0475 110.512L86.5781 112.26L86.1086 113.103Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M138.597 87.8941L138.197 91.3687L130.15 89.0277L130.489 85.2097L138.597 87.8941Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M98.979 102.361L99.0266 98.5821L104.064 97.92L104.214 101.481L98.979 102.361Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0536 106.537L48.9612 111.998L48.2708 115.403L46.2867 109.96L47.0536 106.537Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-211-inside-7_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.27 110.828L127.894 110.457L129.283 110.499L134.819 110.971L133.27 110.828Z"
  }))), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M133.27 110.828L133.307 110.429L133.298 110.429L133.27 110.828ZM127.894 110.457L127.906 110.057L127.866 110.856L127.894 110.457ZM129.283 110.499L129.317 110.1L129.306 110.1L129.295 110.099L129.283 110.499ZM134.819 110.971L134.785 111.37L134.856 110.573L134.819 110.971ZM133.298 110.429L127.921 110.058L127.866 110.856L133.243 111.227L133.298 110.429ZM127.882 110.857L129.271 110.899L129.295 110.099L127.906 110.057L127.882 110.857ZM129.249 110.898L134.785 111.37L134.853 110.573L129.317 110.1L129.249 110.898ZM134.856 110.573L133.307 110.429L133.233 111.226L134.782 111.37L134.856 110.573Z",
    fill: "white",
    mask: "url(#path-211-inside-7_1396_24002)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5523 105.564L91.0677 101.406L94.0653 99.9358L93.794 103.898L90.5523 105.564Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M141.845 103.765L140.751 105.847L134.983 104.585L135.977 102.22L141.845 103.765Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M119.956 65.0867L120.185 68.6928L109.736 65.833L109.632 61.9598L119.956 65.0867Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M109.049 58.0125L109.212 61.4334L98.5434 58.9389L98.592 55.291L109.049 58.0125Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M117.131 103.968L111.194 104.173L110.785 101.371L116.56 101.338L117.131 103.968Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M132.233 110.556L127.947 110.261L127.541 110.06L131.734 110.319L132.233 110.556Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M142.996 100.94L142.019 103.398L136.114 101.844L137.001 99.0812L142.996 100.94Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M110.337 100.989L104.615 101.434L104.466 97.8851L110.025 97.6625L110.337 100.989Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M88.171 107.663L88.9136 103.475L90.615 101.816L90.1187 105.819L88.171 107.663Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M130.137 72.5744L130.301 76.1847L120.718 73.1535L120.609 69.2447L130.137 72.5744Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M123.895 106.501L118.326 106.451L117.655 104.367L123.086 104.533L123.895 106.501Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M138.831 83.9704L138.629 87.4863L130.518 84.801L130.694 80.9515L138.831 83.9704Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M73.2458 134.21L76.5259 133.495L76.7966 136.809L73.3818 137.592L73.2458 134.21Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9534 82.0005L47.3524 88.1846L44.454 91.9215L44.012 85.6655L46.9534 82.0005Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8464 57.8433L59.074 62.9386L53.0074 65.0351L53.9592 59.7616L59.8464 57.8433Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9288 49.5477L87.5707 52.7866L78.0097 51.7165L78.7004 48.2983L87.9288 49.5477Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M68.607 51.982L67.7812 56.2974L60.3556 57.313L61.4523 52.8103L68.607 51.982Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2526 51.7452L98.2003 54.7897L87.9684 52.8438L88.3253 49.616L98.2526 51.7452Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M131.228 109.889L126.651 109.606L125.83 108.773L130.318 109.066L131.228 109.889Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M57.932 131.34L61.2077 134.199L61.5864 137.254L58.3167 134.399L57.932 131.34Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M143.952 97.7995L143.13 100.561L137.111 98.6952L137.857 95.614L143.952 97.7995Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4764 127.35L57.4771 130.929L57.8447 133.853L54.8496 130.282L54.4764 127.35Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7737 121.855L84.6054 118.832L84.9411 121.4L82.8249 124.521L82.7737 121.855Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8059 105.812L46.0641 109.123L44.5765 103.406L45.3753 100.087L46.8059 105.812Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6451 134.473L65.1021 136.503L65.4865 139.652L62.0356 137.624L61.6451 134.473Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3848 115.214L86.4004 112.253L86.338 113.76L85.1742 116.617L85.3848 115.214Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 99.342L94.6952 94.7914L98.6731 93.9476L98.6305 98.2513L94.5 99.342Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9962 127.97L82.5147 125.549L83.1195 128.436L80.3252 130.979L79.9962 127.97Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M119.577 61.4857L119.916 64.6572L109.617 61.5381L109.455 58.1375L119.577 61.4857Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0325 98.1782L99.0749 93.8855L103.962 93.4861L104.053 97.5185L99.0325 98.1782Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5126 65.7273L51.9902 71.4163L47.476 74.4217L48.0866 68.5876L52.5126 65.7273Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3648 122.623L53.9996 126.768L54.3477 129.502L51.7179 125.368L51.3648 122.623Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M116.491 100.939L110.737 100.972L110.426 97.6626L116.054 97.8528L116.491 100.939Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2986 48.2663L77.6071 51.6886L69.1188 51.5594L70.1563 47.9636L78.2986 48.2663Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M108.808 54.7482L109.022 57.5913L98.599 54.8786L98.651 51.85L108.808 54.7482Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1105 100.942L91.4721 96.1777L94.2907 94.9405L94.096 99.4779L91.1105 100.942Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M129.993 108.644L125.432 108.346L124.569 106.934L129.038 107.293L129.993 108.644Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2828 109.028L87.9912 105.902L88.1525 105.473L87.675 108.167L87.2828 109.028Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M122.957 104.127L117.54 103.962L116.973 101.352L122.273 101.686L122.957 104.127Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M144.689 94.425L144.05 97.411L137.942 95.2205L138.523 91.9088L144.689 94.425Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5252 136.666L69.0683 137.791L69.4543 141.006L65.9173 139.878L65.5252 136.666Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M138.838 80.0947L138.84 83.5493L130.707 80.5322L130.713 76.7619L138.838 80.0947Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M129.776 68.8226L130.102 72.1382L120.593 68.8152L120.366 65.2338L129.776 68.8226Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M109.994 97.2595L104.451 97.4814L104.361 93.4673L109.795 93.5129L109.994 97.2595Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6816 117.333L50.8591 121.818L51.1723 124.254L48.999 119.782L48.6816 117.333Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M141.324 110.695L140.23 111.222L136.907 110.466L137.978 109.795L141.324 110.695Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9166 133.364L80.006 131.705L80.3995 134.918L77.1845 136.644L76.9166 133.364Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M138.597 111.509L135.705 110.942L136.394 110.758L139.228 111.402L138.597 111.509Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M143.067 109.433L141.85 110.417L138.333 109.471L139.504 108.298L143.067 109.433Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-262-inside-8_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.96 111.478L133.27 110.829L134.818 110.973L138.594 111.713L136.96 111.478Z"
  }))), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M136.96 111.478L136.89 111.872L136.903 111.874L136.96 111.478ZM133.27 110.829L133.307 110.431L133.201 111.223L133.27 110.829ZM134.818 110.973L134.895 110.581L134.876 110.577L134.855 110.575L134.818 110.973ZM138.594 111.713L138.537 112.109L138.671 111.32L138.594 111.713ZM137.029 111.084L133.34 110.436L133.201 111.223L136.89 111.872L137.029 111.084ZM133.233 111.228L134.781 111.371L134.855 110.575L133.307 110.431L133.233 111.228ZM134.742 111.366L138.517 112.105L138.671 111.32L134.895 110.581L134.742 111.366ZM138.651 111.317L137.016 111.082L136.903 111.874L138.537 112.109L138.651 111.317Z",
    fill: "white",
    mask: "url(#path-262-inside-8_1396_24002)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M144.629 107.701L143.414 109.123L139.768 107.962L140.931 106.315L144.629 107.701Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9868 102.847L89.5093 98.0037L91.0423 96.5467L90.6902 101.186L88.9868 102.847Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1675 99.2438L44.4066 102.406L43.4514 96.6135L44.2484 93.4544L45.1675 99.2438Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M128.817 106.873L124.333 106.513L123.536 104.571L127.933 105.043L128.817 106.873Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3128 49.0112L98.2596 51.3393L88.3779 49.2199L88.7854 46.7507L98.3128 49.0112Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M145.191 90.8965L144.757 94.0193L138.585 91.5006L138.982 88.0534L145.191 90.8965Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0217 75.395L46.9204 81.3993L44.0175 85.0163L44.1334 78.9225L47.0217 75.395Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4794 137.852L73.0121 138.029L73.3962 141.285L69.8694 141.101L69.4794 137.852Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3935 46.676L87.9846 49.1545L78.8025 47.9113L79.6002 45.292L88.3935 46.676Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M119.08 58.4048L119.511 61.0402L109.43 57.7058L109.218 54.8843L119.08 58.4048Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M135.544 111.025L133.331 110.636L133.168 110.558L135.329 110.923L135.544 111.025Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M116.009 97.4514L110.394 97.2617L110.196 93.5368L115.727 93.9946L116.009 97.4514Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M146.026 105.552L144.885 107.373L141.14 105.969L142.231 103.894L146.026 105.552Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M61.015 52.9266L59.9257 57.3984L54.0815 59.3026L55.4247 54.6623L61.015 52.9266Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7337 47.9843L68.6989 51.5709L61.5902 52.3939L62.9672 48.6424L69.7337 47.9843Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M122.182 101.278L116.894 100.945L116.46 97.8812L121.657 98.4324L122.182 101.278Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0782 93.4795L99.1139 88.7917L103.93 88.6896L103.956 93.081L99.0782 93.4795Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M94.7081 94.3787L94.8166 89.3929L98.7131 88.8295L98.6774 93.5367L94.7081 94.3787Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M138.617 76.3632L138.821 79.6524L130.709 76.3253L130.547 72.7455L138.617 76.3632Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9332 118.269L86.4851 114.459L87.044 116.84L85.2557 120.736L84.9332 118.269Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M108.509 52.1451L108.761 54.3166L98.6565 51.4333L98.7095 49.1207L108.509 52.1451Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M46.511 111.745L48.13 116.187L48.3748 118.075L46.7588 113.645L46.511 111.745Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M129.237 65.4485L129.71 68.365L120.332 64.7887L119.997 61.6448L129.237 65.4485Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8493 125.198L85.0797 121.908L85.9127 124.623L83.4418 128.025L82.8493 125.198Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8567 110.911L87.6767 107.293L87.744 108.563L86.8109 112.018L86.8567 110.911Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M134.705 110.412L131.875 109.935L131.047 109.187L133.838 109.678L134.705 110.412Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M109.783 93.1166L104.358 93.0711L104.332 88.7032L109.707 89.0544L109.783 93.1166Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M147.236 103.034L146.22 105.2L142.397 103.531L143.367 101.09L147.236 103.034Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1934 45.2516L78.3955 47.8716L70.3087 47.571L71.5112 44.8112L79.1934 45.2516Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5052 60.0226L52.5679 65.2155L48.1893 68.0452L49.2842 62.7043L53.5052 60.0226Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4916 95.7286L91.6814 90.4884L94.4139 89.5046L94.3055 94.4935L91.4916 95.7286Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M127.775 104.621L123.377 104.149L122.701 101.736L127.024 102.368L127.775 104.621Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M145.444 87.3111L145.23 90.4781L139.022 87.6357L139.223 84.1536L145.444 87.3111Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2409 104.097L88.7777 100.203L88.9119 99.7914L88.5305 103.327L88.2409 104.097Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4102 137.997L76.8362 137.212L77.2152 140.482L73.7948 141.257L73.4102 137.997Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M80.378 131.467L83.1979 128.901L83.6973 131.994L80.7644 134.623L80.378 131.467Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M133.453 109.202L130.516 108.686L129.602 107.393L132.495 107.966L133.453 109.202Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M148.239 100.213L147.386 102.66L143.502 100.708L144.317 97.9734L148.239 100.213Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M121.601 98.0264L116.412 97.4761L116.132 94.0453L121.26 94.8571L121.601 98.0264Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M115.706 93.5907L110.182 93.1334L110.106 89.0967L115.591 89.8605L115.706 93.5907Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3765 47.0714L98.3255 48.604L88.8694 46.3604L89.2998 44.7296L98.3765 47.0714Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4561 135.053L61.668 137.857L62.2278 140.48L59.0468 137.703L58.4561 135.053Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M138.169 72.8811L138.563 75.9023L130.519 72.2961L130.197 69.0163L138.169 72.8811Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M118.479 55.9381L118.975 57.9446L109.18 54.4481L108.931 52.3001L118.479 55.9381Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M55.042 131.131L57.9444 134.592L58.4932 137.054L55.6181 133.627L55.042 131.131Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6939 86.8361L44.0897 92.438L43.3549 95.3505L42.9445 89.7347L43.6939 86.8361Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5429 97.4197L89.8147 92.0521L91.2704 90.8004L91.0837 95.9555L89.5429 97.4197Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9091 44.6437L88.477 46.2806L79.7594 44.9084L80.613 43.1713L88.9091 44.6437Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9832 106.569L45.8801 110.015L45.9506 110.556L45.0549 107.117L44.9832 106.569Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1175 88.3952L99.1453 83.4447L103.972 83.6675L103.932 88.2931L99.1175 88.3952Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1391 138.152L65.5554 140.16L66.1077 142.888L62.7249 140.897L62.1391 138.152Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M128.536 62.5537L129.13 64.9727L119.943 61.1911L119.517 58.5873L128.536 62.5537Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8225 88.9901L94.839 83.7101L98.7453 83.4502L98.7173 88.427L94.8225 88.9901Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M126.917 101.951L122.596 101.318L122.076 98.504L126.339 99.3426L126.917 101.951Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M108.168 50.288L108.436 51.7071L98.7227 48.7091L98.7732 47.1915L108.168 50.288Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M145.442 83.7506L145.451 86.8656L139.239 83.7132L139.238 80.3001L145.442 83.7506Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6295 69.1122L47.0401 74.7435L44.2129 78.1966L44.8736 72.4613L47.6295 69.1122Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9929 126.546L54.4713 130.442L54.9758 132.628L52.5195 128.768L51.9929 126.546Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M132.229 107.508L129.286 106.925L128.427 105.148L131.328 105.832L132.229 107.508Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M109.705 88.652L104.331 88.3009L104.371 83.7027L109.756 84.3897L109.705 88.652Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M149.01 97.1632L148.352 99.8169L144.423 97.573L145.054 94.6251L149.01 97.1632Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0658 44.8252L69.8709 47.5673L63.1816 48.2179L64.7748 45.3389L71.0658 44.8252Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4983 48.7632L61.1378 52.4694L55.6187 54.183L57.2972 50.3243L62.4983 48.7632Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M140.214 111.638L141.392 112.363L140.362 112.461L139.191 111.812L140.214 111.638Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M142.026 112.286L140.67 111.452L141.877 110.87L143.248 111.825L142.026 112.286Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9994 140.326L69.5173 141.448L70.0506 144.247L66.5675 143.132L65.9994 140.326Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M138.53 111.906L139.135 112.241L138.724 112.163L138.108 111.845L138.53 111.906Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6874 90.0614L91.6946 84.4935L94.4378 83.7785L94.4213 89.0771L91.6874 90.0614Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M143.676 111.638L142.229 110.629L143.482 109.616L144.945 110.783L143.676 111.638Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7427 113.804L87.9634 109.283L88.6868 111.492L87.2799 116.092L86.7427 113.804Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2238 137.076L80.4487 135.344L80.8196 138.602L77.5998 140.32L77.2238 137.076Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3615 121.464L87.2416 117.368L88.2583 119.924L86.1766 124.121L85.3615 121.464Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1877 43.1224L79.337 44.8536L71.7533 44.4187L73.044 42.5849L80.1877 43.1224Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M121.232 94.4492L116.107 93.6377L115.993 89.9365L121.091 91.0464L121.232 94.4492Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-338-inside-9_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.062 111.573L135.391 110.731L136.96 111.477L138.657 112.353L137.062 111.573Z"
  }))), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M137.062 111.573L136.882 111.93L136.887 111.932L137.062 111.573ZM135.391 110.731L135.563 110.37L135.211 111.088L135.391 110.731ZM136.96 111.477L137.143 111.122L137.132 111.116L136.96 111.477ZM138.657 112.353L138.482 112.712L138.841 111.998L138.657 112.353ZM137.242 111.216L135.571 110.374L135.211 111.088L136.882 111.93L137.242 111.216ZM135.219 111.092L136.788 111.839L137.132 111.116L135.563 110.37L135.219 111.092ZM136.776 111.833L138.474 112.709L138.841 111.998L137.143 111.122L136.776 111.833ZM138.833 111.994L137.238 111.214L136.887 111.932L138.482 112.712L138.833 111.994Z",
    fill: "white",
    mask: "url(#path-338-inside-9_1396_24002)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4308 121.587L51.3355 125.506L51.7207 127.132L49.8307 123.245L49.4308 121.587Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9996 105.851L88.5752 101.676L88.7085 102.714L88.0464 106.733L87.9996 105.851Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M137.508 69.7379L138.072 72.3901L130.143 68.5464L129.677 65.6725L137.508 69.7379Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M115.589 89.4592L110.103 88.6953L110.154 84.4612L115.649 85.562L115.589 89.4592Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M145.268 110.526L143.767 109.328L144.985 107.903L146.503 109.289L145.268 110.526Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M131.141 105.376L128.219 104.687L127.486 102.489L130.369 103.321L131.141 105.376Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M117.79 54.1505L118.297 55.4405L108.87 51.8488L108.607 50.4567L117.79 54.1505Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9235 54.9527L53.6132 59.4793L49.4705 62.1113L51.0008 57.4395L54.9235 54.9527Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M149.531 93.965L149.089 96.7433L145.134 94.2061L145.561 91.1347L149.531 93.965Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M126.273 98.9203L122.011 98.0818L121.673 94.9472L125.896 96.032L126.273 98.9203Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4361 45.9823L98.3955 46.6614L89.4499 44.3533L89.8384 43.6088L98.4361 45.9823Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M145.185 80.3108L145.413 83.275L139.231 79.8363L139.031 76.5977L145.185 80.3108Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8853 98.5888L89.1804 94.0169L89.3407 93.507L89.1198 97.8694L88.8853 98.5888Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M135.556 110.59L135.503 110.563L135.414 110.488L135.464 110.514L135.556 110.59Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M127.689 60.2111L128.358 62.0373L119.431 58.1115L118.943 56.1428L127.689 60.2111Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5493 128.555L86.0258 125.146L86.6104 128.105L84.0362 131.571L83.5493 128.555Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M103.977 83.2663L99.146 83.0433L99.1649 77.9731L104.083 78.5407L103.977 83.2663Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M147.903 107.397L146.761 108.981L145.225 107.579L146.352 105.781L147.903 107.397Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9356 141.506L73.4539 141.689L73.9605 144.535L70.4771 144.348L69.9356 141.506Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M107.795 49.2256L108.011 49.8154L98.79 46.7761L98.8297 46.1104L107.795 49.2256Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask10 || (_mask10 = /*#__PURE__*/React.createElement("mask", {
    id: "path-360-inside-10_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3706 103.409L44.8603 107.151L43.7415 100.37L43.2479 96.6006L44.3706 103.409Z"
  }))), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3706 103.409L44.7674 103.357L44.7652 103.343L44.3706 103.409ZM44.8603 107.151L44.4656 107.216L45.2569 107.099L44.8603 107.151ZM43.7415 100.37L43.3447 100.422L43.3469 100.435L43.7415 100.37ZM43.2479 96.6006L43.6426 96.5355L42.8513 96.6525L43.2479 96.6006ZM43.9739 103.46L44.4637 107.203L45.2569 107.099L44.7672 103.357L43.9739 103.46ZM45.255 107.086L44.1362 100.305L43.3469 100.435L44.4656 107.216L45.255 107.086ZM44.1382 100.318L43.6445 96.5486L42.8513 96.6525L43.3449 100.422L44.1382 100.318ZM42.8533 96.6657L43.9759 103.474L44.7652 103.343L43.6426 96.5355L42.8533 96.6657Z",
    fill: "white",
    mask: "url(#path-360-inside-10_1396_24002)"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M109.768 83.9878L104.377 83.3001L104.482 78.6039L109.947 79.6487L109.768 83.9878Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8347 83.3094L94.757 77.8876L98.7642 77.9477L98.7453 83.0492L94.8347 83.3094Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4348 43.5156L89.0468 44.2591L80.9074 42.8145L81.7013 42.0079L89.4348 43.5156Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8192 91.5174L89.8204 85.7735L91.294 84.7277L91.2868 90.2556L89.8192 91.5174Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7031 80.546L43.6074 85.5743L42.9768 88.0136L43.0782 82.9577L43.7031 80.546Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M134.804 109.718L134.057 109.33L133.37 108.443L134.098 108.854L134.804 109.718Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6083 117.138L48.6132 119.892L48.6222 119.929L47.6186 117.18L47.6083 117.138Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M130.242 102.87L127.345 102.034L126.78 99.4831L129.645 100.503L130.242 102.87Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M148.114 107.045L146.557 105.422L147.548 103.31L149.118 105.162L148.114 107.045Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M121.089 90.6346L115.989 89.524L116.048 85.6575L121.155 87.0959L121.089 90.6346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M149.791 90.684L149.577 93.4997L145.616 90.6766L145.827 87.577L149.791 90.684Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M136.651 67.0156L137.346 69.2003L129.589 65.1727L129.008 62.8063L136.651 67.0156Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M115.668 85.1547L110.166 84.0525L110.343 79.7427L115.903 81.2031L115.668 85.1547Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6862 84.0846L91.5067 78.3508L94.3576 77.9159L94.4357 83.368L91.6862 84.0846Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M125.861 95.6117L121.636 94.526L121.496 91.1608L125.702 92.5271L125.861 95.6117Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M117.039 53.0984L117.369 53.5477L108.5 49.9803L108.297 49.4277L117.039 53.0984Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7442 63.3411L47.7103 68.3837L45.0593 71.6054L46.2164 66.449L48.7442 63.3411Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M144.68 77.0869L145.113 79.8005L138.995 76.1095L138.609 73.1513L144.68 77.0869Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5421 42.6057L71.2749 44.4061L65.1349 44.9075L66.8295 43.0038L72.5421 42.6057Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M133.693 108.169L132.755 107.641L132.001 106.239L132.916 106.823L133.693 108.169Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M80.824 135.112L83.758 132.482L84.1181 135.699L81.1884 138.312L80.824 135.112Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M126.719 58.4956L127.362 59.6227L118.804 55.6417L118.317 54.4026L126.719 58.4956Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1946 41.9558L80.4207 42.7423L73.5141 42.2226L74.7127 41.3715L81.1946 41.9558Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M104.096 78.1394L99.1673 77.5706L99.1767 72.5286L104.265 73.4526L104.096 78.1394Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask11 || (_mask11 = /*#__PURE__*/React.createElement("mask", {
    id: "path-386-inside-11_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.6463 45.8348L89.7368 43.3753L90.3475 43.2131L98.7093 45.642L98.6463 45.8348Z"
  }))), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6463 45.8348L98.5398 46.2204L98.9079 46.322L99.0265 45.959L98.6463 45.8348ZM89.7368 43.3753L89.6342 42.9887L88.2064 43.3678L89.6304 43.7609L89.7368 43.3753ZM90.3475 43.2131L90.4591 42.829L90.3523 42.798L90.2448 42.8265L90.3475 43.2131ZM98.7093 45.642L99.0895 45.7663L99.2179 45.3732L98.8208 45.2579L98.7093 45.642ZM98.7527 45.4492L89.8433 42.9897L89.6304 43.7609L98.5398 46.2204L98.7527 45.4492ZM89.8395 43.7619L90.4501 43.5997L90.2448 42.8265L89.6342 42.9887L89.8395 43.7619ZM90.2359 43.5973L98.5977 46.0262L98.8208 45.2579L90.4591 42.829L90.2359 43.5973ZM98.329 45.5178L98.2661 45.7106L99.0265 45.959L99.0895 45.7663L98.329 45.5178Z",
    fill: "white",
    mask: "url(#path-386-inside-11_1396_24002)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2419 45.4806L62.6886 48.2878L57.6177 49.8098L59.5348 46.8732L64.2419 45.4806Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M150.125 102.631L149.295 104.749L147.727 102.898L148.548 100.54L150.125 102.631Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8536 141.651L77.2728 140.876L77.7475 143.748L74.3622 144.508L73.8536 141.651Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask12 || (_mask12 = /*#__PURE__*/React.createElement("mask", {
    id: "path-391-inside-12_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.949 49.0645L98.6453 45.8314L98.7082 45.6387L107.527 48.8257L107.949 49.0645Z"
  }))), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M107.949 49.0645L107.818 49.4423L108.146 48.7164L107.949 49.0645ZM98.6453 45.8314L98.265 45.7072L98.1431 46.0804L98.514 46.2093L98.6453 45.8314ZM98.7082 45.6387L98.8442 45.2625L98.4562 45.1223L98.328 45.5144L98.7082 45.6387ZM107.527 48.8257L107.724 48.4775L107.695 48.4609L107.663 48.4495L107.527 48.8257ZM108.081 48.6866L98.7766 45.4536L98.514 46.2093L107.818 49.4423L108.081 48.6866ZM99.0255 45.9557L99.0885 45.7629L98.328 45.5144L98.265 45.7072L99.0255 45.9557ZM98.5723 46.0149L107.391 49.2018L107.663 48.4495L98.8442 45.2625L98.5723 46.0149ZM107.33 49.1738L107.752 49.4126L108.146 48.7164L107.724 48.4775L107.33 49.1738Z",
    fill: "white",
    mask: "url(#path-391-inside-12_1396_24002)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M109.969 79.249L104.493 78.2019L104.662 73.5445L110.272 74.9601L109.969 79.249Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7654 77.5474L94.748 77.4871L94.5775 72.0836L98.7751 72.4729L98.7654 77.5474Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1499 108.569L88.9925 103.454L89.8172 105.494L88.8434 110.687L88.1499 108.569Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M129.565 100.048L126.689 99.0238L126.319 96.1972L129.174 97.4401L129.565 100.048Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4679 116.853L88.9392 112.043L90.0916 114.454L88.4617 119.352L87.4679 116.853Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7844 100.152L89.0757 95.6391L89.2038 96.3567L88.8628 100.762L88.7844 100.152Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask13 || (_mask13 = /*#__PURE__*/React.createElement("mask", {
    id: "path-399-inside-13_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7354 43.3709L81.6335 41.7913L82.8356 41.6396L90.3461 43.2088L89.7354 43.3709Z"
  }))), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7354 43.3709L89.6589 43.7635L89.7492 43.7811L89.8381 43.7575L89.7354 43.3709ZM81.6335 41.7913L81.5835 41.3945L81.557 42.1839L81.6335 41.7913ZM82.8356 41.6396L82.9174 41.2481L82.8519 41.2344L82.7855 41.2428L82.8356 41.6396ZM90.3461 43.2088L90.4487 43.5954L90.4279 42.8172L90.3461 43.2088ZM89.812 42.9783L81.7101 41.3987L81.557 42.1839L89.6589 43.7635L89.812 42.9783ZM81.6836 42.1882L82.8857 42.0365L82.7855 41.2428L81.5835 41.3945L81.6836 42.1882ZM82.7538 42.0312L90.2643 43.6003L90.4279 42.8172L82.9174 41.2481L82.7538 42.0312ZM90.2434 42.8222L89.6328 42.9843L89.8381 43.7575L90.4487 43.5954L90.2434 42.8222Z",
    fill: "white",
    mask: "url(#path-399-inside-13_1396_24002)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2315 138.395L62.3714 141.136L62.8866 143.202L59.7996 140.507L59.2315 138.395Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M149.781 87.4209L149.797 90.1793L145.853 87.0884L145.844 84.0616L149.781 87.4209Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8822 134.565L58.6847 137.905L59.1931 139.795L56.4352 136.509L55.8822 134.565Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M121.178 86.6864L116.062 85.2455L116.296 81.3253L121.452 83.1146L121.178 86.6864Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1806 92.6757L89.1797 87.4939L89.4192 86.8235L89.4181 91.9203L89.1806 92.6757Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M132.644 106.172L131.625 105.523L130.947 103.719L131.945 104.456L132.644 106.172Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M141.373 113.546L140.148 113.586L140.457 112.851L141.697 112.734L141.373 113.546Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M135.619 64.7972L136.375 66.4074L128.868 62.2725L128.224 60.5166L135.619 64.7972Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask14 || (_mask14 = /*#__PURE__*/React.createElement("mask", {
    id: "path-409-inside-14_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5613 113.693L47.4248 117.241L45.7418 110.779L44.8578 107.152L46.5613 113.693Z"
  }))), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5613 113.693L46.95 113.598L46.9484 113.592L46.5613 113.693ZM47.4248 117.241L47.0377 117.341L47.8135 117.146L47.4248 117.241ZM45.7418 110.779L45.3531 110.873L45.3547 110.879L45.7418 110.779ZM44.8578 107.152L45.2449 107.051L44.4692 107.246L44.8578 107.152ZM46.1726 113.787L47.0361 117.335L47.8135 117.146L46.9499 113.598L46.1726 113.787ZM47.8119 117.14L46.1289 110.678L45.3547 110.879L47.0377 117.341L47.8119 117.14ZM46.1304 110.684L45.2464 107.057L44.4692 107.246L45.3532 110.873L46.1304 110.684ZM44.4707 107.252L46.1742 113.794L46.9484 113.592L45.2449 107.051L44.4707 107.252Z",
    fill: "white",
    mask: "url(#path-409-inside-14_1396_24002)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M115.937 80.7968L110.365 79.3329L110.665 75.0725L116.342 76.9062L115.937 80.7968Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M139.724 113.565L138.478 113.275L138.778 112.578L140.039 112.816L139.724 113.565Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7043 50.6849L55.1025 54.3671L51.3235 56.7629L53.1939 52.9462L56.7043 50.6849Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask15 || (_mask15 = /*#__PURE__*/React.createElement("mask", {
    id: "path-414-inside-15_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.2461 96.6005L43.7397 100.37L43.2395 93.5133L42.743 89.7162L43.2461 96.6005Z"
  }))), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2461 96.6005L42.8472 96.6296L42.848 96.641L42.8495 96.6524L43.2461 96.6005ZM43.7397 100.37L43.3431 100.422L44.1386 100.341L43.7397 100.37ZM43.2395 93.5133L43.6384 93.4842L43.6376 93.4728L43.6361 93.4614L43.2395 93.5133ZM42.743 89.7162L43.1396 89.6643L42.344 89.7453L42.743 89.7162ZM42.8495 96.6524L43.3431 100.422L44.1363 100.318L43.6427 96.5485L42.8495 96.6524ZM44.1386 100.341L43.6384 93.4842L42.8405 93.5424L43.3408 100.399L44.1386 100.341ZM43.6361 93.4614L43.1396 89.6643L42.3464 89.768L42.8429 93.5651L43.6361 93.4614ZM42.344 89.7453L42.8472 96.6296L43.645 96.5713L43.1419 89.687L42.344 89.7453Z",
    fill: "white",
    mask: "url(#path-414-inside-15_1396_24002)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8592 141.439L66.2187 143.416L66.7089 145.584L63.408 143.64L62.8592 141.439Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask16 || (_mask16 = /*#__PURE__*/React.createElement("mask", {
    id: "path-417-inside-16_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.166 52.9366L107.949 49.0666L107.527 48.8279L116.335 52.6418L117.166 52.9366Z"
  }))), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M117.166 52.9366L117.032 53.3136L117.321 52.5678L117.166 52.9366ZM107.949 49.0666L107.752 49.4147L107.772 49.4263L107.794 49.4354L107.949 49.0666ZM107.527 48.8279L107.686 48.4608L107.33 49.1761L107.527 48.8279ZM116.335 52.6418L116.176 53.0089L116.188 53.0143L116.201 53.0188L116.335 52.6418ZM117.321 52.5678L108.104 48.6978L107.794 49.4354L117.011 53.3054L117.321 52.5678ZM108.146 48.7184L107.724 48.4797L107.33 49.1761L107.752 49.4147L108.146 48.7184ZM107.368 49.1949L116.176 53.0089L116.494 52.2748L107.686 48.4608L107.368 49.1949ZM116.201 53.0188L117.032 53.3136L117.299 52.5596L116.468 52.2648L116.201 53.0188Z",
    fill: "white",
    mask: "url(#path-417-inside-16_1396_24002)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M143.006 113.092L141.849 113.436L142.157 112.663L143.332 112.221L143.006 113.092Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8039 85.2949L89.5249 79.3413L91.1124 78.5046L91.292 84.2388L89.8039 85.2949Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3418 124.689L88.4071 120.526L89.0528 123.342L86.9072 127.551L86.3418 124.689Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M125.7 92.108L121.487 90.7392L121.552 87.2399L125.768 88.9164L125.7 92.108Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M150.897 99.8788L150.267 102.157L148.699 100.079L149.324 97.5576L150.897 99.8788Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M143.933 74.1551L144.54 76.5163L138.532 72.6208L137.985 70.0489L143.933 74.1551Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M138.101 113.141L136.879 112.515L137.164 111.844L138.399 112.448L138.101 113.141Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9274 130.155L55.2482 133.801L55.6861 135.341L53.3978 131.746L52.9274 130.155Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M125.659 57.4457L125.831 57.614L118.075 53.8351L117.82 53.4883L125.659 57.4457Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M144.586 112.207L143.542 112.806L143.84 112.008L144.9 111.294L144.586 112.207Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M104.283 73.0496L99.177 72.1224L99.1765 67.2586L104.51 68.5412L104.283 73.0496Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4862 77.9504L91.1226 72.2222L94.1764 72.0738L94.3481 77.5138L91.4862 77.9504Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5451 46.0731L91.0912 43.8362L90.8875 43.576L98.5217 45.7936L98.5451 46.0731Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9342 45.9377L107.209 48.9278L107.015 49.1921L98.957 46.2093L98.9342 45.9377Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M110.306 74.5548L104.678 73.1345L104.904 68.6535L110.723 70.4428L110.306 74.5548Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M136.544 112.285L135.391 111.333L135.658 110.674L136.821 111.633L136.544 112.285Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M44.1409 75.3256L43.7388 78.8155L43.4307 80.0047L43.8562 76.4478L44.1409 75.3256Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6671 143.587L70.1371 144.698L70.5844 146.932L67.1761 145.838L66.6671 143.587Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M98.776 72.0711L94.5622 71.6802L94.3036 66.4565L98.7755 67.1762L98.776 72.0711Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M146.065 110.913L145.185 111.689L145.456 110.901L146.353 110.004L146.065 110.913Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M129.137 96.99L126.27 95.7416L126.115 92.722L128.97 94.22L129.137 96.99Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M131.763 103.826L130.699 103.041L130.163 100.917L131.211 101.824L131.763 103.826Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 84.2607L149.737 86.8626L145.836 83.534L145.617 80.6858L149.5 84.2607Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask17 || (_mask17 = /*#__PURE__*/React.createElement("mask", {
    id: "path-442-inside-17_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6357 41.7953L74.659 41.1664L76.4723 41.001L82.8378 41.6437L81.6357 41.7953Z"
  }))), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6357 41.7953L81.5998 42.1937L81.6429 42.1976L81.6858 42.1922L81.6357 41.7953ZM74.659 41.1664L74.6227 40.768L74.6231 41.5647L74.659 41.1664ZM76.4723 41.001L76.5124 40.603L76.4742 40.5991L76.4359 40.6026L76.4723 41.001ZM82.8378 41.6437L82.8878 42.0405L82.878 41.2457L82.8378 41.6437ZM81.6716 41.3969L74.6949 40.768L74.6231 41.5647L81.5998 42.1937L81.6716 41.3969ZM74.6953 41.5647L76.5086 41.3993L76.4359 40.6026L74.6227 40.768L74.6953 41.5647ZM76.4321 41.399L82.7976 42.0416L82.878 41.2457L76.5124 40.603L76.4321 41.399ZM82.7877 41.2468L81.5856 41.3985L81.6858 42.1922L82.8878 42.0405L82.7877 41.2468Z",
    fill: "white",
    mask: "url(#path-442-inside-17_1396_24002)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6544 140.744L80.8776 139.024L81.3175 141.904L78.1258 143.596L77.6544 140.744Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M135.089 111.008L134.046 109.761L134.295 109.096L135.344 110.38L135.089 111.008Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9687 41.4084L72.8762 42.1842L67.5963 42.5522L69.0702 41.7146L73.9687 41.4084Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M121.498 82.7079L116.327 80.9136L116.728 77.0531L121.974 79.2067L121.498 82.7079Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M107.396 49.3465L107.595 49.0746L115.886 52.6644L115.464 52.9004L107.396 49.3465Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M116.395 76.5067L110.698 74.6668L111.112 70.5809L116.957 72.7911L116.395 76.5067Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M151.417 96.9685L151.004 99.3209L149.449 97.0264L149.862 94.4355L151.417 96.9685Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5574 125.651L52.146 128.918L52.3389 129.571L50.7627 126.33L50.5574 125.651Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4721 43.6986L84.1535 42.3209L83.7516 42.0401L90.234 43.3945L90.4721 43.6986Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M134.443 63.1446L135.071 64.0197L127.995 59.9237L127.417 58.9109L134.443 63.1446Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1214 132.128L86.6801 128.682L87.0264 131.825L84.4711 135.251L84.1214 132.128Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M104.535 68.1345L99.1764 66.846L99.1663 62.3062L104.814 63.9394L104.535 68.1345Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M147.41 109.25L146.752 110.069L146.973 109.374L147.646 108.439L147.41 109.25Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M125.798 88.4967L121.569 86.8152L121.84 83.2825L126.094 85.2908L125.798 88.4967Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask18 || (_mask18 = /*#__PURE__*/React.createElement("mask", {
    id: "path-458-inside-18_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.779 57.284L117.168 52.9365L116.337 52.6417L124.623 56.9281L125.779 57.284Z"
  }))), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M125.779 57.284L125.661 57.6663L125.959 56.9269L125.779 57.284ZM117.168 52.9365L117.348 52.5795L117.325 52.568L117.302 52.5596L117.168 52.9365ZM116.337 52.6417L116.471 52.2647L116.153 52.997L116.337 52.6417ZM124.623 56.9281L124.439 57.2833L124.471 57.2998L124.505 57.3104L124.623 56.9281ZM125.959 56.9269L117.348 52.5795L116.987 53.2936L125.599 57.641L125.959 56.9269ZM117.302 52.5596L116.471 52.2647L116.203 53.0187L117.034 53.3135L117.302 52.5596ZM116.153 52.997L124.439 57.2833L124.807 56.5728L116.521 52.2864L116.153 52.997ZM124.505 57.3104L125.661 57.6663L125.897 56.9017L124.74 56.5458L124.505 57.3104Z",
    fill: "white",
    mask: "url(#path-458-inside-18_1396_24002)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M142.971 71.6077L143.693 73.5048L137.855 69.4748L137.194 67.4002L142.971 71.6077Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M106.513 50.5992L99.0198 47.8078L98.9799 46.6426L106.841 49.5524L106.513 50.5992Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2903 58.3224L48.9263 62.4861L46.612 65.3315L48.1395 61.0496L50.2903 58.3224Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M110.772 70.0391L104.927 68.2419L105.205 64.0709L111.29 66.2263L110.772 70.0391Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6128 47.6766L91.7483 45.594L91.2927 44.3179L98.5725 46.5026L98.6128 47.6766Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1165 43.2066L64.5426 44.9746L60.1398 46.2772L62.0793 44.4149L66.1165 43.2066Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M133.778 109.341L132.884 107.846L133.114 107.163L134.01 108.719L133.778 109.341Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1605 71.6717L91.0911 71.8208L90.5531 66.2723L93.9001 66.4108L94.1605 71.6717Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7753 66.7726L94.2806 66.0492L93.9419 61.1638L98.7652 62.2054L98.7753 66.7726Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M70.557 144.753L74.0322 144.94L74.4258 147.22L71.0132 147.032L70.557 144.753Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4911 78.9077L88.9333 72.9272L90.7296 72.3051L91.0951 78.0624L89.4911 78.9077Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M131.099 101.198L130.001 100.247L129.645 97.8822L130.732 98.9865L131.099 101.198Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask19 || (_mask19 = /*#__PURE__*/React.createElement("mask", {
    id: "path-472-inside-19_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8603 107.152L45.7443 110.779L44.6403 104.081L43.7415 100.37L44.8603 107.152Z"
  }))), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8603 107.152L44.4656 107.217L44.4681 107.232L44.4716 107.247L44.8603 107.152ZM45.7443 110.779L45.3556 110.874L46.1389 110.714L45.7443 110.779ZM44.6403 104.081L45.035 104.016L45.0326 104.002L45.0291 103.987L44.6403 104.081ZM43.7415 100.37L44.1303 100.276L43.3469 100.435L43.7415 100.37ZM44.4716 107.247L45.3556 110.874L46.1329 110.684L45.2489 107.057L44.4716 107.247ZM46.1389 110.714L45.035 104.016L44.2457 104.146L45.3496 110.844L46.1389 110.714ZM45.0291 103.987L44.1303 100.276L43.3528 100.464L44.2516 104.175L45.0291 103.987ZM43.3469 100.435L44.4656 107.217L45.2549 107.087L44.1362 100.305L43.3469 100.435Z",
    fill: "white",
    mask: "url(#path-472-inside-19_1396_24002)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M107.21 49.7009L115.169 53.2072L114.532 54.1217L106.883 50.7464L107.21 49.7009Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1222 86.472L88.7791 80.8152L89.1567 80.0259L89.4197 85.6387L89.1222 86.472Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M128.97 93.7694L126.099 92.2632L126.165 89.1379L129.036 90.9184L128.97 93.7694Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M104.843 63.5342L99.1628 61.8915L99.1433 57.8138L105.164 59.779L104.843 63.5342Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M148.583 107.257L148.231 107.857L148.348 107.457L148.713 106.771L148.583 107.257Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1808 93.9659L89.1801 89.5398L89.2041 89.663L89.2037 94.0942L89.1808 93.9659Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M117.028 72.3891L111.157 70.169L111.672 66.3789L117.73 68.9586L117.028 72.3891Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M106.048 52.8119L99.0697 50.2508L99.03 48.2372L106.411 50.9869L106.048 52.8119Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1137 102.688L89.5436 97.1341L90.3983 98.9947L89.8984 104.63L89.1137 102.688Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M111.354 65.8239L105.235 63.6564L105.554 59.9211L111.955 62.4242L111.354 65.8239Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M148.954 81.274L149.386 83.6107L145.564 80.0923L145.155 77.5352L148.954 81.274Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M151.668 93.9794L151.477 96.304L149.953 93.8217L150.148 91.2703L151.668 93.9794Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M122.043 78.8038L116.777 76.6419L117.335 72.9541L122.706 75.4756L122.043 78.8038Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1053 111.462L90.1179 106.063L91.3531 108.338L90.2291 113.814L89.1053 111.462Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask20 || (_mask20 = /*#__PURE__*/React.createElement("mask", {
    id: "path-488-inside-20_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.582 62.9927L126.863 58.342L125.778 57.2849L133.27 61.9362L134.582 62.9927Z"
  }))), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M134.582 62.9927L134.375 63.3354L134.833 62.6812L134.582 62.9927ZM126.863 58.342L126.584 58.6284L126.617 58.6607L126.657 58.6846L126.863 58.342ZM125.778 57.2849L125.989 56.9451L125.499 57.5714L125.778 57.2849ZM133.27 61.9362L133.521 61.6247L133.502 61.6093L133.481 61.5964L133.27 61.9362ZM134.788 62.6501L127.07 57.9993L126.657 58.6846L134.375 63.3354L134.788 62.6501ZM127.142 58.0555L126.058 56.9985L125.499 57.5714L126.584 58.6284L127.142 58.0555ZM125.567 57.6247L133.059 62.276L133.481 61.5964L125.989 56.9451L125.567 57.6247ZM133.019 62.2478L134.331 63.3043L134.833 62.6812L133.521 61.6247L133.019 62.2478Z",
    fill: "white",
    mask: "url(#path-488-inside-20_1396_24002)"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M115.895 53.1169L116.341 52.8677L124.091 56.8771L123.447 57.0696L115.895 53.1169Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6656 50.1232L92.3662 48.2422L91.866 46.0472L98.6258 48.0981L98.6656 50.1232Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2856 45.4786L85.4307 44.1872L84.5127 42.8045L90.8219 44.1801L91.2856 45.4786Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M105.205 59.3712L99.1406 57.3919L99.1127 53.9008L105.556 56.1691L105.205 59.3712Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0257 85.6019L43.1773 86.7658L43.0938 90.8567L42.9434 89.7062L43.0257 85.6019Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M105.611 55.7622L99.1107 53.4739L99.0758 50.6777L105.977 53.2106L105.611 55.7622Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask21 || (_mask21 = /*#__PURE__*/React.createElement("mask", {
    id: "path-496-inside-21_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.6421 123.312L50.5766 126.406L48.4054 120.459L47.4261 117.241L49.6421 123.312Z"
  }))), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6421 123.312L50.0251 123.196L50.0218 123.185L50.0179 123.175L49.6421 123.312ZM50.5766 126.406L50.2009 126.543L50.9595 126.29L50.5766 126.406ZM48.4054 120.459L48.0228 120.576L48.0259 120.586L48.0297 120.596L48.4054 120.459ZM47.4261 117.241L47.8018 117.104L47.0434 117.357L47.4261 117.241ZM49.2592 123.427L50.1937 126.522L50.9595 126.29L50.0251 123.196L49.2592 123.427ZM50.9524 126.269L48.7812 120.322L48.0297 120.596L50.2009 126.543L50.9524 126.269ZM48.7881 120.343L47.8088 117.125L47.0434 117.357L48.0228 120.576L48.7881 120.343ZM47.0503 117.378L49.2664 123.449L50.0179 123.175L47.8018 117.104L47.0503 117.378Z",
    fill: "white",
    mask: "url(#path-496-inside-21_1396_24002)"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M132.643 107.307L131.929 105.636L132.139 104.932L132.852 106.685L132.643 107.307Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M113.645 56.0927L106.425 52.9595L106.787 51.1413L114.342 54.4747L113.645 56.0927Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7643 61.7933L93.9102 60.745L93.503 56.3466L98.7446 57.6921L98.7643 61.7933Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M112.038 62.0285L105.593 59.5083L105.942 56.3218L112.701 59.1438L112.038 62.0285Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M126.151 84.8758L121.88 82.8594L122.351 79.3956L126.667 81.7488L126.151 84.8758Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7029 47.4134L57.0053 50.0135L53.8333 52.0567L55.8123 49.3479L58.7029 47.4134Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M83.321 42.2251L78.3932 41.7025L77.5841 41.3134L82.7646 41.8364L83.321 42.2251Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M141.815 69.5074L142.524 70.7885L136.978 66.7488L136.303 65.3094L141.815 69.5074Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M112.809 58.7534L105.994 55.9081L106.359 53.3676L113.507 56.4695L112.809 58.7534Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6832 119.942L90.2791 115.147L90.9589 117.806L89.3012 122.637L88.6832 119.942Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7071 53.3508L92.9391 51.7143L92.445 48.6802L98.672 50.5397L98.7071 53.3508Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7415 57.28L93.4594 55.9241L92.9989 52.1487L98.7134 53.77L98.7415 57.28Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M117.825 68.5644L111.734 65.9704L112.332 62.5894L118.643 65.5207L117.825 68.5644Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8779 66.0085L90.51 65.8692L89.8144 60.6707L93.5367 61.0884L93.8779 66.0085Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask22 || (_mask22 = /*#__PURE__*/React.createElement("mask", {
    id: "path-512-inside-22_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.77 107.334L149.359 105.135L150.352 102.601L149.746 105.045L148.77 107.334Z"
  }))), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M148.77 107.334L148.383 107.23L149.137 107.491L148.77 107.334ZM149.359 105.135L148.986 104.989L148.978 105.009L148.972 105.031L149.359 105.135ZM150.352 102.601L150.74 102.697L149.979 102.455L150.352 102.601ZM149.746 105.045L150.114 105.202L150.127 105.173L150.134 105.142L149.746 105.045ZM149.156 107.437L149.745 105.238L148.972 105.031L148.383 107.23L149.156 107.437ZM149.731 105.281L150.724 102.747L149.979 102.455L148.986 104.989L149.731 105.281ZM149.963 102.505L149.358 104.949L150.134 105.142L150.74 102.697L149.963 102.505ZM149.378 104.888L148.402 107.177L149.137 107.491L150.114 105.202L149.378 104.888Z",
    fill: "white",
    mask: "url(#path-512-inside-22_1396_24002)"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M114.897 54.3019L115.537 53.3838L123.075 57.3291L122.191 58.1097L114.897 54.3019Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M130.681 98.3621L129.549 97.2123L129.396 94.6808L130.521 96.0138L130.681 98.3621Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M137.161 114.877L136.158 114.6L138.222 113.628L139.247 113.866L137.161 114.877Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask23 || (_mask23 = /*#__PURE__*/React.createElement("mask", {
    id: "path-517-inside-23_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.6577 41.1661L69.0123 41.519L71.4289 41.3126L76.471 41.0007L74.6577 41.1661Z"
  }))), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6577 41.1661L74.6826 41.5655L74.694 41.5645L74.6577 41.1661ZM69.0123 41.519L68.9783 41.1204L69.0373 41.9182L69.0123 41.519ZM71.4289 41.3126L71.4042 40.9133L71.3949 40.9141L71.4289 41.3126ZM76.471 41.0007L76.5073 41.3991L76.4463 40.6015L76.471 41.0007ZM74.6327 40.7669L68.9874 41.1197L69.0373 41.9182L74.6826 41.5653L74.6327 40.7669ZM69.0464 41.9175L71.4629 41.7112L71.3949 40.9141L68.9783 41.1204L69.0464 41.9175ZM71.4536 41.7119L76.4957 41.4L76.4463 40.6015L71.4042 40.9134L71.4536 41.7119ZM76.4346 40.6024L74.6213 40.7678L74.694 41.5645L76.5073 41.3991L76.4346 40.6024Z",
    fill: "white",
    mask: "url(#path-517-inside-23_1396_24002)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M138.752 114.922L138.015 114.906L139.893 113.997L140.619 113.973L138.752 114.922Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2489 138.791L84.1837 136.173L84.5875 139.039L81.6809 141.619L81.2489 138.791Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M135.591 114.423L134.495 113.825L136.618 112.83L137.746 113.409L135.591 114.423Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M122.802 75.0771L117.405 72.5433L118.102 69.1369L123.632 72.0197L122.802 75.0771Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M129.072 90.4689L126.182 88.6766L126.472 85.5362L129.373 87.6204L129.072 90.4689Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask24 || (_mask24 = /*#__PURE__*/React.createElement("mask", {
    id: "path-524-inside-24_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.27 61.9341L125.779 57.2828L124.623 56.9268L131.874 61.5165L133.27 61.9341Z"
  }))), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M133.27 61.9341L133.156 62.3173L133.481 61.5943L133.27 61.9341ZM125.779 57.2828L125.99 56.943L125.946 56.9157L125.897 56.9005L125.779 57.2828ZM124.623 56.9268L124.741 56.5445L124.409 57.2647L124.623 56.9268ZM131.874 61.5165L131.661 61.8544L131.707 61.8839L131.76 61.8997L131.874 61.5165ZM133.481 61.5943L125.99 56.943L125.568 57.6226L133.059 62.274L133.481 61.5943ZM125.897 56.9005L124.741 56.5445L124.505 57.309L125.661 57.6651L125.897 56.9005ZM124.409 57.2647L131.661 61.8544L132.088 61.1785L124.837 56.5888L124.409 57.2647ZM131.76 61.8997L133.156 62.3173L133.385 61.5509L131.989 61.1332L131.76 61.8997Z",
    fill: "white",
    mask: "url(#path-524-inside-24_1396_24002)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9324 48.134L86.6523 47.0029L85.6445 44.6433L91.4278 45.9189L91.9324 48.134Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M118.765 65.1349L112.413 62.1843L113.073 59.3137L119.67 62.5678L118.765 65.1349Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask25 || (_mask25 = /*#__PURE__*/React.createElement("mask", {
    id: "path-528-inside-25_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.6809 72.3827L43.6587 76.412L45.0704 70.3338L46.0321 66.3613L44.6809 72.3827Z"
  }))), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6809 72.3827L45.0688 72.4811L45.0712 72.4703L44.6809 72.3827ZM43.6587 76.412L43.2691 76.3216L44.0464 76.5104L43.6587 76.412ZM45.0704 70.3338L44.6816 70.2397L44.6808 70.2433L45.0704 70.3338ZM46.0321 66.3613L46.4224 66.4489L45.6433 66.2672L46.0321 66.3613ZM44.2932 72.2843L43.271 76.3137L44.0464 76.5104L45.0686 72.4811L44.2932 72.2843ZM44.0483 76.5025L45.46 70.4243L44.6808 70.2433L43.2691 76.3216L44.0483 76.5025ZM45.4592 70.4279L46.4209 66.4554L45.6433 66.2672L44.6816 70.2397L45.4592 70.4279ZM45.6418 66.2737L44.2906 72.2951L45.0712 72.4703L46.4224 66.4489L45.6418 66.2737Z",
    fill: "white",
    mask: "url(#path-528-inside-25_1396_24002)"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4314 144.905L77.8087 144.148L78.1432 146.458L74.8268 147.196L74.4314 144.905Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8828 72.5212L88.0593 66.7048L90.1554 66.3009L90.6975 71.8926L88.8828 72.5212Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M131.717 104.943L131.206 103.193L131.391 102.484L131.9 104.329L131.717 104.943Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask26 || (_mask26 = /*#__PURE__*/React.createElement("mask", {
    id: "path-533-inside-26_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.798 115.125L141.511 113.745L143.16 113.256L140.397 114.753L138.798 115.125Z"
  }))), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M138.798 115.125L138.616 114.769L138.888 115.515L138.798 115.125ZM141.511 113.745L141.397 113.362L141.362 113.372L141.33 113.389L141.511 113.745ZM143.16 113.256L143.35 113.608L143.046 112.872L143.16 113.256ZM140.397 114.753L140.487 115.143L140.54 115.13L140.587 115.105L140.397 114.753ZM138.979 115.482L141.692 114.102L141.33 113.389L138.616 114.769L138.979 115.482ZM141.625 114.129L143.274 113.639L143.046 112.872L141.397 113.362L141.625 114.129ZM142.969 112.904L140.206 114.401L140.587 115.105L143.35 113.608L142.969 112.904ZM140.306 114.363L138.707 114.736L138.888 115.515L140.487 115.143L140.306 114.363Z",
    fill: "white",
    mask: "url(#path-533-inside-26_1396_24002)"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M151.644 90.9865L151.664 93.1578L150.197 90.5437L150.183 88.1637L151.644 90.9865Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M114.703 54.6507L121.93 58.4239L120.975 59.8346L114.008 56.2651L114.703 54.6507Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M148.157 78.5504L148.729 80.4933L145.041 76.8635L144.492 74.7264L148.157 78.5504Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M134.085 113.579L132.988 112.651L135.121 111.631L136.252 112.564L134.085 113.579Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M119.822 62.1978L113.175 58.9184L113.87 56.6434L120.776 60.1816L119.822 62.1978Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5022 60.6827L89.7523 60.2619L88.9225 55.5739L93.0923 56.2542L93.5022 60.6827Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M59.983 141.195L63.0542 143.877L63.3774 145.298L60.375 142.676L59.983 141.195Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M126.756 81.3406L122.417 78.9754L123.074 75.6812L127.478 78.3835L126.756 81.3406Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask27 || (_mask27 = /*#__PURE__*/React.createElement("mask", {
    id: "path-543-inside-27_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.396 114.753L143.159 113.256L144.749 112.343L141.936 113.982L140.396 114.753Z"
  }))), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M140.396 114.753L140.205 114.401L140.575 115.111L140.396 114.753ZM143.159 113.256L143.35 113.608L143.358 113.603L143.159 113.256ZM144.749 112.343L144.95 112.688L144.549 111.996L144.749 112.343ZM141.936 113.982L142.115 114.34L142.126 114.334L142.137 114.328L141.936 113.982ZM140.586 115.105L143.35 113.607L142.969 112.904L140.205 114.401L140.586 115.105ZM143.358 113.603L144.948 112.69L144.549 111.996L142.96 112.909L143.358 113.603ZM144.547 111.997L141.735 113.636L142.137 114.328L144.95 112.688L144.547 111.997ZM141.757 113.624L140.217 114.395L140.575 115.111L142.115 114.34L141.757 113.624Z",
    fill: "white",
    mask: "url(#path-543-inside-27_1396_24002)"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M140.495 67.9123L140.693 68.1503L135.919 64.5146L135.568 64.0255L140.495 67.9123Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5199 51.6227L87.7987 50.6967L86.8007 47.4479L92.0221 48.5664L92.5199 51.6227Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M56.716 137.465L59.4404 140.711L59.7746 141.974L57.1053 138.794L56.716 137.465Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask28 || (_mask28 = /*#__PURE__*/React.createElement("mask", {
    id: "path-548-inside-28_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.746 105.045L150.352 102.601L151.115 99.8422L150.494 102.537L149.746 105.045Z"
  }))), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M149.746 105.045L149.358 104.949L150.13 105.16L149.746 105.045ZM150.352 102.601L149.966 102.494L149.964 102.505L150.352 102.601ZM151.115 99.8422L151.504 99.9319L150.729 99.7356L151.115 99.8422ZM150.494 102.537L150.877 102.651L150.881 102.639L150.884 102.627L150.494 102.537ZM150.135 105.142L150.74 102.697L149.964 102.505L149.358 104.949L150.135 105.142ZM150.738 102.707L151.5 99.9487L150.729 99.7356L149.967 102.494L150.738 102.707ZM150.725 99.7524L150.104 102.447L150.884 102.627L151.504 99.9319L150.725 99.7524ZM150.111 102.423L149.363 104.931L150.13 105.16L150.877 102.651L150.111 102.423Z",
    fill: "white",
    mask: "url(#path-548-inside-28_1396_24002)"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M132.677 112.353L131.645 111.112L133.767 110.049L134.832 111.323L132.677 112.353Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0463 55.8421L88.8409 55.1559L87.9073 51.1241L92.5827 52.0411L93.0463 55.8421Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6926 80.0717L87.9814 74.1631L88.5697 73.3426L89.115 79.1889L88.6926 80.0717Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0281 128.19L89.1375 124.052L89.4662 127.078L87.3592 131.195L87.0281 128.19Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M67.289 42.2675L66.6555 42.6275L64.1696 43.3715L64.8619 43.028L67.289 42.2675Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9062 44.1252L80.299 43.6503L78.8611 42.1549L83.9568 42.6954L84.9062 44.1252Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M123.757 71.6348L118.194 68.7351L119.007 65.7107L124.725 68.9376L123.757 71.6348Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M123.9 57.3525L124.591 57.1462L131.32 61.4053L130.473 61.5429L123.9 57.3525Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5317 144.176L66.8253 146.116L67.0991 147.618L63.8837 145.723L63.5317 144.176Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask29 || (_mask29 = /*#__PURE__*/React.createElement("mask", {
    id: "path-559-inside-29_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.425 117.242L48.4043 120.461L46.7566 114.133L45.7419 110.78L47.425 117.242Z"
  }))), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M47.425 117.242L47.0379 117.343L47.0399 117.351L47.0423 117.359L47.425 117.242ZM48.4043 120.461L48.0216 120.577L48.7914 120.36L48.4043 120.461ZM46.7566 114.133L47.1437 114.032L47.1417 114.024L47.1394 114.017L46.7566 114.133ZM45.7419 110.78L46.1248 110.664L45.3549 110.881L45.7419 110.78ZM47.0423 117.359L48.0216 120.577L48.787 120.344L47.8076 117.126L47.0423 117.359ZM48.7914 120.36L47.1437 114.032L46.3695 114.233L48.0172 120.561L48.7914 120.36ZM47.1394 114.017L46.1248 110.664L45.3591 110.896L46.3737 114.248L47.1394 114.017ZM45.3549 110.881L47.0379 117.343L47.812 117.141L46.129 110.679L45.3549 110.881Z",
    fill: "white",
    mask: "url(#path-559-inside-29_1396_24002)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M43.62 95.9617L43.9501 97.3435L44.2655 101.687L43.9394 100.34L43.62 95.9617Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M130.53 95.4043L129.363 94.0212L129.424 91.3985L130.588 92.9911L130.53 95.4043Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9166 54.6432L50.6622 57.2032L49.1777 59.0856L50.5977 56.4081L51.9166 54.6432Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask30 || (_mask30 = /*#__PURE__*/React.createElement("mask", {
    id: "path-564-inside-30_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.936 113.982L144.749 112.343L146.239 111.029L143.379 112.832L141.936 113.982Z"
  }))), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M141.936 113.982L141.687 113.67L142.138 114.328L141.936 113.982ZM144.749 112.343L144.95 112.689L144.984 112.669L145.014 112.643L144.749 112.343ZM146.239 111.029L146.503 111.329L146.025 110.691L146.239 111.029ZM143.379 112.832L143.166 112.493L143.147 112.505L143.13 112.519L143.379 112.832ZM142.138 114.328L144.95 112.689L144.548 111.998L141.735 113.637L142.138 114.328ZM145.014 112.643L146.503 111.329L145.974 110.729L144.484 112.043L145.014 112.643ZM146.025 110.691L143.166 112.493L143.593 113.17L146.452 111.367L146.025 110.691ZM143.13 112.519L141.687 113.67L142.186 114.295L143.629 113.144L143.13 112.519Z",
    fill: "white",
    mask: "url(#path-564-inside-30_1396_24002)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8531 133.206L56.0702 136.688L56.3356 137.594L54.1529 134.166L53.8531 133.206Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M131.036 102.26L130.736 100.571L130.886 99.9192L131.182 101.701L131.036 102.26Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask31 || (_mask31 = /*#__PURE__*/React.createElement("mask", {
    id: "path-568-inside-31_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.5769 80.7754L88.909 82.7694L89.4067 89.6386L88.9823 87.4598L88.5769 80.7754Z"
  }))), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5769 80.7754L88.9715 80.7097L88.1776 80.7996L88.5769 80.7754ZM88.909 82.7694L89.3079 82.7405L89.3066 82.722L89.3035 82.7037L88.909 82.7694ZM89.4067 89.6386L89.014 89.7151L89.8056 89.6097L89.4067 89.6386ZM88.9823 87.4598L88.5831 87.484L88.5846 87.5103L88.5897 87.5363L88.9823 87.4598ZM88.1823 80.8411L88.5144 82.8351L89.3035 82.7037L88.9715 80.7097L88.1823 80.8411ZM88.51 82.7983L89.0077 89.6675L89.8056 89.6097L89.3079 82.7405L88.51 82.7983ZM89.7993 89.5622L89.3749 87.3833L88.5897 87.5363L89.014 89.7151L89.7993 89.5622ZM89.3816 87.4356L88.9762 80.7512L88.1776 80.7996L88.5831 87.484L89.3816 87.4356Z",
    fill: "white",
    mask: "url(#path-568-inside-31_1396_24002)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M131.404 110.786L130.485 109.264L132.59 108.136L133.536 109.718L131.404 110.786Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M129.446 87.1786L126.523 85.0781L127.029 82.0127L129.973 84.4145L129.446 87.1786Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M124.882 68.5639L119.125 65.3152L120.025 62.762L125.955 66.3054L124.882 68.5639Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9915 66.31L86.9271 60.8453L89.4069 60.6575L90.1087 65.9021L87.9915 66.31Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M122.553 58.3218L123.446 57.5338L130.053 61.7466L128.984 62.3968L122.553 58.3218Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M151.348 88.0667L151.538 89.9077L150.176 87.2749L149.991 85.2475L151.348 88.0667Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M147.131 76.1595L147.713 77.5093L144.28 73.9279L143.696 72.3949L147.131 76.1595Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M127.596 77.9876L123.166 75.2689L123.988 72.2405L128.501 75.2863L127.596 77.9876Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask32 || (_mask32 = /*#__PURE__*/React.createElement("mask", {
    id: "path-578-inside-32_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.636 67.7694L134.581 62.9928L133.269 61.9364L139.173 66.7141L140.636 67.7694Z"
  }))), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M140.636 67.7694L140.402 68.0939L140.883 67.4554L140.636 67.7694ZM134.581 62.9928L134.33 63.3044L134.333 63.3068L134.581 62.9928ZM133.269 61.9364L133.52 61.6249L133.017 62.2473L133.269 61.9364ZM139.173 66.7141L138.921 67.025L138.93 67.032L138.939 67.0385L139.173 66.7141ZM140.883 67.4554L134.828 62.6788L134.333 63.3068L140.388 68.0835L140.883 67.4554ZM134.832 62.6813L133.52 61.6249L133.018 62.2479L134.33 63.3043L134.832 62.6813ZM133.017 62.2473L138.921 67.025L139.424 66.4032L133.52 61.6255L133.017 62.2473ZM138.939 67.0385L140.402 68.0939L140.87 67.445L139.407 66.3897L138.939 67.0385Z",
    fill: "white",
    mask: "url(#path-578-inside-32_1396_24002)"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6058 96.307L89.6063 90.5101L90.4096 92.1603L90.405 98.0469L89.6058 96.307Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M121.125 60.3799L127.283 64.2016L126.15 65.958L120.175 62.3882L121.125 60.3799Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M121.323 60.0313L122.277 58.6214L128.669 62.6718L127.529 63.8826L121.323 60.0313Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M67.263 146.284L70.6657 147.376L70.8696 148.928L67.5504 147.86L67.263 146.284Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5727 41.7514L73.9469 42.0072L72.4073 41.4519L76.4323 41.203L77.5727 41.7514Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask33 || (_mask33 = /*#__PURE__*/React.createElement("mask", {
    id: "path-585-inside-33_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.494 102.536L151.115 99.8417L151.626 96.9277L150.992 99.8714L150.494 102.536Z"
  }))), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M150.494 102.536L150.101 102.463L150.884 102.626L150.494 102.536ZM151.115 99.8417L151.504 99.9314L151.507 99.9212L151.509 99.9108L151.115 99.8417ZM151.626 96.9277L152.02 96.9969L151.235 96.8436L151.626 96.9277ZM150.992 99.8714L150.601 99.7872L150.599 99.7979L150.992 99.8714ZM150.884 102.626L151.504 99.9314L150.725 99.7519L150.104 102.447L150.884 102.626ZM151.509 99.9108L152.02 96.9969L151.232 96.8586L150.721 99.7725L151.509 99.9108ZM151.235 96.8436L150.601 99.7872L151.383 99.9556L152.017 97.0119L151.235 96.8436ZM150.599 99.7979L150.101 102.463L150.887 102.61L151.385 99.9449L150.599 99.7979Z",
    fill: "white",
    mask: "url(#path-585-inside-33_1396_24002)"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M146.104 110.877L144.423 111.936L144.821 111.478L146.591 110.269L146.104 110.877Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1951 46.9519L82.1438 46.5926L80.5915 44.0828L85.1714 44.5549L86.1951 46.9519Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M90.231 105.432L90.7486 99.5987L92.0074 101.74L91.4297 107.64L90.231 105.432Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M130.304 108.908L129.538 107.151L131.622 105.935L132.409 107.779L130.304 108.908Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0816 82.9277L43.6677 78.0284L43.9572 80.2659L43.3704 85.1454L43.0816 82.9277Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M59.841 46.0072L59.2802 46.5458L58.2123 47.2604L58.792 46.7572L59.841 46.0072Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1938 144.011L81.374 142.324L81.6481 144.651L78.5251 146.299L78.1938 144.011Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask34 || (_mask34 = /*#__PURE__*/React.createElement("mask", {
    id: "path-594-inside-34_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.2154 131.83L53.9708 134.251L51.4077 128.984L50.577 126.406L53.2154 131.83Z"
  }))), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2154 131.83L53.5973 131.711L53.5883 131.682L53.5751 131.655L53.2154 131.83ZM53.9708 134.251L53.6111 134.426L54.3526 134.132L53.9708 134.251ZM51.4077 128.984L51.027 129.106L51.0357 129.133L51.048 129.159L51.4077 128.984ZM50.577 126.406L50.9367 126.231L50.1963 126.529L50.577 126.406ZM52.8336 131.949L53.5889 134.37L54.3526 134.132L53.5973 131.711L52.8336 131.949ZM54.3305 134.076L51.7674 128.809L51.048 129.159L53.6111 134.426L54.3305 134.076ZM51.7884 128.861L50.9577 126.283L50.1963 126.529L51.027 129.106L51.7884 128.861ZM50.2173 126.581L52.8557 132.005L53.5751 131.655L50.9367 126.231L50.2173 126.581Z",
    fill: "white",
    mask: "url(#path-594-inside-34_1396_24002)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3464 60.2615L86.8415 60.4512L85.5717 55.513L88.5089 55.5302L89.3464 60.2615Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M130.649 92.3977L129.444 90.749L129.722 88.1107L130.928 89.9897L130.649 92.3977Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M130.634 99.2349L130.531 97.8457L130.618 97.4189L130.717 98.8739L130.634 99.2349Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3674 50.6514L83.8773 50.4479L82.347 47.0105L86.3582 47.3663L87.3674 50.6514Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M128.652 74.9066L124.107 71.8396L125.068 69.1652L129.709 72.5388L128.652 74.9066Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8849 73.6113L86.8085 67.7174L87.6882 66.9421L88.5092 72.7407L87.8849 73.6113Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M132.77 61.9949L133.175 62.1161L138.246 66.2198L137.716 66.0574L132.77 61.9949Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M130.083 83.9896L127.112 81.5662L127.82 78.6643L130.822 81.3899L130.083 83.9896Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M90.51 114.435L91.5915 109.166L92.274 111.646L91.15 116.939L90.51 114.435Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4234 55.1328L85.456 55.1154L84.0268 50.8604L87.4808 51.0618L88.4234 55.1328Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5384 135.827L87.0995 132.394L87.4672 135.22L84.9302 138.608L84.5384 135.827Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M145.904 74.1671L146.002 74.326L143.3 71.3643L143.046 70.9063L145.904 74.1671Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M147.442 109.204L145.367 110.621L145.977 109.647L148.104 108.075L147.442 109.204Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M150.782 85.2989L151.022 86.4685L149.882 84.1012L149.634 82.7587L150.782 85.2989Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M129.401 106.766L128.818 104.828L130.882 103.505L131.48 105.553L129.401 106.766Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0771 147.439L74.4796 147.626L74.6031 149.213L71.2857 149.026L71.0771 147.439Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask35 || (_mask35 = /*#__PURE__*/React.createElement("mask", {
    id: "path-612-inside-35_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.992 99.8736L151.626 96.9299L151.871 93.9352L151.227 97.1201L150.992 99.8736Z"
  }))), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M150.992 99.8736L150.593 99.8396L151.383 99.9578L150.992 99.8736ZM151.626 96.9299L152.017 97.0141L152.022 96.9886L152.024 96.9626L151.626 96.9299ZM151.871 93.9352L152.27 93.9679L151.479 93.8559L151.871 93.9352ZM151.227 97.1201L150.835 97.0407L150.83 97.0632L150.828 97.086L151.227 97.1201ZM151.383 99.9578L152.017 97.0141L151.235 96.8458L150.601 99.7894L151.383 99.9578ZM152.024 96.9626L152.27 93.9679L151.473 93.9025L151.227 96.8972L152.024 96.9626ZM151.479 93.8559L150.835 97.0407L151.619 97.1994L152.263 94.0145L151.479 93.8559ZM150.828 97.086L150.593 99.8396L151.39 99.9076L151.625 97.1541L150.828 97.086Z",
    fill: "white",
    mask: "url(#path-612-inside-35_1396_24002)"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8266 41.6501L67.7254 42.3701L66.6452 42.4701L69.0509 41.7163L69.8266 41.6501Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M132.505 116.325L131.644 116.046L135.587 114.856L136.468 115.099L132.505 116.325Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M129.899 72.1805L125.223 68.7812L126.288 66.5382L131.072 70.2133L129.899 72.1805Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M131.001 115.823L130.001 115.233L134.031 114.027L135.07 114.595L131.001 115.823Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M130.898 61.8787L131.815 61.7297L137.104 66.0738L136.079 66.1489L130.898 61.8787Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3518 107.18L45.4825 107.619L46.0635 111.15L45.9374 110.733L45.3518 107.18Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0507 64.0958L46.8932 64.7984L46.0806 67.0053L46.224 66.413L47.0507 64.0958Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M134.03 116.446L133.579 116.414L137.208 115.291L137.601 115.3L134.03 116.446Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M129.553 114.949L128.531 114.044L132.576 112.824L133.642 113.726L129.553 114.949Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7757 43.6811L76.4733 43.9882L74.4453 42.3734L78.2596 42.1043L79.7757 43.6811Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask36 || (_mask36 = /*#__PURE__*/React.createElement("mask", {
    id: "path-624-inside-36_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.7737 74.1102L87.921 75.9287L88.9086 82.773L88.5765 80.779L87.7737 74.1102Z"
  }))), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7737 74.1102L88.1709 74.0624L87.375 74.1425L87.7737 74.1102ZM87.921 75.9287L87.5223 75.961L87.5234 75.9735L87.5251 75.9858L87.921 75.9287ZM88.9086 82.773L88.514 82.8387L89.3045 82.7158L88.9086 82.773ZM88.5765 80.779L88.1794 80.8268L88.1805 80.8358L88.182 80.8447L88.5765 80.779ZM87.375 74.1425L87.5223 75.961L88.3197 75.8964L88.1724 74.0779L87.375 74.1425ZM87.5251 75.9858L88.5127 82.8301L89.3045 82.7158L88.3169 75.8716L87.5251 75.9858ZM89.3032 82.7073L88.9711 80.7133L88.182 80.8447L88.514 82.8387L89.3032 82.7073ZM88.9737 80.7312L88.1709 74.0624L87.3766 74.158L88.1794 80.8268L88.9737 80.7312Z",
    fill: "white",
    mask: "url(#path-624-inside-36_1396_24002)"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M126.482 66.1826L127.611 64.4333L132.547 68.3733L131.304 69.8867L126.482 66.1826Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M129.326 62.6576L130.413 61.9967L135.636 66.3018L134.435 66.8303L129.326 62.6576Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask37 || (_mask37 = /*#__PURE__*/React.createElement("mask", {
    id: "path-628-inside-37_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.395 95.0634L130.79 92.9287L130.717 95.9369L130.329 97.8325L130.395 95.0634Z"
  }))), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M130.395 95.0634L130.002 94.9906L129.996 95.0219L129.995 95.0538L130.395 95.0634ZM130.79 92.9287L131.19 92.9384L130.397 92.8559L130.79 92.9287ZM130.717 95.9369L131.109 96.0172L131.116 95.9823L131.117 95.9466L130.717 95.9369ZM130.329 97.8325L129.929 97.8229L130.72 97.9128L130.329 97.8325ZM130.788 95.1361L131.183 93.0015L130.397 92.8559L130.002 94.9906L130.788 95.1361ZM130.39 92.919L130.317 95.9272L131.117 95.9466L131.19 92.9384L130.39 92.919ZM130.325 95.8566L129.937 97.7521L130.72 97.9128L131.109 96.0172L130.325 95.8566ZM130.728 97.8421L130.795 95.0729L129.995 95.0538L129.929 97.8229L130.728 97.8421Z",
    fill: "white",
    mask: "url(#path-628-inside-37_1396_24002)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M131.042 89.4243L129.797 87.4829L130.289 84.9043L131.537 87.0895L131.042 89.4243Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M130.968 80.9803L127.936 78.2278L128.825 75.5726L131.896 78.6184L130.968 80.9803Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask38 || (_mask38 = /*#__PURE__*/React.createElement("mask", {
    id: "path-632-inside-38_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.055 116.65L138.799 115.127L140.398 114.755L135.587 116.374L134.055 116.65Z"
  }))), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M134.055 116.65L133.933 116.269L134.126 117.043L134.055 116.65ZM138.799 115.127L138.708 114.738L138.692 114.741L138.676 114.746L138.799 115.127ZM140.398 114.755L140.525 115.134L140.307 114.365L140.398 114.755ZM135.587 116.374L135.658 116.768L135.687 116.763L135.715 116.753L135.587 116.374ZM134.178 117.03L138.921 115.508L138.676 114.746L133.933 116.269L134.178 117.03ZM138.889 115.517L140.488 115.144L140.307 114.365L138.708 114.738L138.889 115.517ZM140.27 114.376L135.459 115.995L135.715 116.753L140.525 115.134L140.27 114.376ZM135.516 115.98L133.985 116.256L134.126 117.043L135.658 116.768L135.516 115.98Z",
    fill: "white",
    mask: "url(#path-632-inside-38_1396_24002)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M148.609 107.207L146.326 108.895L146.932 107.55L149.253 105.698L148.609 107.207Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M128.201 113.728L127.229 112.526L131.26 111.279L132.274 112.499L128.201 113.728Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask39 || (_mask39 = /*#__PURE__*/React.createElement("mask", {
    id: "path-636-inside-39_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.5772 126.405L51.4079 128.982L49.2997 123.209L48.406 120.458L50.5772 126.405Z"
  }))), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5772 126.405L50.9579 126.282L50.9555 126.275L50.9529 126.267L50.5772 126.405ZM51.4079 128.982L51.0321 129.119L51.7886 128.86L51.4079 128.982ZM49.2997 123.209L48.9193 123.333L48.9215 123.339L48.924 123.346L49.2997 123.209ZM48.406 120.458L48.7817 120.321L48.0256 120.582L48.406 120.458ZM50.1965 126.527L51.0272 129.105L51.7886 128.86L50.9579 126.282L50.1965 126.527ZM51.7836 128.845L49.6754 123.072L48.924 123.346L51.0321 129.119L51.7836 128.845ZM49.6801 123.085L48.7864 120.334L48.0256 120.582L48.9193 123.333L49.6801 123.085ZM48.0303 120.595L50.2014 126.542L50.9529 126.267L48.7817 120.321L48.0303 120.595Z",
    fill: "white",
    mask: "url(#path-636-inside-39_1396_24002)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M127.855 64.12L128.997 62.9075L134.086 67.0636L132.827 68.0884L127.855 64.12Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask40 || (_mask40 = /*#__PURE__*/React.createElement("mask", {
    id: "path-639-inside-40_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.065 74.047L141.968 69.3725L140.636 67.7679L144.655 72.4985L146.065 74.047Z"
  }))), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M146.065 74.047L145.769 74.3163L146.366 73.7833L146.065 74.047ZM141.968 69.3725L141.661 69.6282L141.668 69.6361L141.968 69.3725ZM140.636 67.7679L140.941 67.5089L140.328 68.0235L140.636 67.7679ZM144.655 72.4985L144.35 72.7577L144.359 72.7678L144.655 72.4985ZM146.366 73.7833L142.269 69.1089L141.668 69.6361L145.764 74.3106L146.366 73.7833ZM142.276 69.1169L140.944 67.5124L140.328 68.0235L141.661 69.6281L142.276 69.1169ZM140.331 68.0269L144.35 72.7575L144.96 72.2395L140.941 67.5089L140.331 68.0269ZM144.359 72.7678L145.769 74.3163L146.361 73.7777L144.951 72.2292L144.359 72.7678Z",
    fill: "white",
    mask: "url(#path-639-inside-40_1396_24002)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4672 123.384L91.0653 118.727L91.3701 121.568L89.7734 126.203L89.4672 123.384Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5461 88.3496L44.0878 90.6632L43.9809 95.7537L43.4411 93.4947L43.5461 88.3496Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7057 67.2726L85.2936 61.6535L86.545 60.9697L87.6164 66.4702L86.7057 67.2726Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M128.725 104.414L128.345 102.359L130.39 100.912L130.779 103.097L128.725 104.414Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask41 || (_mask41 = /*#__PURE__*/React.createElement("mask", {
    id: "path-645-inside-41_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.974 85.2382L149.139 81.1767L148.336 78.4471L150.15 82.6885L150.974 85.2382Z"
  }))), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M150.974 85.2382L150.609 85.4029L151.354 85.1153L150.974 85.2382ZM149.139 81.1767L148.755 81.2896L148.763 81.3162L148.774 81.3414L149.139 81.1767ZM148.336 78.4471L148.704 78.2898L147.952 78.56L148.336 78.4471ZM150.15 82.6885L150.531 82.5656L150.525 82.5481L150.518 82.5311L150.15 82.6885ZM151.338 85.0735L149.503 81.012L148.774 81.3414L150.609 85.4029L151.338 85.0735ZM149.522 81.0639L148.72 78.3343L147.952 78.56L148.755 81.2896L149.522 81.0639ZM147.968 78.6045L149.783 82.8458L150.518 82.5311L148.704 78.2898L147.968 78.6045ZM149.77 82.8113L150.593 85.3611L151.354 85.1153L150.531 82.5656L149.77 82.8113Z",
    fill: "white",
    mask: "url(#path-645-inside-41_1396_24002)"
  })), _mask42 || (_mask42 = /*#__PURE__*/React.createElement("mask", {
    id: "path-647-inside-42_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0388 52.8093L50.4281 56.3031L53.3694 52.5515L55.6733 49.2031L53.0388 52.8093Z"
  }))), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0388 52.8093L53.3593 53.0488L53.3618 53.0453L53.0388 52.8093ZM50.4281 56.3031L50.1077 56.0636L50.7429 56.5499L50.4281 56.3031ZM53.3694 52.5515L53.6842 52.7983L53.6919 52.7885L53.6989 52.7783L53.3694 52.5515ZM55.6733 49.2031L56.0028 49.4299L55.3503 48.9672L55.6733 49.2031ZM52.7184 52.5699L50.1077 56.0636L50.7485 56.5425L53.3593 53.0487L52.7184 52.5699ZM50.7429 56.5499L53.6842 52.7983L53.0546 52.3047L50.1133 56.0563L50.7429 56.5499ZM53.6989 52.7783L56.0028 49.4299L55.3438 48.9764L53.0399 52.3248L53.6989 52.7783ZM55.3503 48.9672L52.7158 52.5733L53.3618 53.0453L55.9963 49.4391L55.3503 48.9672Z",
    fill: "white",
    mask: "url(#path-647-inside-42_1396_24002)"
  })), _mask43 || (_mask43 = /*#__PURE__*/React.createElement("mask", {
    id: "path-649-inside-43_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.585 116.369L140.396 114.749L141.936 113.979L137.06 115.712L135.585 116.369Z"
  }))), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M135.585 116.369L135.422 116.003L135.713 116.748L135.585 116.369ZM140.396 114.749L140.523 115.128L140.55 115.12L140.575 115.107L140.396 114.749ZM141.936 113.979L142.115 114.336L141.802 113.602L141.936 113.979ZM137.06 115.712L136.926 115.335L136.911 115.34L136.897 115.347L137.06 115.712ZM135.713 116.748L140.523 115.128L140.268 114.37L135.457 115.99L135.713 116.748ZM140.575 115.107L142.115 114.336L141.757 113.621L140.217 114.392L140.575 115.107ZM141.802 113.602L136.926 115.335L137.194 116.089L142.07 114.355L141.802 113.602ZM136.897 115.347L135.422 116.003L135.748 116.734L137.222 116.078L136.897 115.347Z",
    fill: "white",
    mask: "url(#path-649-inside-43_1396_24002)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M126.979 112.185L126.108 110.72L130.116 109.427L131.025 110.933L126.979 112.185Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M151.664 92.95L151.673 93.9154L151.405 95.2417L151.394 94.3661L151.664 92.95Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6033 89.589L89.1845 83.8082L89.8394 85.1717L90.3235 91.0683L89.6033 89.589Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6929 46.6256L78.9217 47.0032L76.7986 44.3592L80.101 44.052L81.6929 46.6256Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M132.079 78.236L128.976 75.1583L130.018 72.8258L133.166 76.1788L132.079 78.236Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M140.336 67.7992L140.498 67.9162L143.541 71.4984L143.244 71.2956L140.336 67.7992Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7474 142.095L84.6357 139.531L84.852 141.855L82.0148 144.365L81.7474 142.095Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8784 147.591L78.1741 146.858L78.2148 148.468L75.0019 149.178L74.8784 147.591Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M149.573 104.929L147.153 106.86L147.661 105.233L150.108 103.133L149.573 104.929Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M141.837 113.804L138.257 115.077L138.536 114.871L142.262 113.465L141.837 113.804Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M131.694 86.5608L130.407 84.3079L131.102 81.8631L132.394 84.3644L131.694 86.5608Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M85.175 61.2621L83.4758 56.144L85.1717 55.5702L86.4554 60.5625L85.175 61.2621Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask44 || (_mask44 = /*#__PURE__*/React.createElement("mask", {
    id: "path-663-inside-44_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.732 92.3277L131.137 89.9404L130.791 92.9265L130.396 95.0611L130.732 92.3277Z"
  }))), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M130.732 92.3277L130.338 92.2608L130.336 92.2698L130.335 92.2789L130.732 92.3277ZM131.137 89.9404L131.535 89.9865L130.743 89.8735L131.137 89.9404ZM130.791 92.9265L131.185 92.9993L131.187 92.986L131.189 92.9725L130.791 92.9265ZM130.396 95.0611L129.999 95.0124L130.79 95.1339L130.396 95.0611ZM131.127 92.3946L131.532 90.0073L130.743 89.8735L130.338 92.2608L131.127 92.3946ZM130.74 89.8944L130.394 92.8805L131.189 92.9725L131.535 89.9865L130.74 89.8944ZM130.398 92.8537L130.003 94.9884L130.79 95.1339L131.185 92.9993L130.398 92.8537ZM130.793 95.1099L131.129 92.3764L130.335 92.2789L129.999 95.0124L130.793 95.1099Z",
    fill: "white",
    mask: "url(#path-663-inside-44_1396_24002)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1637 43.8691L61.8441 44.913L60.5086 45.5294L62.0768 44.4084L63.1637 43.8691Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5065 143.325L63.5168 145.954L63.605 146.69L60.6663 144.124L60.5065 143.325Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M125.919 110.36L125.188 108.674L129.172 107.318L129.933 109.066L125.919 110.36Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3382 139.695L60.0101 142.878L60.1352 143.504L57.5159 140.384L57.3382 139.695Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M128.297 101.906L128.13 99.8067L130.157 98.2238L130.325 100.471L128.297 101.906Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8044 98.9047L90.8091 92.8263L92.0244 94.8242L92.0138 100.962L90.8044 98.9047Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M83.4601 50.496L81.2304 50.9681L79.1588 47.3736L81.9035 46.9997L83.4601 50.496Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3523 42.2188L70.8281 43.2165L68.4411 42.5478L71.4274 41.5245L73.3523 42.2188Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask45 || (_mask45 = /*#__PURE__*/React.createElement("mask", {
    id: "path-673-inside-45_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.152 82.6867L148.337 78.4453L147.304 76.0477L149.096 80.4297L150.152 82.6867Z"
  }))), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M150.152 82.6867L149.79 82.8562L150.52 82.5293L150.152 82.6867ZM148.337 78.4453L148.705 78.288L148.705 78.287L148.337 78.4453ZM147.304 76.0477L147.671 75.8894L146.934 76.1991L147.304 76.0477ZM149.096 80.4297L148.725 80.581L148.729 80.5902L148.733 80.5992L149.096 80.4297ZM150.52 82.5293L148.705 78.288L147.97 78.6027L149.784 82.844L150.52 82.5293ZM148.705 78.287L147.671 75.8894L146.937 76.206L147.97 78.6037L148.705 78.287ZM146.934 76.1991L148.725 80.581L149.466 80.2783L147.674 75.8964L146.934 76.1991ZM148.733 80.5992L149.79 82.8562L150.514 82.5171L149.458 80.2601L148.733 80.5992Z",
    fill: "white",
    mask: "url(#path-673-inside-45_1396_24002)"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3332 55.768L81.4097 51.3371L83.6096 50.8712L85.0583 55.1843L83.3332 55.768Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9542 146.231L67.1764 148.13L67.1913 148.911L64.0535 147.061L63.9542 146.231Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M133.39 75.8346L130.208 72.446L131.367 70.502L134.6 74.1385L133.39 75.8346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3665 74.2045L44.2148 79.142L43.8625 76.4192L45.0144 71.4594L45.3665 74.2045Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M138.196 66.6203L139.058 66.8844L142.516 71.041L141.588 70.7415L138.196 66.6203Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M151.488 89.4318L151.643 90.9277L151.243 93.0175L151.087 91.6392L151.488 89.4318Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7926 69.8554L86.6672 69.2836L86.6733 69.2024L86.7926 69.8554Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M54.562 135.555L56.7373 138.971L56.8239 139.306L54.6722 135.929L54.562 135.555Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M143.261 112.661L139.155 114.21L139.806 113.5L143.991 111.822L143.261 112.661Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask46 || (_mask46 = /*#__PURE__*/React.createElement("mask", {
    id: "path-684-inside-46_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4045 120.458L49.2982 123.209L47.6995 117.067L46.7568 114.13L48.4045 120.458Z"
  }))), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4045 120.458L48.0174 120.559L48.0204 120.57L48.0241 120.581L48.4045 120.458ZM49.2982 123.209L48.9178 123.332L49.6853 123.108L49.2982 123.209ZM47.6995 117.067L48.0866 116.966L48.0838 116.955L48.0804 116.945L47.6995 117.067ZM46.7568 114.13L47.1377 114.008L46.3697 114.231L46.7568 114.13ZM48.0241 120.581L48.9178 123.332L49.6787 123.085L48.785 120.334L48.0241 120.581ZM49.6853 123.108L48.0866 116.966L47.3124 117.168L48.9111 123.309L49.6853 123.108ZM48.0804 116.945L47.1377 114.008L46.376 114.252L47.3187 117.189L48.0804 116.945ZM46.3697 114.231L48.0174 120.559L48.7916 120.357L47.1439 114.029L46.3697 114.231Z",
    fill: "white",
    mask: "url(#path-684-inside-46_1396_24002)"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4405 131.918L89.552 127.792L89.884 130.542L87.7915 134.616L87.4405 131.918Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M125.052 108.295L124.49 106.438L128.453 105L129.037 106.938L125.052 108.295Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M134.865 73.8315L131.598 70.158L132.833 68.6548L136.155 72.5408L134.865 73.8315Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7656 108.289L92.3076 102.755L92.9537 105.004L92.3889 110.553L91.7656 108.289Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M136.415 66.5229L137.531 66.4414L141.049 70.7164L139.873 70.7236L136.415 66.5229Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M44.485 99.1987L45.0025 100.987L45.347 105.761L44.837 104.047L44.485 99.1987Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M150.311 102.432L147.792 104.593L148.147 102.759L150.686 100.427L150.311 102.432Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M132.597 83.889L131.268 81.3161L132.148 79.0766L133.482 81.8935L132.597 83.889Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M133.116 68.3717L134.378 67.3444L137.786 71.4335L136.466 72.2906L133.116 68.3717Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M134.728 67.1412L135.957 66.6005L139.438 70.8294L138.15 71.2472L134.728 67.1412Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask47 || (_mask47 = /*#__PURE__*/React.createElement("mask", {
    id: "path-696-inside-47_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.33 89.7062L131.749 87.0596L131.137 89.9453L130.732 92.3326L131.33 89.7062Z"
  }))), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M131.33 89.7062L131.72 89.795L131.723 89.782L131.725 89.7688L131.33 89.7062ZM131.749 87.0596L132.144 87.1221L131.358 86.9766L131.749 87.0596ZM131.137 89.9453L130.746 89.8624L130.744 89.8704L130.743 89.8784L131.137 89.9453ZM130.732 92.3326L130.338 92.2656L131.122 92.4213L130.732 92.3326ZM131.725 89.7688L132.144 87.1221L131.354 86.997L130.935 89.6437L131.725 89.7688ZM131.358 86.9766L130.746 89.8624L131.528 90.0283L132.14 87.1425L131.358 86.9766ZM130.743 89.8784L130.338 92.2656L131.126 92.3995L131.532 90.0122L130.743 89.8784ZM131.122 92.4213L131.72 89.795L130.94 89.6174L130.342 92.2438L131.122 92.4213Z",
    fill: "white",
    mask: "url(#path-696-inside-47_1396_24002)"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5798 148.288L70.8942 149.354L70.8186 150.154L67.5956 149.116L67.5798 148.288Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M124.717 117.388L123.779 116.781L129.472 115.388L130.451 115.965L124.717 117.388Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M147.071 76.0543L147.123 76.1392L148.145 78.6388L148.009 78.4337L147.071 76.0543Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M128.132 99.2943L128.178 97.2288L130.184 95.5076L130.131 97.7329L128.132 99.2943Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M126.149 117.941L125.352 117.64L130.966 116.247L131.782 116.512L126.149 117.941Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M123.34 116.473L122.376 115.562L128.077 114.174L129.086 115.068L123.34 116.473Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M127.601 118.127L127.227 118.081L132.523 116.738L132.833 116.76L127.601 118.127Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9624 57.605L49.4683 60.0735L47.5926 63.5113L48.1515 61.0194L49.9624 57.605Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M122.049 115.23L121.129 114.035L126.812 112.645L127.776 113.836L122.049 115.23Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M144.553 111.167L140.203 112.911L140.912 111.823L145.319 109.945L144.553 111.167Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask48 || (_mask48 = /*#__PURE__*/React.createElement("mask", {
    id: "path-708-inside-48_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9712 134.25L54.4902 136.01L52.0229 130.941L51.4081 128.983L53.9712 134.25Z"
  }))), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9712 134.25L54.3549 134.137L54.3454 134.105L54.3309 134.075L53.9712 134.25ZM54.4902 136.01L54.1306 136.185L54.8739 135.897L54.4902 136.01ZM52.0229 130.941L51.6413 131.061L51.6502 131.089L51.6633 131.116L52.0229 130.941ZM51.4081 128.983L51.7678 128.808L51.0265 129.102L51.4081 128.983ZM53.5875 134.363L54.1066 136.124L54.8739 135.897L54.3549 134.137L53.5875 134.363ZM54.8499 135.835L52.3826 130.766L51.6633 131.116L54.1306 136.185L54.8499 135.835ZM52.4046 130.821L51.7898 128.863L51.0265 129.102L51.6413 131.061L52.4046 130.821ZM51.0485 129.158L53.6115 134.425L54.3309 134.075L51.7678 128.808L51.0485 129.158Z",
    fill: "white",
    mask: "url(#path-708-inside-48_1396_24002)"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M124.396 106.05L124.026 104.081L127.973 102.545L128.356 104.613L124.396 106.05Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M151.34 88.0147L150.868 90.6179L150.52 89.0379L150.992 86.3141L151.34 88.0147Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0377 44.1545L73.9277 45.1797L71.2746 43.4708L73.8838 42.4395L76.0377 44.1545Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M133.723 81.4637L132.355 78.5736L133.395 76.6054L134.771 79.7267L133.723 81.4637Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M78.57 146.733L81.6543 145.105L81.6173 146.723L78.6097 148.305L78.57 146.733Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask49 || (_mask49 = /*#__PURE__*/React.createElement("mask", {
    id: "path-715-inside-49_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.614 118.33L134.054 116.647L135.586 116.372L129.071 118.133L127.614 118.33Z"
  }))), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M127.614 118.33L127.513 117.943L127.668 118.726L127.614 118.33ZM134.054 116.647L133.984 116.254L133.968 116.256L133.953 116.26L134.054 116.647ZM135.586 116.372L135.691 116.758L135.515 115.978L135.586 116.372ZM129.071 118.133L129.125 118.53L129.151 118.526L129.176 118.52L129.071 118.133ZM127.715 118.717L134.155 117.034L133.953 116.26L127.513 117.943L127.715 118.717ZM134.125 117.041L135.657 116.766L135.515 115.978L133.984 116.254L134.125 117.041ZM135.482 115.986L128.967 117.747L129.176 118.52L135.691 116.758L135.482 115.986ZM129.018 117.737L127.561 117.933L127.668 118.726L129.125 118.53L129.018 117.737Z",
    fill: "white",
    mask: "url(#path-715-inside-49_1396_24002)"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M89.1023 82.7125L88.3326 77.378L88.6976 78.2192L89.6115 83.7726L89.1023 82.7125Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M120.882 113.684L120.056 112.239L125.711 110.834L126.577 112.291L120.882 113.684Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3471 68.2151L84.7902 63.0688L85.0392 62.2841L86.3895 67.657L86.3471 68.2151Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2194 81.4303L44.8609 84.2444L44.225 89.4928L43.5807 86.7413L44.2194 81.4303Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M150.801 99.782L148.207 102.164L148.377 100.192L150.984 97.6425L150.801 99.782Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8265 47.5973L56.5589 49.6741L54.3348 51.4993L55.8225 49.337L57.8265 47.5973Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M145.224 73.4193L145.893 74.1545L147.273 77.6545L146.568 76.919L145.224 73.4193Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3697 117.826L92.4134 112.912L92.6818 115.436L91.6384 120.33L91.3697 117.826Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M131.883 87.4882L131.944 87.1052L132.041 86.7984L131.98 87.2072L131.883 87.4882Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1948 42.8212L65.3415 44.5202L62.6176 44.8138L64.8633 43.0371L67.1948 42.8212Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M128.243 96.6489L128.488 94.7056L130.465 92.8557L130.206 94.9652L128.243 96.6489Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2878 149.423L74.5748 149.608L74.406 150.415L71.2113 150.233L71.2878 149.423Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask50 || (_mask50 = /*#__PURE__*/React.createElement("mask", {
    id: "path-729-inside-50_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.071 118.13L135.586 116.368L137.06 115.712L130.472 117.562L129.071 118.13Z"
  }))), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M129.071 118.13L128.921 117.759L129.175 118.516L129.071 118.13ZM135.586 116.368L135.69 116.755L135.72 116.746L135.748 116.734L135.586 116.368ZM137.06 115.712L137.223 116.077L136.952 115.327L137.06 115.712ZM130.472 117.562L130.364 117.177L130.343 117.183L130.322 117.191L130.472 117.562ZM129.175 118.516L135.69 116.755L135.481 115.982L128.966 117.744L129.175 118.516ZM135.748 116.734L137.223 116.077L136.898 115.346L135.423 116.003L135.748 116.734ZM136.952 115.327L130.364 117.177L130.581 117.947L137.168 116.097L136.952 115.327ZM130.322 117.191L128.921 117.759L129.221 118.501L130.623 117.933L130.322 117.191Z",
    fill: "white",
    mask: "url(#path-729-inside-50_1396_24002)"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0061 139.176L87.515 135.826L87.6789 138.121L85.2134 141.402L85.0061 139.176Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M145.677 109.36L141.178 111.277L141.825 109.882L146.369 107.826L145.677 109.36Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M119.871 111.873L119.175 110.222L124.803 108.789L125.531 110.467L119.871 111.873Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M135.048 79.3652L133.641 76.1718L134.81 74.5331L136.226 77.9362L135.048 79.3652Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M123.977 103.674L123.81 101.655L127.746 100.007L127.915 102.141L123.977 103.674Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M150.769 85.2487L150.252 88.2354L149.7 86.6252L150.214 83.5291L150.769 85.2487Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M143.52 71.9669L144.49 72.6281L145.982 76.5113L144.987 75.846L143.52 71.9669Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5433 47.1684L76.937 48.2026L74.2523 45.4657L76.3554 44.4438L78.5433 47.1684Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3434 110.379L46.4608 110.756L47.0656 114.435L46.9537 114.087L46.3434 110.379Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8054 92.0484L90.305 85.9538L91.3979 87.7731L91.9489 93.9284L90.8054 92.0484Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5583 62.4769L82.5401 57.4383L83.1647 56.4776L84.8506 61.5556L84.5583 62.4769Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask51 || (_mask51 = /*#__PURE__*/React.createElement("mask", {
    id: "path-742-inside-51_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.4065 128.985L52.0213 130.943L49.9927 125.388L49.2983 123.212L51.4065 128.985Z"
  }))), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4065 128.985L51.7882 128.865L51.7854 128.857L51.7823 128.848L51.4065 128.985ZM52.0213 130.943L51.6456 131.08L52.4029 130.823L52.0213 130.943ZM49.9927 125.388L49.6116 125.51L49.6141 125.518L49.6169 125.526L49.9927 125.388ZM49.2983 123.212L49.6741 123.075L48.9173 123.333L49.2983 123.212ZM51.0249 129.105L51.6397 131.063L52.4029 130.823L51.7882 128.865L51.0249 129.105ZM52.397 130.806L50.3684 125.251L49.6169 125.526L51.6456 131.08L52.397 130.806ZM50.3737 125.267L49.6794 123.09L48.9173 123.333L49.6116 125.51L50.3737 125.267ZM48.9226 123.349L51.0308 129.122L51.7823 128.848L49.6741 123.075L48.9226 123.349Z",
    fill: "white",
    mask: "url(#path-742-inside-51_1396_24002)"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M136.536 77.6406L135.093 74.1706L136.355 72.9088L137.808 76.5603L136.536 77.6406Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M136.972 115.535L131.538 117.062L131.873 116.825L137.421 115.203L136.972 115.535Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M151.026 97.0377L148.375 99.6309L148.341 97.5902L150.997 94.8382L151.026 97.0377Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M119.037 109.844L118.501 108.035L124.106 106.56L124.666 108.411L119.037 109.844Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M132.567 85.9884L132.805 84.4056L133.298 83.2948L133.053 84.9867L132.567 85.9884Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M141.801 71.2347L142.955 71.607L144.484 75.6501L143.31 75.2443L141.801 71.2347Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7654 52.1951L77.1894 48.514L78.768 47.4977L80.8765 51.1565L79.7654 52.1951Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M82.335 57.0211L79.9827 52.5423L81.0596 51.5358L82.9981 56.0012L82.335 57.0211Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M128.648 94.0091L129.055 92.2927L130.979 90.3455L130.55 92.2284L128.648 94.0091Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M138.148 76.3397L136.672 72.6324L137.984 71.7805L139.471 75.6355L138.148 76.3397Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3777 68.7469L45.6639 73.3827L45.2755 70.3547L46.9906 65.6962L47.3777 68.7469Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M146.606 107.275L142.002 109.358L142.522 107.718L147.161 105.495L146.606 107.275Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M140.068 71.1256L141.332 71.1178L142.863 75.1879L141.583 75.1249L140.068 71.1256Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M138.345 71.6021L139.658 71.1758L141.173 75.1758L139.846 75.4922L138.345 71.6021Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M123.803 101.222L123.843 99.2193L127.773 97.4498L127.725 99.5796L123.803 101.222Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M117.188 119.134L116.292 118.488L123.244 116.907L124.178 117.511L117.188 119.134Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M115.879 118.17L114.962 117.224L121.91 115.671L122.871 116.58L115.879 118.17Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4583 91.9995L45.1405 94.4471L45.0279 99.6371L44.3473 97.2853L44.4583 91.9995Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M149.189 81.1038L149.944 82.7151L149.398 85.9972L148.65 84.4756L149.189 81.1038Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M60.686 144.67L63.6393 147.249L63.609 147.353L60.6864 144.801L60.686 144.67Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M89.875 127.14L91.4741 122.498L91.7688 125.107L90.1832 129.693L89.875 127.14Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4122 101.668L92.4217 96.1655L92.9739 98.0646L92.9612 103.58L92.4122 101.668Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M118.545 119.749L117.775 119.41L124.669 117.81L125.457 118.108L118.545 119.749Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M57.66 141.175L60.286 144.303L60.2861 144.342L57.6687 141.225L57.66 141.175Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask52 || (_mask52 = /*#__PURE__*/React.createElement("mask", {
    id: "path-768-inside-52_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.465 69.2968L87.2007 71.4389L88.8893 78.1618L87.9196 75.9265L86.465 69.2968Z"
  }))), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M86.465 69.2968L86.8433 69.1668L86.0743 69.3825L86.465 69.2968ZM87.2007 71.4389L87.5886 71.3414L87.5845 71.325L87.579 71.309L87.2007 71.4389ZM88.8893 78.1618L88.5224 78.3209L89.2773 78.0643L88.8893 78.1618ZM87.9196 75.9265L87.5289 76.0122L87.5372 76.0501L87.5527 76.0857L87.9196 75.9265ZM86.0867 69.4267L86.8223 71.5688L87.579 71.309L86.8433 69.1668L86.0867 69.4267ZM86.8127 71.5363L88.5014 78.2592L89.2773 78.0643L87.5886 71.3414L86.8127 71.5363ZM89.2563 78.0026L88.2866 75.7673L87.5527 76.0857L88.5224 78.3209L89.2563 78.0026ZM88.3103 75.8408L86.8557 69.211L86.0743 69.3825L87.5289 76.0122L88.3103 75.8408Z",
    fill: "white",
    mask: "url(#path-768-inside-52_1396_24002)"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M114.656 116.886L113.782 115.663L120.704 114.138L121.621 115.33L114.656 116.886Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M138.33 114.515L132.431 116.24L133.077 115.552L139.047 113.734L138.33 114.515Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9888 149.59L78.1241 148.897L77.8757 149.692L74.8269 150.363L74.9888 149.59Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M118.408 107.646L118.052 105.735L123.642 104.205L124.011 106.171L118.408 107.646Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M63.987 147.485L67.1067 149.324L67.028 149.433L63.9488 147.617L63.987 147.485Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M133.569 84.1947L133.893 81.9542L134.659 80.683L134.324 83.0615L133.569 84.1947Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M119.916 119.994L119.52 119.926L126.149 118.352L126.496 118.395L119.916 119.994Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4788 43.5339L68.9385 45.2757L65.8489 44.5988L67.8224 42.7896L70.4788 43.5339Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M113.548 115.304L112.762 113.84L119.653 112.336L120.477 113.778L113.548 115.304Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0598 144.859L84.8309 142.408L84.7288 144.004L82.0247 146.39L82.0598 144.859Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M150.736 92.0888L150.983 94.2754L148.288 97.066L148.044 95.0249L150.736 92.0888Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask53 || (_mask53 = /*#__PURE__*/React.createElement("mask", {
    id: "path-781-inside-53_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.3337 140.475L57.48 141.311L54.7665 137.052L54.4897 136.011L57.3337 140.475Z"
  }))), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3337 140.475L57.7278 140.406L57.714 140.328L57.6711 140.26L57.3337 140.475ZM57.48 141.311L57.1427 141.526L57.874 141.242L57.48 141.311ZM54.7665 137.052L54.3799 137.155L54.3958 137.215L54.4291 137.267L54.7665 137.052ZM54.4897 136.011L54.827 135.796L54.1031 136.113L54.4897 136.011ZM56.9397 140.544L57.086 141.38L57.874 141.242L57.7278 140.406L56.9397 140.544ZM57.8174 141.096L55.1038 136.837L54.4291 137.267L57.1427 141.526L57.8174 141.096ZM55.1531 136.949L54.8763 135.908L54.1031 136.113L54.3799 137.155L55.1531 136.949ZM54.1523 136.226L56.9964 140.69L57.6711 140.26L54.827 135.796L54.1523 136.226Z",
    fill: "white",
    mask: "url(#path-781-inside-53_1396_24002)"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M53.0384 53.2972L52.5381 56.2377L50.0147 59.381L50.6134 56.3902L53.0384 53.2972Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M129.37 91.4012L129.858 90.0574L131.673 88.0917L131.153 89.5969L129.37 91.4012Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M147.951 79.0689L148.885 80.4769L148.324 83.9836L147.399 82.6395L147.951 79.0689Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M147.311 104.981L142.629 107.225L142.984 105.398L147.691 103.018L147.311 104.981Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5064 45.5115L60.2252 48.0033L57.2201 49.3585L58.8078 46.7572L61.5064 45.5115Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask54 || (_mask54 = /*#__PURE__*/React.createElement("mask", {
    id: "path-788-inside-54_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.923 120.199L127.614 118.329L129.071 118.133L121.302 120.068L119.923 120.199Z"
  }))), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M119.923 120.199L119.828 119.811L119.961 120.598L119.923 120.199ZM127.614 118.329L127.56 117.933L127.539 117.936L127.519 117.941L127.614 118.329ZM129.071 118.133L129.167 118.521L129.017 117.737L129.071 118.133ZM121.302 120.068L121.34 120.466L121.37 120.463L121.399 120.456L121.302 120.068ZM120.017 120.588L127.708 118.718L127.519 117.941L119.828 119.811L120.017 120.588ZM127.667 118.726L129.124 118.53L129.017 117.737L127.56 117.933L127.667 118.726ZM128.974 117.745L121.206 119.68L121.399 120.456L129.167 118.521L128.974 117.745ZM121.264 119.67L119.885 119.801L119.961 120.598L121.34 120.466L121.264 119.67Z",
    fill: "white",
    mask: "url(#path-788-inside-54_1396_24002)"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M123.891 98.7609L124.131 96.8435L128.056 94.9485L127.797 97.0016L123.891 98.7609Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M112.582 113.47L111.92 111.807L118.781 110.318L119.475 111.966L112.582 113.47Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask55 || (_mask55 = /*#__PURE__*/React.createElement("mask", {
    id: "path-792-inside-55_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.2997 123.211L49.9941 125.388L48.4567 119.48L47.701 117.069L49.2997 123.211Z"
  }))), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2997 123.211L48.9126 123.312L48.9154 123.322L48.9186 123.333L49.2997 123.211ZM49.9941 125.388L49.613 125.509L50.3812 125.287L49.9941 125.388ZM48.4567 119.48L48.8438 119.379L48.8413 119.37L48.8384 119.361L48.4567 119.48ZM47.701 117.069L48.0827 116.95L47.3139 117.17L47.701 117.069ZM48.9186 123.333L49.613 125.509L50.3751 125.266L49.6808 123.089L48.9186 123.333ZM50.3812 125.287L48.8438 119.379L48.0696 119.581L49.6069 125.488L50.3812 125.287ZM48.8384 119.361L48.0827 116.95L47.3194 117.189L48.075 119.6L48.8384 119.361ZM47.3139 117.17L48.9126 123.312L49.6868 123.11L48.0882 116.969L47.3139 117.17Z",
    fill: "white",
    mask: "url(#path-792-inside-55_1396_24002)"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M139.564 113.158L133.442 115.023L134.128 113.979L140.306 112.019L139.564 113.158Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M67.476 149.501L70.578 150.501L70.4746 150.583L67.4084 149.595L67.476 149.501Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M118.002 105.333L117.837 103.378L123.419 101.782L123.586 103.804L118.002 105.333Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M134.804 82.5285L135.184 79.8237L136.16 78.6406L135.764 81.4888L134.804 82.5285Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2574 78.2646L45.0654 83.3457L44.3626 80.2627L45.563 75.1167L46.2574 78.2646Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M92.683 111.639L93.1624 106.929L93.3628 108.827L92.8829 113.52L92.683 111.639Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask56 || (_mask56 = /*#__PURE__*/React.createElement("mask", {
    id: "path-800-inside-56_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.303 120.07L129.071 118.135L130.473 117.567L122.629 119.568L121.303 120.07Z"
  }))), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M121.303 120.07L121.161 119.696L121.399 120.458L121.303 120.07ZM129.071 118.135L129.168 118.523L129.195 118.516L129.221 118.506L129.071 118.135ZM130.473 117.567L130.623 117.938L130.374 117.18L130.473 117.567ZM122.629 119.568L122.53 119.181L122.508 119.186L122.487 119.194L122.629 119.568ZM121.399 120.458L129.168 118.523L128.974 117.747L121.206 119.682L121.399 120.458ZM129.221 118.506L130.623 117.938L130.322 117.197L128.921 117.764L129.221 118.506ZM130.374 117.18L122.53 119.181L122.727 119.956L130.571 117.955L130.374 117.18ZM122.487 119.194L121.161 119.696L121.444 120.444L122.77 119.942L122.487 119.194Z",
    fill: "white",
    mask: "url(#path-800-inside-56_1396_24002)"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M146.533 77.4615L147.62 78.5942L147.053 82.2608L145.979 81.1623L146.533 77.4615Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M150.205 89.4712L150.668 91.574L147.944 94.5446L147.49 92.5699L150.205 89.4712Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "M90.226 85.0474L89.2713 79.2466L90.136 80.7816L91.2009 86.6703L90.226 85.0474Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask57 || (_mask57 = /*#__PURE__*/React.createElement("mask", {
    id: "path-805-inside-57_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4899 136.012L54.7667 137.053L52.4131 132.218L52.0226 130.942L54.4899 136.012Z"
  }))), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4899 136.012L54.8765 135.909L54.8665 135.872L54.8496 135.837L54.4899 136.012ZM54.7667 137.053L54.4071 137.228L55.1533 136.95L54.7667 137.053ZM52.4131 132.218L52.0306 132.335L52.0398 132.365L52.0534 132.393L52.4131 132.218ZM52.0226 130.942L52.3823 130.767L51.6401 131.059L52.0226 130.942ZM54.1033 136.114L54.3801 137.156L55.1533 136.95L54.8765 135.909L54.1033 136.114ZM55.1264 136.878L52.7727 132.043L52.0534 132.393L54.4071 137.228L55.1264 136.878ZM52.7956 132.101L52.4051 130.825L51.6401 131.059L52.0306 132.335L52.7956 132.101ZM51.6629 131.117L54.1302 136.187L54.8496 135.837L52.3823 130.767L51.6629 131.117Z",
    fill: "white",
    mask: "url(#path-805-inside-57_1396_24002)"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5322 102.761L45.9965 104.319L46.3323 108.999L45.877 107.538L45.5322 102.761Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "M111.788 111.425L111.275 109.614L118.113 108.129L118.648 109.936L111.788 111.425Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8783 135.316L89.9285 131.325L90.0471 133.539L88.0309 137.453L87.8783 135.316Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask58 || (_mask58 = /*#__PURE__*/React.createElement("mask", {
    id: "path-810-inside-58_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.5797 63.0692L85.0098 65.1386L87.1999 71.4409L86.4643 69.2988L84.5797 63.0692Z"
  }))), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5797 63.0692L84.9625 62.9534L84.188 63.1506L84.5797 63.0692ZM85.0098 65.1386L84.6181 65.22L84.6234 65.2454L84.6319 65.2699L85.0098 65.1386ZM87.1999 71.4409L86.8221 71.5722L87.5782 71.311L87.1999 71.4409ZM86.4643 69.2988L86.0814 69.4146L86.0836 69.4217L86.086 69.4287L86.4643 69.2988ZM84.188 63.1506L84.6181 65.22L85.4014 65.0572L84.9713 62.9878L84.188 63.1506ZM84.6319 65.2699L86.8221 71.5722L87.5777 71.3096L85.3876 65.0073L84.6319 65.2699ZM87.5782 71.311L86.8426 69.1689L86.086 69.4287L86.8216 71.5709L87.5782 71.311ZM86.8472 69.183L84.9625 62.9534L84.1968 63.185L86.0814 69.4146L86.8472 69.183Z",
    fill: "white",
    mask: "url(#path-810-inside-58_1396_24002)"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M136.218 81.1362L136.644 78.0732L137.776 77.1112L137.334 80.3088L136.218 81.1362Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M130.537 88.7343L130.883 88.0625L132.41 86.3103L132.006 87.1428L130.537 88.7343Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6371 45.4666L72.5275 47.1623L69.3272 45.4392L70.8758 43.6879L73.6371 45.4666Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M147.774 102.527L143.035 104.924L143.198 102.974L147.953 100.446L147.774 102.527Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M146.178 77.1227L145.614 80.8856L144.425 80.0825L144.975 76.3179L146.178 77.1227Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M124.237 96.3467L124.659 94.5863L128.577 92.5683L128.126 94.4691L124.237 96.3467Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M140.634 111.501L134.372 113.488L134.992 112.147L141.3 110.065L140.634 111.501Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M117.829 102.969L117.861 101.034L123.442 99.3612L123.401 101.375L117.829 102.969Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M107.186 119.897L115.127 118.006L116.048 118.808L108.127 120.716L107.186 119.897Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M105.912 118.455L113.916 116.575L114.821 117.667L106.836 119.569L105.912 118.455Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M137.769 80.0907L138.231 76.7482L139.472 76.0879L138.991 79.547L137.769 80.0907Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5847 148.77L81.4317 147.272L81.1425 148.007L78.3676 149.464L78.5847 148.77Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M130.389 117.381L123.653 119.099L123.953 118.89L130.77 117.111L130.389 117.381Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M116.439 119.128L117.297 119.624L109.481 121.523L108.604 121.016L116.439 119.128Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0592 150.627L73.8883 150.788L73.875 150.796L71.05 150.635L71.0592 150.627Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M143.32 75.6676L144.601 76.1102L144.047 79.9034L142.783 79.4298L143.32 75.6676Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M111.186 109.224L110.843 107.319L117.664 105.83L118.02 107.74L111.186 109.224Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M104.789 116.736L112.836 114.875L113.673 116.226L105.644 118.112L104.789 116.736Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M139.41 79.4406L139.903 75.8889L141.204 75.5789L140.692 79.2228L139.41 79.4406Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M149.418 87.0437L150.087 88.9959L147.346 92.125L146.694 90.2801L149.418 87.0437Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M141.096 79.2169L141.615 75.5251L142.928 75.5898L142.392 79.3443L141.096 79.2169Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M117.826 119.908L118.471 120.106L110.871 121.964L110.207 121.76L117.826 119.908Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask59 || (_mask59 = /*#__PURE__*/React.createElement("mask", {
    id: "path-834-inside-59_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.943 86.2335L134.517 83.1379L133.246 85.0461L130.717 87.9477L131.943 86.2335Z"
  }))), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M131.943 86.2335L131.636 85.9778L131.626 85.989L131.618 86.0009L131.943 86.2335ZM134.517 83.1379L134.85 83.3597L134.21 82.8822L134.517 83.1379ZM133.246 85.0461L133.548 85.3089L133.565 85.2894L133.579 85.2679L133.246 85.0461ZM130.717 87.9477L130.392 87.715L131.019 88.2105L130.717 87.9477ZM132.251 86.4893L134.825 83.3937L134.21 82.8822L131.636 85.9778L132.251 86.4893ZM134.184 82.9162L132.913 84.8244L133.579 85.2679L134.85 83.3597L134.184 82.9162ZM132.945 84.7833L130.416 87.6849L131.019 88.2105L133.548 85.3089L132.945 84.7833ZM131.043 88.1803L132.269 86.4662L131.618 86.0009L130.392 87.715L131.043 88.1803Z",
    fill: "white",
    mask: "url(#path-834-inside-59_1396_24002)"
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4604 63.4659L82.5774 59.388L82.5517 58.5377L84.3899 63.1266L84.4604 63.4659Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M103.836 114.771L111.917 112.935L112.646 114.507L104.584 116.371L103.836 114.771Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2919 64.8961L49.5367 60.7813L49.9449 64.0396L47.7025 68.1322L47.2919 64.8961Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4212 94.7291L91.9796 89.7959L92.3226 90.9974L92.7821 95.9702L92.4212 94.7291Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0034 50.1195L72.8576 47.3895L73.9464 45.7257L76.6729 48.5055L76.0034 50.1195Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1382 85.2923L45.9048 88.1749L45.2661 93.4032L44.4919 90.6259L45.1382 85.2923Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask60 || (_mask60 = /*#__PURE__*/React.createElement("mask", {
    id: "path-842-inside-60_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.0228 130.945L52.4133 132.22L50.4788 126.924L49.9941 125.39L52.0228 130.945Z"
  }))), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0228 130.945L52.4052 130.828L52.4021 130.817L52.3985 130.807L52.0228 130.945ZM52.4133 132.22L52.0375 132.358L52.7958 132.103L52.4133 132.22ZM50.4788 126.924L50.0974 127.044L50.1001 127.053L50.1031 127.061L50.4788 126.924ZM49.9941 125.39L50.3699 125.252L49.6127 125.51L49.9941 125.39ZM51.6403 131.062L52.0308 132.338L52.7958 132.103L52.4052 130.828L51.6403 131.062ZM52.789 132.083L50.8545 126.787L50.1031 127.061L52.0375 132.358L52.789 132.083ZM50.8602 126.803L50.3756 125.269L49.6127 125.51L50.0974 127.044L50.8602 126.803ZM49.6184 125.527L51.647 131.082L52.3985 130.807L50.3699 125.252L49.6184 125.527Z",
    fill: "white",
    mask: "url(#path-842-inside-60_1396_24002)"
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M147.982 99.978L143.201 102.52L143.161 100.51L147.946 97.8462L147.982 99.978Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask61 || (_mask61 = /*#__PURE__*/React.createElement("mask", {
    id: "path-845-inside-61_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.273 122.227L120.618 120.18L119.225 120.125L110.864 122.169L112.273 122.227Z"
  }))), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M112.273 122.227L112.257 122.627L112.313 122.629L112.368 122.615L112.273 122.227ZM120.618 120.18L120.713 120.569L120.634 119.781L120.618 120.18ZM119.225 120.125L119.241 119.725L119.184 119.723L119.13 119.736L119.225 120.125ZM110.864 122.169L110.769 121.781L110.847 122.569L110.864 122.169ZM112.368 122.615L120.713 120.569L120.523 119.792L112.178 121.838L112.368 122.615ZM120.634 119.781L119.241 119.725L119.209 120.525L120.602 120.58L120.634 119.781ZM119.13 119.736L110.769 121.781L110.959 122.558L119.32 120.513L119.13 119.736ZM110.847 122.569L112.257 122.627L112.29 121.827L110.88 121.77L110.847 122.569Z",
    fill: "white",
    mask: "url(#path-845-inside-61_1396_24002)"
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1187 44.9465L64.106 47.4732L60.7231 47.9102L62.0784 45.2743L65.1187 44.9465Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M124.853 94.0362L125.419 92.5086L129.316 90.3803L128.711 92.0491L124.853 94.0362Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M141.516 109.569L135.155 111.669L135.65 110.087L142.047 107.894L141.516 109.569Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M131.677 116.461L124.484 118.339L125.094 117.686L132.343 115.753L131.677 116.461Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "M85.256 142.009L87.6145 138.87L87.4689 140.384L85.1642 143.445L85.256 142.009Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7761 121.606L92.819 116.715L93.0691 119.054L92.034 123.89L91.7761 121.606Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M117.898 100.601L118.123 98.7473L123.708 96.9922L123.465 98.9327L117.898 100.601Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask62 || (_mask62 = /*#__PURE__*/React.createElement("mask", {
    id: "path-854-inside-62_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7015 117.069L48.4571 119.479L47.453 113.363L46.6559 110.707L47.7015 117.069Z"
  }))), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7015 117.069L47.3068 117.133L47.3114 117.161L47.3198 117.188L47.7015 117.069ZM48.4571 119.479L48.0755 119.599L48.8519 119.415L48.4571 119.479ZM47.453 113.363L47.8477 113.298L47.8435 113.272L47.8361 113.248L47.453 113.363ZM46.6559 110.707L47.0391 110.592L46.2612 110.772L46.6559 110.707ZM47.3198 117.188L48.0755 119.599L48.8388 119.36L48.0832 116.949L47.3198 117.188ZM48.8519 119.415L47.8477 113.298L47.0582 113.427L48.0624 119.544L48.8519 119.415ZM47.8361 113.248L47.0391 110.592L46.2728 110.822L47.0698 113.478L47.8361 113.248ZM46.2612 110.772L47.3068 117.133L48.0962 117.004L47.0506 110.642L46.2612 110.772Z",
    fill: "white",
    mask: "url(#path-854-inside-62_1396_24002)"
  })), _mask63 || (_mask63 = /*#__PURE__*/React.createElement("mask", {
    id: "path-856-inside-63_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.7143 147.709L63.3617 147.439L60.3103 144.774L60.4871 144.891L63.7143 147.709Z"
  }))), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7143 147.709L63.471 148.027L63.9774 147.408L63.7143 147.709ZM63.3617 147.439L63.0986 147.741L63.1082 147.749L63.1184 147.757L63.3617 147.439ZM60.3103 144.774L60.5306 144.441L60.0472 145.076L60.3103 144.774ZM60.4871 144.891L60.7502 144.59L60.7299 144.572L60.7074 144.557L60.4871 144.891ZM63.9576 147.392L63.605 147.122L63.1184 147.757L63.471 148.027L63.9576 147.392ZM63.6248 147.138L60.5734 144.473L60.0472 145.076L63.0986 147.741L63.6248 147.138ZM60.09 145.108L60.2668 145.225L60.7074 144.557L60.5306 144.441L60.09 145.108ZM60.224 145.192L63.4512 148.011L63.9774 147.408L60.7502 144.59L60.224 145.192Z",
    fill: "white",
    mask: "url(#path-856-inside-63_1396_24002)"
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M110.79 106.92L110.628 104.979L117.443 103.476L117.607 105.431L110.79 106.92Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask64 || (_mask64 = /*#__PURE__*/React.createElement("mask", {
    id: "path-859-inside-64_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.4858 144.894L60.309 144.777L57.4659 141.391L57.4789 141.312L60.4858 144.894Z"
  }))), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4858 144.894L60.2655 145.228L60.7921 144.637L60.4858 144.894ZM60.309 144.777L60.0026 145.034L60.0401 145.079L60.0887 145.111L60.309 144.777ZM57.4659 141.391L57.0712 141.326L57.0412 141.507L57.1595 141.648L57.4659 141.391ZM57.4789 141.312L57.7852 141.055L57.2261 140.389L57.0842 141.247L57.4789 141.312ZM60.706 144.56L60.5292 144.443L60.0887 145.111L60.2655 145.228L60.706 144.56ZM60.6153 144.52L57.7722 141.134L57.1595 141.648L60.0026 145.034L60.6153 144.52ZM57.8605 141.456L57.8735 141.378L57.0842 141.247L57.0712 141.326L57.8605 141.456ZM57.1725 141.569L60.1794 145.151L60.7921 144.637L57.7852 141.055L57.1725 141.569Z",
    fill: "white",
    mask: "url(#path-859-inside-64_1396_24002)"
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M103.072 112.621L111.178 110.814L111.769 112.559L103.68 114.397L103.072 112.621Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M148.401 84.8753L149.256 86.6155L146.511 89.8777L145.679 88.22L148.401 84.8753Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1548 58.6831L79.5831 54.4535L79.8276 53.1067L82.118 57.4676L82.1548 58.6831Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "M79.253 54.0303L76.3105 50.4189L76.9516 48.8733L79.5223 52.5465L79.253 54.0303Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4457 50.2807L56.0265 53.3959L53.0126 55.8294L53.5526 52.6547L56.4457 50.2807Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask65 || (_mask65 = /*#__PURE__*/React.createElement("mask", {
    id: "path-866-inside-65_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.331 84.8538L135.954 81.5802L134.517 83.1361L131.943 86.2318L133.331 84.8538Z"
  }))), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M133.331 84.8538L133.613 85.1376L133.629 85.1217L133.643 85.104L133.331 84.8538ZM135.954 81.5802L136.267 81.8303L135.661 81.3088L135.954 81.5802ZM134.517 83.1361L134.223 82.8647L134.216 82.8724L134.21 82.8804L134.517 83.1361ZM131.943 86.2318L131.636 85.976L132.225 86.5156L131.943 86.2318ZM133.643 85.104L136.267 81.8303L135.642 81.3301L133.019 84.6037L133.643 85.104ZM135.661 81.3088L134.223 82.8647L134.811 83.4076L136.248 81.8516L135.661 81.3088ZM134.21 82.8804L131.636 85.976L132.251 86.4875L134.825 83.3919L134.21 82.8804ZM132.225 86.5156L133.613 85.1376L133.049 84.57L131.662 85.9479L132.225 86.5156Z",
    fill: "white",
    mask: "url(#path-866-inside-65_1396_24002)"
  })), _mask66 || (_mask66 = /*#__PURE__*/React.createElement("mask", {
    id: "path-868-inside-66_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.0843 149.698L66.5477 149.319L63.3621 147.44L63.7147 147.711L67.0843 149.698Z"
  }))), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0843 149.698L66.8811 150.042L67.3149 149.371L67.0843 149.698ZM66.5477 149.319L66.7784 148.992L66.765 148.983L66.7509 148.974L66.5477 149.319ZM63.3621 147.44L63.5652 147.096L63.1188 147.758L63.3621 147.44ZM63.7147 147.711L63.4714 148.028L63.4907 148.043L63.5115 148.055L63.7147 147.711ZM67.3149 149.371L66.7784 148.992L66.3171 149.646L66.8536 150.024L67.3149 149.371ZM66.7509 148.974L63.5652 147.096L63.1589 147.785L66.3446 149.663L66.7509 148.974ZM63.1188 147.758L63.4714 148.028L63.958 147.393L63.6053 147.123L63.1188 147.758ZM63.5115 148.055L66.8811 150.042L67.2875 149.353L63.9179 147.366L63.5115 148.055Z",
    fill: "white",
    mask: "url(#path-868-inside-66_1396_24002)"
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0784 78.0884L87.8489 73.1931L88.2694 74.0407L89.6961 79.1849L89.0784 78.0884Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask67 || (_mask67 = /*#__PURE__*/React.createElement("mask", {
    id: "path-871-inside-67_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.642 121.906L121.973 119.862L120.616 120.18L112.271 122.226L113.642 121.906Z"
  }))), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M113.642 121.906L113.733 122.295L113.738 122.294L113.642 121.906ZM121.973 119.862L122.068 120.251L121.882 119.473L121.973 119.862ZM120.616 120.18L120.525 119.79L120.521 119.791L120.616 120.18ZM112.271 122.226L112.176 121.838L112.362 122.616L112.271 122.226ZM113.738 122.294L122.068 120.251L121.878 119.474L113.547 121.517L113.738 122.294ZM121.882 119.473L120.525 119.79L120.707 120.569L122.064 120.252L121.882 119.473ZM120.521 119.791L112.176 121.838L112.367 122.615L120.711 120.568L120.521 119.791ZM112.362 122.616L113.733 122.295L113.551 121.516L112.18 121.837L112.362 122.616Z",
    fill: "white",
    mask: "url(#path-871-inside-67_1396_24002)"
  })), _mask68 || (_mask68 = /*#__PURE__*/React.createElement("mask", {
    id: "path-873-inside-68_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4786 141.312L57.4657 141.391L54.9001 137.365L54.765 137.054L57.4786 141.312Z"
  }))), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4786 141.312L57.8733 141.378L57.8982 141.227L57.816 141.098L57.4786 141.312ZM57.4657 141.391L57.1283 141.606L57.6899 142.487L57.8603 141.456L57.4657 141.391ZM54.9001 137.365L54.5332 137.524L54.5457 137.553L54.5627 137.579L54.9001 137.365ZM54.765 137.054L55.1024 136.839L54.3981 137.213L54.765 137.054ZM57.084 141.247L57.071 141.326L57.8603 141.456L57.8733 141.378L57.084 141.247ZM57.803 141.176L55.2374 137.15L54.5627 137.579L57.1283 141.606L57.803 141.176ZM55.267 137.205L55.1319 136.894L54.3981 137.213L54.5332 137.524L55.267 137.205ZM54.4277 137.269L57.1413 141.527L57.816 141.098L55.1024 136.839L54.4277 137.269Z",
    fill: "white",
    mask: "url(#path-873-inside-68_1396_24002)"
  })), _mask69 || (_mask69 = /*#__PURE__*/React.createElement("mask", {
    id: "path-875-inside-69_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0309 149.863L77.2249 150.271L73.9215 150.998L74.5665 150.625L78.0309 149.863Z"
  }))), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0309 149.863L78.2117 150.219L77.9449 149.472L78.0309 149.863ZM77.2249 150.271L77.3108 150.662L77.3604 150.651L77.4057 150.628L77.2249 150.271ZM73.9215 150.998L73.7215 150.651L74.0074 151.388L73.9215 150.998ZM74.5665 150.625L74.4805 150.235L74.4201 150.248L74.3665 150.279L74.5665 150.625ZM77.8501 149.506L77.0441 149.914L77.4057 150.628L78.2117 150.219L77.8501 149.506ZM77.1389 149.88L73.8356 150.607L74.0074 151.388L77.3108 150.662L77.1389 149.88ZM74.1215 151.344L74.7665 150.972L74.3665 150.279L73.7215 150.651L74.1215 151.344ZM74.6525 151.016L78.1169 150.253L77.9449 149.472L74.4805 150.235L74.6525 151.016Z",
    fill: "white",
    mask: "url(#path-875-inside-69_1396_24002)"
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M147.926 97.4008L143.12 100.076L142.871 98.0703L147.672 95.2856L147.926 97.4008Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M102.962 112.235L102.516 110.337L110.641 108.562L111.071 110.428L102.962 112.235Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M147.177 83.0259L148.192 84.5006L145.454 87.8652L144.469 86.4462L147.177 83.0259Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M132.843 115.204L125.434 117.18L126.084 116.173L133.541 114.144L132.843 115.204Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M125.748 91.8743L126.39 90.6668L130.229 88.4598L129.535 89.8059L125.748 91.8743Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4785 122.085L106.709 120.013L107.655 120.838L99.4749 122.953L98.4785 122.085Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M142.181 107.429L135.748 109.634L136.082 107.867L142.541 105.573L142.181 107.429Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1559 120.589L105.477 118.563L106.405 119.68L98.132 121.762L97.1559 120.589Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "M134.291 83.9783L136.095 81.7267L136.458 81.4577L134.707 83.7018L134.291 83.9783Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "M110.617 104.57L110.641 102.655L117.458 101.129L117.425 103.068L110.617 104.57Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M118.213 98.2981L118.615 96.5901L124.208 94.7493L123.776 96.5501L118.213 98.2981Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask70 || (_mask70 = /*#__PURE__*/React.createElement("mask", {
    id: "path-888-inside-70_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.513 150.805L69.7885 150.366L66.5457 149.321L67.0823 149.7L70.513 150.805Z"
  }))), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "M70.513 150.805L70.3903 151.186L70.7205 150.463L70.513 150.805ZM69.7885 150.366L69.996 150.024L69.9559 149.999L69.9112 149.985L69.7885 150.366ZM66.5457 149.321L66.6684 148.94L66.3151 149.648L66.5457 149.321ZM67.0823 149.7L66.8516 150.026L66.9015 150.062L66.9596 150.08L67.0823 149.7ZM70.7205 150.463L69.996 150.024L69.5811 150.708L70.3055 151.147L70.7205 150.463ZM69.9112 149.985L66.6684 148.94L66.423 149.702L69.6658 150.746L69.9112 149.985ZM66.3151 149.648L66.8516 150.026L67.3129 149.373L66.7764 148.994L66.3151 149.648ZM66.9596 150.08L70.3903 151.186L70.6357 150.425L67.205 149.319L66.9596 150.08Z",
    fill: "white",
    mask: "url(#path-888-inside-70_1396_24002)"
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M108.044 121.15L108.932 121.665L100.884 123.79L99.9449 123.245L108.044 121.15Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5124 95.7693L46.1341 97.9795L46.0217 103.007L45.4005 100.924L45.5124 95.7693Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9883 118.793L104.378 116.828L105.236 118.207L96.8909 120.239L95.9883 118.793Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask71 || (_mask71 = /*#__PURE__*/React.createElement("mask", {
    id: "path-893-inside-71_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.941 121.214L123.26 119.179L121.974 119.862L113.643 121.905L114.941 121.214Z"
  }))), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M114.941 121.214L114.846 120.825L114.797 120.837L114.752 120.861L114.941 121.214ZM123.26 119.179L123.448 119.532L123.165 118.79L123.26 119.179ZM121.974 119.862L122.069 120.25L122.117 120.238L122.161 120.215L121.974 119.862ZM113.643 121.905L113.455 121.552L113.738 122.294L113.643 121.905ZM115.036 121.602L123.355 119.567L123.165 118.79L114.846 120.825L115.036 121.602ZM123.072 118.825L121.786 119.508L122.161 120.215L123.448 119.532L123.072 118.825ZM121.878 119.473L113.548 121.517L113.738 122.294L122.069 120.25L121.878 119.473ZM113.831 122.258L115.129 121.567L114.752 120.861L113.455 121.552L113.831 122.258Z",
    fill: "white",
    mask: "url(#path-893-inside-71_1396_24002)"
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3586 104.978L93.3659 101.768L93.3812 101.913L93.3731 105.115L93.3586 104.978Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2501 72.8824L46.5116 77.5612L45.7764 74.2286L47.5295 69.4864L48.2501 72.8824Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9817 146.961L84.3632 144.86L84.1259 145.391L81.7893 147.45L81.9817 146.961Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M145.784 81.5334L146.924 82.6991L144.207 86.1312L143.102 84.9932L145.784 81.5334Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M109.447 121.94L110.139 122.153L102.324 124.247L101.581 124.017L109.447 121.94Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2918 130.608L91.8164 126.199L91.8973 128.228L90.3962 132.558L90.2918 130.608Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask72 || (_mask72 = /*#__PURE__*/React.createElement("mask", {
    id: "path-901-inside-72_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 125.389L50.4769 126.923L49.0117 121.292L48.4548 119.481L49.9922 125.389Z"
  }))), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9922 125.389L49.6051 125.49L49.6077 125.499L49.6108 125.509L49.9922 125.389ZM50.4769 126.923L50.0955 127.043L50.864 126.822L50.4769 126.923ZM49.0117 121.292L49.3988 121.191L49.3966 121.183L49.394 121.174L49.0117 121.292ZM48.4548 119.481L48.8372 119.364L48.0677 119.582L48.4548 119.481ZM49.6108 125.509L50.0955 127.043L50.8583 126.802L50.3736 125.268L49.6108 125.509ZM50.864 126.822L49.3988 121.191L48.6246 121.393L50.0898 127.024L50.864 126.822ZM49.394 121.174L48.8372 119.364L48.0725 119.599L48.6293 121.41L49.394 121.174ZM48.0677 119.582L49.6051 125.49L50.3793 125.288L48.8419 119.381L48.0677 119.582Z",
    fill: "white",
    mask: "url(#path-901-inside-72_1396_24002)"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M135.44 83.4122L137.648 80.5829L138.537 80.1875L136.319 83.0805L135.44 83.4122Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask73 || (_mask73 = /*#__PURE__*/React.createElement("mask", {
    id: "path-904-inside-73_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.7664 137.052L54.9014 137.363L52.6766 132.792L52.4128 132.217L54.7664 137.052Z"
  }))), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7664 137.052L55.1333 136.893L55.1298 136.885L55.126 136.877L54.7664 137.052ZM54.9014 137.363L54.5418 137.538L55.2683 137.204L54.9014 137.363ZM52.6766 132.792L52.3129 132.959L52.317 132.967L52.6766 132.792ZM52.4128 132.217L52.7724 132.041L52.0492 132.383L52.4128 132.217ZM54.3995 137.211L54.5345 137.522L55.2683 137.204L55.1333 136.893L54.3995 137.211ZM55.2611 137.188L53.0363 132.617L52.317 132.967L54.5418 137.538L55.2611 137.188ZM53.0402 132.626L52.7764 132.05L52.0492 132.383L52.313 132.959L53.0402 132.626ZM52.0531 132.392L54.4067 137.227L55.126 136.877L52.7724 132.041L52.0531 132.392Z",
    fill: "white",
    mask: "url(#path-904-inside-73_1396_24002)"
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9938 116.756L103.438 114.863L104.187 116.466L95.7828 118.434L94.9938 116.756Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M110.568 108.167L102.444 109.941L102.177 107.977L110.315 106.236L110.568 108.167Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7606 45.6453L68.0914 48.099L64.5262 47.4988L65.5509 44.9419L68.7606 45.6453Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M147.605 94.8593L142.789 97.6532L142.336 95.7147L147.138 92.8268L147.605 94.8593Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M141.611 83.9098L144.255 80.4513L145.477 81.277L142.795 84.7363L141.611 83.9098Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M126.979 89.8668L127.545 89.1088L131.22 86.9021L130.58 87.7967L126.979 89.8668Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "M136.887 82.9922L139.283 79.8657L140.403 79.6755L137.977 82.8691L136.887 82.9922Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "M103.633 124.316L110.887 122.373L110.964 122.376L103.759 124.321L103.633 124.316Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M133.857 113.644L126.313 115.696L126.899 114.389L134.484 112.289L133.857 113.644Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M140.044 83.209L142.633 79.7991L143.888 80.2693L141.259 83.7076L140.044 83.209Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M138.45 82.9131L140.961 79.6077L142.187 79.7284L139.639 83.0853L138.45 82.9131Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M142.618 105.121L136.133 107.424L136.283 105.531L142.783 103.146L142.618 105.121Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "M110.675 102.242L110.881 100.412L117.708 98.8558L117.483 100.718L110.675 102.242Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path845 || (_path845 = /*#__PURE__*/React.createElement("path", {
    d: "M118.776 96.1166L119.327 94.6179L124.923 92.6933L124.332 94.2881L118.776 96.1166Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path846 || (_path846 = /*#__PURE__*/React.createElement("path", {
    d: "M115.687 120.828L116.229 120.352L123.696 118.536L123.167 118.998L115.687 120.828Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path847 || (_path847 = /*#__PURE__*/React.createElement("path", {
    d: "M94.835 116.381L94.1908 114.52L102.679 112.707L103.288 114.486L94.835 116.381Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask74 || (_mask74 = /*#__PURE__*/React.createElement("mask", {
    id: "path-922-inside-74_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.0112 65.1406L86.0273 67.6692L88.4561 73.9718L87.2014 71.443L85.0112 65.1406Z"
  }))), _path848 || (_path848 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0112 65.1406L85.3824 64.9915L84.6334 65.2719L85.0112 65.1406ZM86.0273 67.6692L86.4006 67.5253L86.3984 67.5201L86.0273 67.6692ZM88.4561 73.9718L88.0978 74.1496L88.8294 73.828L88.4561 73.9718ZM87.2014 71.443L86.8235 71.5743L86.8318 71.5981L86.8431 71.6208L87.2014 71.443ZM84.6401 65.2898L85.6561 67.8183L86.3984 67.5201L85.3824 64.9915L84.6401 65.2898ZM85.654 67.813L88.0829 74.1156L88.8294 73.828L86.4005 67.5254L85.654 67.813ZM88.8144 73.794L87.5597 71.2652L86.8431 71.6208L88.0978 74.1496L88.8144 73.794ZM87.5792 71.3117L85.3891 65.0093L84.6334 65.2719L86.8235 71.5743L87.5792 71.3117Z",
    fill: "white",
    mask: "url(#path-922-inside-74_1396_24002)"
  })), _mask75 || (_mask75 = /*#__PURE__*/React.createElement("mask", {
    id: "path-924-inside-75_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.3256 80.7168L91.2062 83.9641L92.5189 90.9655L91.5909 87.714L90.3256 80.7168Z"
  }))), _path849 || (_path849 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3256 80.7168L90.7116 80.6121L89.9319 80.788L90.3256 80.7168ZM91.2062 83.9641L91.5993 83.8904L91.5964 83.8747L91.5922 83.8594L91.2062 83.9641ZM92.5189 90.9655L92.1343 91.0753L92.9121 90.8918L92.5189 90.9655ZM91.5909 87.714L91.1973 87.7852L91.2009 87.8047L91.2063 87.8238L91.5909 87.714ZM89.9395 80.8215L90.8201 84.0688L91.5922 83.8594L90.7116 80.6121L89.9395 80.8215ZM90.813 84.0378L92.1258 91.0392L92.9121 90.8918L91.5993 83.8904L90.813 84.0378ZM92.9036 90.8558L91.9756 87.6043L91.2063 87.8238L92.1343 91.0753L92.9036 90.8558ZM91.9846 87.6429L90.7192 80.6456L89.9319 80.788L91.1973 87.7852L91.9846 87.6429Z",
    fill: "white",
    mask: "url(#path-924-inside-75_1396_24002)"
  })), _mask76 || (_mask76 = /*#__PURE__*/React.createElement("mask", {
    id: "path-926-inside-76_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.9231 151L73.011 150.549L69.79 150.366L70.5145 150.806L73.9231 151Z"
  }))), _path850 || (_path850 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9231 151L73.9003 151.399L74.1003 150.641L73.9231 151ZM73.011 150.549L73.1883 150.191L73.1151 150.154L73.0337 150.15L73.011 150.549ZM69.79 150.366L69.8127 149.967L69.5826 150.708L69.79 150.366ZM70.5145 150.806L70.307 151.148L70.3922 151.199L70.4917 151.205L70.5145 150.806ZM74.1003 150.641L73.1883 150.191L72.8337 150.908L73.7458 151.359L74.1003 150.641ZM73.0337 150.15L69.8127 149.967L69.7673 150.765L72.9883 150.948L73.0337 150.15ZM69.5826 150.708L70.307 151.148L70.722 150.464L69.9975 150.024L69.5826 150.708ZM70.4917 151.205L73.9003 151.399L73.9459 150.601L70.5373 150.406L70.4917 151.205Z",
    fill: "white",
    mask: "url(#path-926-inside-76_1396_24002)"
  })), _path851 || (_path851 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5328 106.23L46.8115 107.221L47.1222 111.573L46.8513 110.67L46.5328 106.23Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path852 || (_path852 = /*#__PURE__*/React.createElement("path", {
    d: "M110.279 105.837L102.144 107.577L102.064 105.607L110.209 103.901L110.279 105.837Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask77 || (_mask77 = /*#__PURE__*/React.createElement("mask", {
    id: "path-930-inside-77_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.198 124.19L113.643 121.908L112.272 122.229L103.779 124.522L105.198 124.19Z"
  }))), _path853 || (_path853 = /*#__PURE__*/React.createElement("path", {
    d: "M105.198 124.19L105.289 124.58L105.302 124.576L105.198 124.19ZM113.643 121.908L113.747 122.294L113.552 121.519L113.643 121.908ZM112.272 122.229L112.18 121.839L112.167 121.843L112.272 122.229ZM103.779 124.522L103.675 124.136L103.87 124.911L103.779 124.522ZM105.302 124.576L113.747 122.294L113.538 121.522L105.094 123.804L105.302 124.576ZM113.552 121.519L112.181 121.839L112.363 122.618L113.734 122.298L113.552 121.519ZM112.167 121.843L103.675 124.136L103.883 124.908L112.376 122.615L112.167 121.843ZM103.87 124.911L105.289 124.58L105.107 123.801L103.688 124.132L103.87 124.911Z",
    fill: "white",
    mask: "url(#path-930-inside-77_1396_24002)"
  })), _path854 || (_path854 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8668 60.2041L52.5862 56.8167L53.0068 60.2233L50.291 63.5905L49.8668 60.2041Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path855 || (_path855 = /*#__PURE__*/React.createElement("path", {
    d: "M147.03 92.426L142.217 95.3209L141.574 93.5104L146.363 90.5391L147.03 92.426Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path856 || (_path856 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4547 144.45L62.8449 146.537L62.9348 146.803L60.4945 144.672L60.4547 144.45Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask78 || (_mask78 = /*#__PURE__*/React.createElement("mask", {
    id: "path-935-inside-78_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.3013 148.148L80.3421 148.637L77.2263 150.273L78.0322 149.865L81.3013 148.148Z"
  }))), _path857 || (_path857 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3013 148.148L81.4872 148.502L81.1197 147.792L81.3013 148.148ZM80.3421 148.637L80.1605 148.281L80.1562 148.283L80.3421 148.637ZM77.2263 150.273L77.0403 149.919L77.4071 150.63L77.2263 150.273ZM78.0322 149.865L78.2131 150.222L78.2182 150.219L78.0322 149.865ZM81.1197 147.792L80.1605 148.281L80.5237 148.994L81.4829 148.505L81.1197 147.792ZM80.1562 148.283L77.0403 149.919L77.4122 150.627L80.5281 148.991L80.1562 148.283ZM77.4071 150.63L78.2131 150.222L77.8514 149.508L77.0454 149.916L77.4071 150.63ZM78.2182 150.219L81.4872 148.502L81.1153 147.794L77.8463 149.511L78.2182 150.219Z",
    fill: "white",
    mask: "url(#path-935-inside-78_1396_24002)"
  })), _path858 || (_path858 = /*#__PURE__*/React.createElement("path", {
    d: "M98.0096 122.207L99.017 123.085L91.0904 125.411L90.003 124.463L98.0096 122.207Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path859 || (_path859 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6025 122.872L96.7237 120.695L97.7064 121.876L89.6612 124.143L88.6025 122.872Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path860 || (_path860 = /*#__PURE__*/React.createElement("path", {
    d: "M57.671 141.275L59.9693 144.013L59.9802 144.074L57.6691 141.321L57.671 141.275Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path861 || (_path861 = /*#__PURE__*/React.createElement("path", {
    d: "M129.849 87.2541L131.934 85.9565L131.818 86.0716L129.849 87.2541Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path862 || (_path862 = /*#__PURE__*/React.createElement("path", {
    d: "M60.14 48.4771L59.8416 51.6455L56.4611 53.1708L56.8958 49.9402L60.14 48.4771Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path863 || (_path863 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3974 123.394L100.358 123.951L92.586 126.305L91.544 125.699L99.3974 123.394Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path864 || (_path864 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0796 138.241L89.9223 134.664L89.7698 135.946L87.9636 139.446L88.0796 138.241Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path865 || (_path865 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2775 82.3246L46.095 87.3348L45.2693 84.23L46.4697 79.1126L47.2775 82.3246Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask79 || (_mask79 = /*#__PURE__*/React.createElement("mask", {
    id: "path-945-inside-79_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.412 132.219L52.6759 132.795L50.8479 127.79L50.4775 126.923L52.412 132.219Z"
  }))), _path866 || (_path866 = /*#__PURE__*/React.createElement("path", {
    d: "M52.412 132.219L52.0363 132.357L52.0418 132.372L52.0484 132.386L52.412 132.219ZM52.6759 132.795L52.3123 132.962L53.0516 132.658L52.6759 132.795ZM50.8479 127.79L51.2236 127.652L51.2199 127.642L51.2157 127.633L50.8479 127.79ZM50.4775 126.923L50.8454 126.766L50.1018 127.06L50.4775 126.923ZM52.0484 132.386L52.3123 132.962L53.0395 132.628L52.7757 132.053L52.0484 132.386ZM53.0516 132.658L51.2236 127.652L50.4721 127.927L52.3002 132.932L53.0516 132.658ZM51.2157 127.633L50.8454 126.766L50.1097 127.08L50.48 127.947L51.2157 127.633ZM50.1018 127.06L52.0363 132.357L52.7878 132.082L50.8533 126.786L50.1018 127.06Z",
    fill: "white",
    mask: "url(#path-945-inside-79_1396_24002)"
  })), _path867 || (_path867 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0793 114.133L93.6043 112.144L102.126 110.418L102.572 112.32L94.0793 114.133Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path868 || (_path868 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3639 120.973L95.5776 118.896L96.4845 120.349L88.3412 122.532L87.3639 120.973Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path869 || (_path869 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3792 146.865L65.8487 148.321L66.0838 148.812L63.5276 147.305L63.3792 146.865Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path870 || (_path870 = /*#__PURE__*/React.createElement("path", {
    d: "M134.687 111.818L127.049 113.933L127.515 112.38L135.186 110.224L134.687 111.818Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path871 || (_path871 = /*#__PURE__*/React.createElement("path", {
    d: "M142.805 102.711L136.286 105.103L136.24 103.146L142.764 100.682L142.805 102.711Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path872 || (_path872 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0651 49.8656L68.4751 48.2173L69.1365 45.7925L72.3773 47.5372L72.0651 49.8656Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path873 || (_path873 = /*#__PURE__*/React.createElement("path", {
    d: "M116.636 119.841L117.302 118.971L124.986 117.119L124.328 117.971L116.636 119.841Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path874 || (_path874 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0854 115.447L93.5621 110.786L93.7416 112.53L93.2671 117.146L93.0854 115.447Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path875 || (_path875 = /*#__PURE__*/React.createElement("path", {
    d: "M100.855 124.217L101.644 124.461L94.1122 126.793L93.2425 126.523L100.855 124.217Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path876 || (_path876 = /*#__PURE__*/React.createElement("path", {
    d: "M119.59 94.1076L120.242 92.8828L125.822 90.8841L125.12 92.2056L119.59 94.1076Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path877 || (_path877 = /*#__PURE__*/React.createElement("path", {
    d: "M110.961 99.9831L111.338 98.2993L118.178 96.7062L117.773 98.43L110.961 99.9831Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask80 || (_mask80 = /*#__PURE__*/React.createElement("mask", {
    id: "path-958-inside-80_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.4651 141.389L57.4915 140.75L55.0874 136.977L54.8995 137.363L57.4651 141.389Z"
  }))), _path878 || (_path878 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4651 141.389L57.1278 141.604L57.8122 142.679L57.8648 141.406L57.4651 141.389ZM57.4915 140.75L57.8912 140.767L57.8964 140.641L57.8289 140.535L57.4915 140.75ZM55.0874 136.977L55.4248 136.762L55.0405 136.158L54.7277 136.802L55.0874 136.977ZM54.8995 137.363L54.5398 137.188L54.442 137.389L54.5622 137.578L54.8995 137.363ZM57.8648 141.406L57.8912 140.767L57.0919 140.734L57.0655 141.373L57.8648 141.406ZM57.8289 140.535L55.4248 136.762L54.7501 137.191L57.1542 140.965L57.8289 140.535ZM54.7277 136.802L54.5398 137.188L55.2592 137.538L55.4472 137.152L54.7277 136.802ZM54.5622 137.578L57.1278 141.604L57.8025 141.174L55.2369 137.148L54.5622 137.578Z",
    fill: "white",
    mask: "url(#path-958-inside-80_1396_24002)"
  })), _mask81 || (_mask81 = /*#__PURE__*/React.createElement("mask", {
    id: "path-960-inside-81_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.541 123.472L114.942 121.216L113.644 121.908L105.2 124.19L106.541 123.472Z"
  }))), _path879 || (_path879 = /*#__PURE__*/React.createElement("path", {
    d: "M106.541 123.472L106.437 123.086L106.393 123.098L106.352 123.12L106.541 123.472ZM114.942 121.216L115.13 121.569L114.838 120.83L114.942 121.216ZM113.644 121.908L113.749 122.294L113.792 122.282L113.833 122.261L113.644 121.908ZM105.2 124.19L105.011 123.837L105.304 124.576L105.2 124.19ZM106.644 123.859L115.046 121.602L114.838 120.83L106.437 123.086L106.644 123.859ZM114.754 120.863L113.456 121.555L113.833 122.261L115.13 121.569L114.754 120.863ZM113.54 121.522L105.095 123.804L105.304 124.576L113.749 122.294L113.54 121.522ZM105.388 124.542L106.729 123.825L106.352 123.12L105.011 123.837L105.388 124.542Z",
    fill: "white",
    mask: "url(#path-960-inside-81_1396_24002)"
  })), _path880 || (_path880 = /*#__PURE__*/React.createElement("path", {
    d: "M86.306 118.807L94.5951 116.847L95.3869 118.531L87.1602 120.612L86.306 118.807Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path881 || (_path881 = /*#__PURE__*/React.createElement("path", {
    d: "M145.362 88.4849L146.207 90.1682L141.411 93.1435L140.6 91.5165L145.362 88.4849Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path882 || (_path882 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3842 62.0934L83.2915 61.9132L83.2762 61.8595L83.3842 62.0934Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask82 || (_mask82 = /*#__PURE__*/React.createElement("mask", {
    id: "path-965-inside-82_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.177 86.8379L134.843 83.8516L133.33 84.8561L128.731 87.7181L130.177 86.8379Z"
  }))), _path883 || (_path883 = /*#__PURE__*/React.createElement("path", {
    d: "M130.177 86.8379L130.385 87.1796L130.392 87.1748L130.177 86.8379ZM134.843 83.8516L135.065 84.1848L134.628 83.5146L134.843 83.8516ZM133.33 84.8561L133.542 85.1959L133.551 85.1894L133.33 84.8561ZM128.731 87.7181L128.52 87.3785L128.939 88.0598L128.731 87.7181ZM130.392 87.1748L135.059 84.1885L134.628 83.5146L129.961 86.501L130.392 87.1748ZM134.622 83.5183L133.109 84.5229L133.551 85.1894L135.065 84.1848L134.622 83.5183ZM133.119 84.5165L128.52 87.3785L128.943 88.0578L133.542 85.1957L133.119 84.5165ZM128.939 88.0598L130.385 87.1795L129.968 86.4963L128.523 87.3765L128.939 88.0598Z",
    fill: "white",
    mask: "url(#path-965-inside-82_1396_24002)"
  })), _path884 || (_path884 = /*#__PURE__*/React.createElement("path", {
    d: "M110.212 103.487L102.073 105.192L102.181 103.277L110.328 101.605L110.212 103.487Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask83 || (_mask83 = /*#__PURE__*/React.createElement("mask", {
    id: "path-968-inside-83_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4572 119.481L49.0141 121.291L48.058 115.463L47.4531 113.364L48.4572 119.481Z"
  }))), _path885 || (_path885 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4572 119.481L48.0625 119.545L48.0669 119.572L48.0749 119.598L48.4572 119.481ZM49.0141 121.291L48.6317 121.409L49.4088 121.226L49.0141 121.291ZM48.058 115.463L48.4527 115.398L48.4489 115.375L48.4424 115.352L48.058 115.463ZM47.4531 113.364L47.8374 113.253L47.0583 113.429L47.4531 113.364ZM48.0749 119.598L48.6317 121.409L49.3964 121.174L48.8395 119.363L48.0749 119.598ZM49.4088 121.226L48.4527 115.398L47.6633 115.528L48.6193 121.356L49.4088 121.226ZM48.4424 115.352L47.8374 113.253L47.0687 113.475L47.6737 115.574L48.4424 115.352ZM47.0583 113.429L48.0625 119.545L48.8519 119.416L47.8478 113.299L47.0583 113.429Z",
    fill: "white",
    mask: "url(#path-968-inside-83_1396_24002)"
  })), _path886 || (_path886 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3824 148.515L68.9083 149.328L69.3309 150.008L66.6894 149.157L66.3824 148.515Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path887 || (_path887 = /*#__PURE__*/React.createElement("path", {
    d: "M95.269 126.85L102.345 124.658L102.628 124.67L95.6286 126.866L95.269 126.85Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path888 || (_path888 = /*#__PURE__*/React.createElement("path", {
    d: "M102.053 110.025L93.5299 111.751L93.2405 109.692L101.785 108.057L102.053 110.025Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path889 || (_path889 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6083 150.622L76.115 150.069L76.5232 150.223L73.9473 150.789L73.6083 150.622Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path890 || (_path890 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1467 118.431L85.4474 116.432L93.7976 114.603L94.4435 116.469L86.1467 118.431Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path891 || (_path891 = /*#__PURE__*/React.createElement("path", {
    d: "M144.167 86.709L145.159 88.1379L140.397 91.1694L139.445 89.7753L144.167 86.709Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path892 || (_path892 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9021 52.6985L72.4405 50.0699L72.7422 47.8193L75.8813 50.5435L75.9021 52.6985Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask84 || (_mask84 = /*#__PURE__*/React.createElement("mask", {
    id: "path-977-inside-84_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.6629 140.458L86.9266 142.011L84.291 145.51L84.9223 144.098L87.6629 140.458Z"
  }))), _path893 || (_path893 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6629 140.458L88.0243 140.629L87.3433 140.217L87.6629 140.458ZM86.9266 142.011L87.2461 142.252L87.2706 142.219L87.288 142.183L86.9266 142.011ZM84.291 145.51L83.9259 145.347L84.6105 145.751L84.291 145.51ZM84.9223 144.098L84.6027 143.858L84.5756 143.894L84.5571 143.935L84.9223 144.098ZM87.3014 140.287L86.5651 141.84L87.288 142.183L88.0243 140.629L87.3014 140.287ZM86.6071 141.771L83.9715 145.269L84.6105 145.751L87.2461 142.252L86.6071 141.771ZM84.6562 145.673L85.2875 144.262L84.5571 143.935L83.9259 145.347L84.6562 145.673ZM85.2419 144.339L87.9824 140.699L87.3433 140.217L84.6027 143.858L85.2419 144.339Z",
    fill: "white",
    mask: "url(#path-977-inside-84_1396_24002)"
  })), _path894 || (_path894 = /*#__PURE__*/React.createElement("path", {
    d: "M131.6 86.1632L132.093 85.8474L131.619 86.1568L131.6 86.1632Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path895 || (_path895 = /*#__PURE__*/React.createElement("path", {
    d: "M142.741 100.263L136.205 102.732L135.96 100.773L142.491 98.2421L142.741 100.263Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask85 || (_mask85 = /*#__PURE__*/React.createElement("mask", {
    id: "path-981-inside-85_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9007 137.363L55.0886 136.976L53.0043 132.693L52.6759 132.792L54.9007 137.363Z"
  }))), _path896 || (_path896 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9007 137.363L54.5411 137.538L54.9009 138.277L55.2604 137.538L54.9007 137.363ZM55.0886 136.976L55.4483 137.151L55.5334 136.976L55.4483 136.801L55.0886 136.976ZM53.0043 132.693L53.364 132.518L53.215 132.212L52.889 132.31L53.0043 132.693ZM52.6759 132.792L52.5606 132.409L52.1105 132.544L52.3162 132.967L52.6759 132.792ZM55.2604 137.538L55.4483 137.151L54.7289 136.801L54.541 137.188L55.2604 137.538ZM55.4483 136.801L53.364 132.518L52.6446 132.868L54.7289 137.151L55.4483 136.801ZM52.889 132.31L52.5606 132.409L52.7912 133.175L53.1196 133.076L52.889 132.31ZM52.3162 132.967L54.5411 137.538L55.2604 137.188L53.0356 132.617L52.3162 132.967Z",
    fill: "white",
    mask: "url(#path-981-inside-85_1396_24002)"
  })), _path897 || (_path897 = /*#__PURE__*/React.createElement("path", {
    d: "M135.316 109.773L127.609 111.939L127.921 110.196L135.652 107.995L135.316 109.773Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path898 || (_path898 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5468 124.596L90.6501 125.558L83.4228 128.077L82.2117 127.021L89.5468 124.596Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path899 || (_path899 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7104 125.31L88.1808 122.993L89.2493 124.275L81.8809 126.712L80.7104 125.31Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path900 || (_path900 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1788 89.2211L46.8793 91.896L46.2583 96.9397L45.5454 94.4055L46.1788 89.2211Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path901 || (_path901 = /*#__PURE__*/React.createElement("path", {
    d: "M120.664 92.3079L121.329 91.4299L126.842 89.3825L126.115 90.3556L120.664 92.3079Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path902 || (_path902 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9583 57.0075L79.7215 55.4477L82.1939 59.5141L82.5737 60.8472L79.9583 57.0075Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path903 || (_path903 = /*#__PURE__*/React.createElement("path", {
    d: "M117.573 118.491L118.211 117.292L125.993 115.439L125.359 116.615L117.573 118.491Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask86 || (_mask86 = /*#__PURE__*/React.createElement("mask", {
    id: "path-990-inside-86_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5186 90.9609L92.9281 94.857L93.5788 101.901L93.1721 98.0335L92.5186 90.9609Z"
  }))), _path904 || (_path904 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5186 90.9609L92.9164 90.9191L92.1203 90.9977L92.5186 90.9609ZM92.9281 94.857L93.3265 94.8202L93.326 94.8152L92.9281 94.857ZM93.5788 101.901L93.181 101.943L93.9771 101.864L93.5788 101.901ZM93.1721 98.0335L92.7737 98.0703L92.7743 98.0753L93.1721 98.0335ZM92.1207 91.0028L92.5303 94.8989L93.326 94.8152L92.9164 90.9191L92.1207 91.0028ZM92.5298 94.8938L93.1805 101.938L93.9771 101.864L93.3264 94.8202L92.5298 94.8938ZM93.9766 101.859L93.5699 97.9916L92.7743 98.0753L93.181 101.943L93.9766 101.859ZM93.5704 97.9967L92.9169 90.9241L92.1203 90.9977L92.7738 98.0703L93.5704 97.9967Z",
    fill: "white",
    mask: "url(#path-990-inside-86_1396_24002)"
  })), _path905 || (_path905 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0186 125.853L92.089 126.476L85.034 129.04L83.8533 128.352L91.0186 125.853Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path906 || (_path906 = /*#__PURE__*/React.createElement("path", {
    d: "M107.309 123.059L107.865 122.568L115.361 120.581L114.844 121.035L107.309 123.059Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path907 || (_path907 = /*#__PURE__*/React.createElement("path", {
    d: "M111.479 97.8553L112.001 96.3766L118.856 94.7429L118.295 96.2679L111.479 97.8553Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path908 || (_path908 = /*#__PURE__*/React.createElement("path", {
    d: "M79.469 56.4679L76.3043 53.0273L76.2849 51.022L79.1821 54.5779L79.469 56.4679Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask87 || (_mask87 = /*#__PURE__*/React.createElement("mask", {
    id: "path-996-inside-87_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M97.1559 126.719L105.2 124.189L103.781 124.521L95.6569 127.069L97.1559 126.719Z"
  }))), _path909 || (_path909 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1559 126.719L97.2467 127.109L97.2614 127.105L97.2759 127.101L97.1559 126.719ZM105.2 124.189L105.32 124.571L105.109 123.8L105.2 124.189ZM103.781 124.521L103.69 124.131L103.676 124.135L103.662 124.139L103.781 124.521ZM95.6569 127.069L95.5372 126.687L95.7477 127.458L95.6569 127.069ZM97.2759 127.101L105.32 124.571L105.08 123.808L97.0359 126.338L97.2759 127.101ZM105.109 123.8L103.69 124.131L103.872 124.91L105.291 124.579L105.109 123.8ZM103.662 124.139L95.5372 126.687L95.7766 127.45L103.901 124.903L103.662 124.139ZM95.7477 127.458L97.2467 127.109L97.0651 126.33L95.566 126.679L95.7477 127.458Z",
    fill: "white",
    mask: "url(#path-996-inside-87_1396_24002)"
  })), _path910 || (_path910 = /*#__PURE__*/React.createElement("path", {
    d: "M79.377 123.256L86.9599 121.077L87.9434 122.646L80.454 124.968L79.377 123.256Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path911 || (_path911 = /*#__PURE__*/React.createElement("path", {
    d: "M142.807 85.2669L143.907 86.3999L139.195 89.4598L138.141 88.3399L142.807 85.2669Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path912 || (_path912 = /*#__PURE__*/React.createElement("path", {
    d: "M50.794 68.2447L48.5432 72.332L47.794 68.8011L50.0654 64.6556L50.794 68.2447Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path913 || (_path913 = /*#__PURE__*/React.createElement("path", {
    d: "M132.452 86.0907L136.514 83.4388L137.282 83.3521L133.212 86.0425L132.452 86.0907Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask88 || (_mask88 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1002-inside-88_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4557 73.9681L89.2643 77.2223L91.2069 83.9599L90.3263 80.7126L88.4557 73.9681Z"
  }))), _path914 || (_path914 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4557 73.9681L88.8412 73.8612L88.0676 74.0646L88.4557 73.9681ZM89.2643 77.2223L88.8761 77.3187L88.8779 77.3259L88.88 77.3331L89.2643 77.2223ZM91.2069 83.9599L90.8225 84.0707L91.5929 83.8552L91.2069 83.9599ZM90.3263 80.7126L90.7124 80.6079L90.7117 80.6057L90.3263 80.7126ZM88.0676 74.0646L88.8761 77.3187L89.6525 77.1258L88.8439 73.8717L88.0676 74.0646ZM88.88 77.3331L90.8225 84.0707L91.5912 83.8491L89.6487 77.1115L88.88 77.3331ZM91.5929 83.8552L90.7123 80.6079L89.9402 80.8173L90.8208 84.0646L91.5929 83.8552ZM90.7117 80.6057L88.8412 73.8612L88.0703 74.075L89.9408 80.8195L90.7117 80.6057Z",
    fill: "white",
    mask: "url(#path-1002-inside-88_1396_24002)"
  })), _mask89 || (_mask89 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1004-inside-89_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4766 126.924L50.847 127.791L49.4631 122.471L49.0115 121.293L50.4766 126.924Z"
  }))), _path915 || (_path915 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4766 126.924L50.0895 127.024L50.0971 127.053L50.1088 127.081L50.4766 126.924ZM50.847 127.791L50.4791 127.948L51.2341 127.69L50.847 127.791ZM49.4631 122.471L49.8502 122.37L49.8446 122.349L49.8366 122.328L49.4631 122.471ZM49.0115 121.293L49.385 121.15L48.6244 121.394L49.0115 121.293ZM50.1088 127.081L50.4791 127.948L51.2148 127.633L50.8445 126.767L50.1088 127.081ZM51.2341 127.69L49.8502 122.37L49.076 122.572L50.4598 127.891L51.2341 127.69ZM49.8366 122.328L49.385 121.15L48.638 121.436L49.0896 122.614L49.8366 122.328ZM48.6244 121.394L50.0895 127.024L50.8638 126.823L49.3986 121.192L48.6244 121.394Z",
    fill: "white",
    mask: "url(#path-1004-inside-89_1396_24002)"
  })), _path916 || (_path916 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4632 142.828L62.762 144.835L62.8004 145.965L60.3655 143.839L60.4632 142.828Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path917 || (_path917 = /*#__PURE__*/React.createElement("path", {
    d: "M92.5636 126.728L93.493 127.017L86.6778 129.57L85.6385 129.245L92.5636 126.728Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path918 || (_path918 = /*#__PURE__*/React.createElement("path", {
    d: "M110.367 101.19L102.231 102.86L102.52 101.06L110.661 99.4222L110.367 101.19Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path919 || (_path919 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1742 125.146L93.1224 120.716L93.1709 122.304L92.2348 126.666L92.1742 125.146Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path920 || (_path920 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9214 139.897L60.0946 142.486L60.0035 143.429L57.7119 140.699L57.9214 139.897Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path921 || (_path921 = /*#__PURE__*/React.createElement("path", {
    d: "M101.746 107.657L93.2031 109.292L93.1088 107.226L101.666 105.682L101.746 107.657Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path922 || (_path922 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3335 116.047L84.8147 113.912L93.2115 112.222L93.6878 114.216L85.3335 116.047Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path923 || (_path923 = /*#__PURE__*/React.createElement("path", {
    d: "M141.323 84.1953L142.48 85.0036L137.84 88.0596L136.732 87.2431L141.323 84.1953Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path924 || (_path924 = /*#__PURE__*/React.createElement("path", {
    d: "M133.797 86.1362L138.132 83.2703L139.181 83.4223L134.808 86.3298L133.797 86.1362Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path925 || (_path925 = /*#__PURE__*/React.createElement("path", {
    d: "M69.412 149.38L71.9538 149.523L72.5794 150.322L69.9033 150.17L69.412 149.38Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path926 || (_path926 = /*#__PURE__*/React.createElement("path", {
    d: "M139.75 83.5251L140.901 83.997L136.365 87.0084L135.262 86.5088L139.75 83.5251Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path927 || (_path927 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2317 120.923L85.9089 118.903L86.7676 120.717L79.1733 122.899L78.2317 120.923Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path928 || (_path928 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1726 145.103L65.5504 146.504L65.7429 147.797L63.2136 146.306L63.1726 145.103Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path929 || (_path929 = /*#__PURE__*/React.createElement("path", {
    d: "M64.0376 47.8855L63.8801 51.0395L60.2538 51.5506L60.5566 48.3351L64.0376 47.8855Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask90 || (_mask90 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1020-inside-90_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.2926 145.512L83.1919 146.125L80.3423 148.637L81.3014 148.149L84.2926 145.512Z"
  }))), _path930 || (_path930 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2926 145.512L84.5571 145.813L84.0981 145.163L84.2926 145.512ZM83.1919 146.125L82.9975 145.775L82.9598 145.796L82.9274 145.825L83.1919 146.125ZM80.3423 148.637L80.0778 148.337L80.5239 148.994L80.3423 148.637ZM81.3014 148.149L81.483 148.505L81.528 148.482L81.5659 148.449L81.3014 148.149ZM84.0981 145.163L82.9975 145.775L83.3864 146.474L84.4871 145.862L84.0981 145.163ZM82.9274 145.825L80.0778 148.337L80.6068 148.937L83.4565 146.425L82.9274 145.825ZM80.5239 148.994L81.483 148.505L81.1198 147.792L80.1607 148.281L80.5239 148.994ZM81.5659 148.449L84.5571 145.813L84.0282 145.212L81.037 147.848L81.5659 148.449Z",
    fill: "white",
    mask: "url(#path-1020-inside-90_1396_24002)"
  })), _path931 || (_path931 = /*#__PURE__*/React.createElement("path", {
    d: "M142.421 97.8388L135.883 100.373L135.445 98.4741L141.967 95.8906L142.421 97.8388Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path932 || (_path932 = /*#__PURE__*/React.createElement("path", {
    d: "M122.105 90.709L122.565 90.2913L127.848 88.2665L127.3 88.7797L122.105 90.709Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path933 || (_path933 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6154 136.373L57.6123 139.509L57.4167 140.258L55.3197 136.966L55.6154 136.373Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path934 || (_path934 = /*#__PURE__*/React.createElement("path", {
    d: "M135.72 107.559L127.966 109.767L128.102 107.892L135.871 105.658L135.72 107.559Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path935 || (_path935 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6697 129.627L94.1431 127.202L94.6821 127.226L88.3127 129.656L87.6697 129.627Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path936 || (_path936 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5017 99.4019L46.9483 101.13L46.8403 105.846L46.3932 104.256L46.5017 99.4019Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask91 || (_mask91 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1028-inside-91_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.5699 125.958L106.54 123.47L105.199 124.187L97.1548 126.717L98.5699 125.958Z"
  }))), _path937 || (_path937 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5699 125.958L98.4507 125.576L98.4144 125.588L98.3808 125.606L98.5699 125.958ZM106.54 123.47L106.729 123.823L106.421 123.088L106.54 123.47ZM105.199 124.187L105.319 124.569L105.355 124.558L105.388 124.54L105.199 124.187ZM97.1548 126.717L96.9658 126.365L97.2748 127.099L97.1548 126.717ZM98.6891 126.34L106.659 123.852L106.421 123.088L98.4507 125.576L98.6891 126.34ZM106.351 123.117L105.01 123.835L105.388 124.54L106.729 123.823L106.351 123.117ZM105.079 123.806L97.0348 126.336L97.2748 127.099L105.319 124.569L105.079 123.806ZM97.3439 127.07L98.759 126.311L98.3808 125.606L96.9658 126.365L97.3439 127.07Z",
    fill: "white",
    mask: "url(#path-1028-inside-91_1396_24002)"
  })), _path938 || (_path938 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7771 127.174L83.0083 128.247L76.8218 130.917L75.4584 129.728L81.7771 127.174Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path939 || (_path939 = /*#__PURE__*/React.createElement("path", {
    d: "M118.392 116.841L118.928 115.366L126.765 113.526L126.229 114.973L118.392 116.841Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path940 || (_path940 = /*#__PURE__*/React.createElement("path", {
    d: "M108.281 122.043L108.972 121.133L116.676 119.133L116.017 119.993L108.281 122.043Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path941 || (_path941 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3032 125.441L81.4865 126.859L75.1415 129.424L73.8334 127.859L80.3032 125.441Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask92 || (_mask92 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1034-inside-92_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6754 132.793L53.0038 132.694L51.2918 128.004L50.8474 127.787L52.6754 132.793Z"
  }))), _path942 || (_path942 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6754 132.793L52.2997 132.93L52.4292 133.284L52.7907 133.176L52.6754 132.793ZM53.0038 132.694L53.1191 133.077L53.5249 132.955L53.3796 132.556L53.0038 132.694ZM51.2918 128.004L51.6676 127.867L51.6123 127.716L51.4674 127.645L51.2918 128.004ZM50.8474 127.787L51.0229 127.428L50.1313 126.992L50.4717 127.924L50.8474 127.787ZM52.7907 133.176L53.1191 133.077L52.8885 132.311L52.5602 132.409L52.7907 133.176ZM53.3796 132.556L51.6676 127.867L50.9161 128.141L52.6281 132.831L53.3796 132.556ZM51.4674 127.645L51.0229 127.428L50.6719 128.147L51.1163 128.364L51.4674 127.645ZM50.4717 127.924L52.2997 132.93L53.0512 132.655L51.2231 127.65L50.4717 127.924Z",
    fill: "white",
    mask: "url(#path-1034-inside-92_1396_24002)"
  })), _path943 || (_path943 = /*#__PURE__*/React.createElement("path", {
    d: "M112.228 95.9094L112.857 94.693L119.713 93.0186L119.038 94.2861L112.228 95.9094Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path944 || (_path944 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9404 56.4059L56.0607 53.8866L56.4875 57.3982L53.3718 59.9001L52.9404 56.4059Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path945 || (_path945 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3657 128.529L84.5813 129.238L78.5795 131.969L77.228 131.178L83.3657 128.529Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path946 || (_path946 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0738 120.549L77.3019 118.364L85.0556 116.52L85.7576 118.527L78.0738 120.549Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path947 || (_path947 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9803 146.67L68.3915 147.444L68.7567 148.86L66.1828 148.031L65.9803 146.67Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path948 || (_path948 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3813 125.627L78.9806 123.379L80.0663 125.105L73.5815 127.528L72.3813 125.627Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path949 || (_path949 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1373 111.829L84.7393 113.519L84.4184 111.31L92.8471 109.765L93.1373 111.829Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path950 || (_path950 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6191 149.831L79.0988 148.527L79.7884 148.703L77.2134 150.055L76.6191 149.831Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path951 || (_path951 = /*#__PURE__*/React.createElement("path", {
    d: "M101.668 105.274L93.1159 106.818L93.2185 104.807L101.776 103.353L101.668 105.274Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path952 || (_path952 = /*#__PURE__*/React.createElement("path", {
    d: "M110.748 98.9982L102.626 100.632L103.08 99.0077L111.203 97.4027L110.748 98.9982Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path953 || (_path953 = /*#__PURE__*/React.createElement("path", {
    d: "M141.855 95.5044L135.332 98.0887L134.714 96.31L141.211 93.6897L141.855 95.5044Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path954 || (_path954 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1265 132.16L85.0296 129.474L86.1379 129.821L80.3702 132.551L79.1265 132.16Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask93 || (_mask93 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1048-inside-93_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.83 89.3328L130.177 86.8353L128.732 87.7156L122.46 90.1197L123.83 89.3328Z"
  }))), _path955 || (_path955 = /*#__PURE__*/React.createElement("path", {
    d: "M123.83 89.3328L123.684 88.9606L123.657 88.9713L123.631 88.9859L123.83 89.3328ZM130.177 86.8353L130.385 87.1769L130.03 86.4631L130.177 86.8353ZM128.732 87.7156L128.875 88.0891L128.909 88.0761L128.94 88.0572L128.732 87.7156ZM122.46 90.1197L122.26 89.7728L122.603 90.4932L122.46 90.1197ZM123.977 89.705L130.323 87.2075L130.03 86.4631L123.684 88.9606L123.977 89.705ZM129.969 86.4937L128.524 87.374L128.94 88.0572L130.385 87.1769L129.969 86.4937ZM128.589 87.3421L122.316 89.7462L122.603 90.4932L128.875 88.0891L128.589 87.3421ZM122.659 90.4666L124.03 89.6797L123.631 88.9859L122.26 89.7728L122.659 90.4666Z",
    fill: "white",
    mask: "url(#path-1048-inside-93_1396_24002)"
  })), _path956 || (_path956 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4459 133.632L91.6402 130.187L91.5601 130.791L90.379 134.193L90.4459 133.632Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask94 || (_mask94 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1051-inside-94_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9541 129.484L97.1538 126.719L95.6549 127.068L88.3443 129.858L89.9541 129.484Z"
  }))), _path957 || (_path957 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9541 129.484L90.0446 129.874L90.0716 129.868L90.0975 129.858L89.9541 129.484ZM97.1538 126.719L97.2972 127.092L97.063 126.329L97.1538 126.719ZM95.6549 127.068L95.5641 126.679L95.5376 126.685L95.5123 126.694L95.6549 127.068ZM88.3443 129.858L88.2017 129.484L88.4348 130.248L88.3443 129.858ZM90.0975 129.858L97.2972 127.092L97.0104 126.345L89.8106 129.111L90.0975 129.858ZM97.063 126.329L95.5641 126.679L95.7457 127.458L97.2446 127.108L97.063 126.329ZM95.5123 126.694L88.2017 129.484L88.4869 130.232L95.7975 127.442L95.5123 126.694ZM88.4348 130.248L90.0446 129.874L89.8635 129.095L88.2538 129.468L88.4348 130.248Z",
    fill: "white",
    mask: "url(#path-1051-inside-94_1396_24002)"
  })), _path958 || (_path958 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2802 142.605L62.845 144.381L60.5389 142.367L61.1395 140.736L63.2802 142.605Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path959 || (_path959 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6066 132.337L55.3712 135.966L55.0924 136.526L53.2455 132.73L53.6066 132.337Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path960 || (_path960 = /*#__PURE__*/React.createElement("path", {
    d: "M47.363 109.321L47.4394 109.612L47.7216 113.579L47.6491 113.327L47.363 109.321Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path961 || (_path961 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8056 138.027L60.8223 140.431L60.2329 142.031L58.0646 139.448L58.8056 138.027Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path962 || (_path962 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2357 77.066L47.5216 81.6541L46.673 78.2795L48.4161 73.5884L49.2357 77.066Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path963 || (_path963 = /*#__PURE__*/React.createElement("path", {
    d: "M71.1325 123.084L77.8413 121.033L78.7888 123.021L72.1808 125.272L71.1325 123.084Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path964 || (_path964 = /*#__PURE__*/React.createElement("path", {
    d: "M75.052 129.906L76.4392 131.116L71.5076 133.862L69.9678 132.519L75.052 129.906Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path965 || (_path965 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3982 125.488L99.966 124.984L106.945 122.844L106.441 123.29L99.3982 125.488Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path966 || (_path966 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4446 128.019L74.7683 129.602L69.6658 132.224L68.1982 130.471L73.4446 128.019Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask95 || (_mask95 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1062-inside-95_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.5798 101.903L93.9622 105.696L93.9433 112.53L93.5623 108.827L93.5798 101.903Z"
  }))), _path967 || (_path967 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5798 101.903L93.9777 101.863L93.1798 101.902L93.5798 101.903ZM93.9622 105.696L94.3622 105.697L94.3622 105.677L94.3602 105.656L93.9622 105.696ZM93.9433 112.53L93.5454 112.571L94.3433 112.531L93.9433 112.53ZM93.5623 108.827L93.1623 108.826L93.1622 108.847L93.1644 108.868L93.5623 108.827ZM93.1818 101.943L93.5642 105.736L94.3602 105.656L93.9777 101.863L93.1818 101.943ZM93.5622 105.695L93.5433 112.529L94.3433 112.531L94.3622 105.697L93.5622 105.695ZM94.3412 112.489L93.9602 108.786L93.1644 108.868L93.5454 112.571L94.3412 112.489ZM93.9623 108.828L93.9798 101.904L93.1798 101.902L93.1623 108.826L93.9623 108.828Z",
    fill: "white",
    mask: "url(#path-1062-inside-95_1396_24002)"
  })), _path968 || (_path968 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8444 144.144L65.5772 146.056L63.1895 144.649L63.6325 142.842L65.8444 144.144Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path969 || (_path969 = /*#__PURE__*/React.createElement("path", {
    d: "M135.889 105.235L128.105 107.474L128.055 105.528L135.843 103.271L135.889 105.235Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path970 || (_path970 = /*#__PURE__*/React.createElement("path", {
    d: "M72.409 149.454L74.9117 148.9L75.7348 149.741L73.0896 150.324L72.409 149.454Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path971 || (_path971 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1847 117.981L76.6087 115.65L84.4211 113.994L84.9419 116.137L77.1847 117.981Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path972 || (_path972 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9332 70.8776L86.7788 70.1694L88.2658 74.0279L88.3752 74.4682L86.9332 70.8776Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path973 || (_path973 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7816 131.381L78.1728 132.195L73.4325 135.016L71.8841 134.109L76.7816 131.381Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path974 || (_path974 = /*#__PURE__*/React.createElement("path", {
    d: "M113.212 94.1952L113.879 93.2988L120.703 91.5912L119.983 92.5419L113.212 94.1952Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path975 || (_path975 = /*#__PURE__*/React.createElement("path", {
    d: "M109.241 120.651L109.902 119.393L117.687 117.427L117.051 118.623L109.241 120.651Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path976 || (_path976 = /*#__PURE__*/React.createElement("path", {
    d: "M119.044 114.928L119.436 113.233L127.309 111.414L126.915 113.079L119.044 114.928Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path977 || (_path977 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6969 134.789L58.5366 137.68L57.809 139.075L55.8344 135.974L56.6969 134.789Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path978 || (_path978 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1932 132.6L86.7252 129.981L87.5501 130.019L82.1471 132.645L81.1932 132.6Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path979 || (_path979 = /*#__PURE__*/React.createElement("path", {
    d: "M133.787 94.3352L140.245 91.6948L141.055 93.3195L134.562 95.9382L133.787 94.3352Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path980 || (_path980 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9976 125.766L73.2084 127.685L67.952 130.142L66.6098 128.021L71.9976 125.766Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask96 || (_mask96 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1077-inside-96_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.281 88.922L131.705 86.3406L130.176 86.8375L123.83 89.3349L125.281 88.922Z"
  }))), _path981 || (_path981 = /*#__PURE__*/React.createElement("path", {
    d: "M125.281 88.922L125.391 89.3067L125.411 89.301L125.43 89.2931L125.281 88.922ZM131.705 86.3406L131.854 86.7117L131.581 85.9602L131.705 86.3406ZM130.176 86.8375L130.053 86.4571L130.041 86.4608L130.03 86.4653L130.176 86.8375ZM123.83 89.3349L123.683 88.9627L123.939 89.7197L123.83 89.3349ZM125.43 89.2931L131.854 86.7117L131.556 85.9694L125.132 88.5508L125.43 89.2931ZM131.581 85.9602L130.053 86.4571L130.3 87.2179L131.828 86.721L131.581 85.9602ZM130.03 86.4653L123.683 88.9627L123.976 89.7072L130.323 87.2097L130.03 86.4653ZM123.939 89.7197L125.391 89.3067L125.172 88.5372L123.72 88.9502L123.939 89.7197Z",
    fill: "white",
    mask: "url(#path-1077-inside-96_1396_24002)"
  })), _mask97 || (_mask97 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1079-inside-97_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.0129 121.291L49.4646 122.469L48.5624 116.965L48.0569 115.463L49.0129 121.291Z"
  }))), _path982 || (_path982 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0129 121.291L48.6182 121.356L48.6248 121.396L48.6394 121.434L49.0129 121.291ZM49.4646 122.469L49.0911 122.612L49.8593 122.404L49.4646 122.469ZM48.5624 116.965L48.9571 116.9L48.9519 116.868L48.9415 116.837L48.5624 116.965ZM48.0569 115.463L48.436 115.335L47.6622 115.528L48.0569 115.463ZM48.6394 121.434L49.0911 122.612L49.838 122.326L49.3864 121.148L48.6394 121.434ZM49.8593 122.404L48.9571 116.9L48.1677 117.03L49.0698 122.534L49.8593 122.404ZM48.9415 116.837L48.436 115.335L47.6778 115.59L48.1833 117.093L48.9415 116.837ZM47.6622 115.528L48.6182 121.356L49.4077 121.226L48.4516 115.398L47.6622 115.528Z",
    fill: "white",
    mask: "url(#path-1079-inside-97_1396_24002)"
  })), _path983 || (_path983 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8175 147.504L71.2157 147.636L71.7625 149.116L69.1961 148.971L68.8175 147.504Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path984 || (_path984 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8082 109.366L84.3808 110.911L84.2685 108.693L92.7136 107.294L92.8082 109.366Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path985 || (_path985 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0274 51.5878L64.2797 51.0407L64.4372 47.8888L68.0368 48.4948L68.0274 51.5878Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path986 || (_path986 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6964 139.969L63.4486 142.218L61.3172 140.357L62.7413 138.262L64.6964 139.969Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path987 || (_path987 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5991 132.728L71.1649 134.094L67.5624 136.813L65.829 135.3L69.5991 132.728Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path988 || (_path988 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6102 135.778L62.452 137.975L61.0351 140.06L59.0293 137.669L60.6102 135.778Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path989 || (_path989 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9743 122.712L70.1134 120.297L76.9118 118.463L77.6879 120.659L70.9743 122.712Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path990 || (_path990 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8334 130.66L69.3185 132.434L65.539 135.012L63.8963 133.052L67.8334 130.66Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path991 || (_path991 = /*#__PURE__*/React.createElement("path", {
    d: "M73.919 135.19L78.592 132.409L79.9098 132.824L75.3937 135.657L73.919 135.19Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path992 || (_path992 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2263 144.3L68.458 145.015L68.3684 147.014L65.9553 146.239L66.2263 144.3Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask98 || (_mask98 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1091-inside-98_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.2075 83.959L91.6211 87.8822L92.9299 94.8565L92.5203 90.9604L91.2075 83.959Z"
  }))), _path993 || (_path993 = /*#__PURE__*/React.createElement("path", {
    d: "M91.2075 83.959L91.6007 83.8853L90.8097 84.0009L91.2075 83.959ZM91.6211 87.8822L91.2233 87.9242L91.225 87.9402L91.228 87.956L91.6211 87.8822ZM92.9299 94.8565L92.5367 94.9303L93.3277 94.8147L92.9299 94.8565ZM92.5203 90.9604L92.9181 90.9186L92.9164 90.9026L92.9134 90.8867L92.5203 90.9604ZM90.8097 84.0009L91.2233 87.9242L92.0189 87.8403L91.6053 83.917L90.8097 84.0009ZM91.228 87.956L92.5367 94.9303L93.323 94.7828L92.0143 87.8084L91.228 87.956ZM93.3277 94.8147L92.9181 90.9186L92.1224 91.0023L92.5321 94.8984L93.3277 94.8147ZM92.9134 90.8867L91.6007 83.8853L90.8144 84.0327L92.1271 91.0342L92.9134 90.8867Z",
    fill: "white",
    mask: "url(#path-1091-inside-98_1396_24002)"
  })), _mask99 || (_mask99 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1093-inside-99_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.4734 128.67L98.5705 125.961L97.1554 126.72L89.9557 129.485L91.4734 128.67Z"
  }))), _path994 || (_path994 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4734 128.67L91.3308 128.296L91.3067 128.305L91.2841 128.317L91.4734 128.67ZM98.5705 125.961L98.7596 126.313L98.4278 125.587L98.5705 125.961ZM97.1554 126.72L97.2988 127.093L97.3223 127.084L97.3445 127.072L97.1554 126.72ZM89.9557 129.485L89.7663 129.133L90.0991 129.859L89.9557 129.485ZM91.6161 129.043L98.7131 126.335L98.4278 125.587L91.3308 128.296L91.6161 129.043ZM98.3814 125.608L96.9663 126.368L97.3445 127.072L98.7596 126.313L98.3814 125.608ZM97.012 126.347L89.8123 129.112L90.0991 129.859L97.2988 127.093L97.012 126.347ZM90.1451 129.838L91.6628 129.022L91.2841 128.317L89.7663 129.133L90.1451 129.838Z",
    fill: "white",
    mask: "url(#path-1093-inside-99_1396_24002)"
  })), _mask100 || (_mask100 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1095-inside-100_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.9619 136.004L89.1363 137.731L86.9266 142.013L87.6628 140.46L89.9619 136.004Z"
  }))), _path995 || (_path995 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9619 136.004L90.3228 136.177L89.6064 135.821L89.9619 136.004ZM89.1363 137.731L89.492 137.914L89.4972 137.903L89.1363 137.731ZM86.9266 142.013L86.5651 141.842L87.282 142.196L86.9266 142.013ZM87.6628 140.46L87.3072 140.276L87.3014 140.288L87.6628 140.46ZM89.601 135.832L88.7755 137.558L89.4972 137.903L90.3228 136.177L89.601 135.832ZM88.7809 137.547L86.5711 141.83L87.282 142.196L89.4918 137.914L88.7809 137.547ZM87.288 142.184L88.0243 140.631L87.3014 140.288L86.5651 141.842L87.288 142.184ZM88.0183 140.643L90.3174 136.187L89.6064 135.821L87.3074 140.276L88.0183 140.643Z",
    fill: "white",
    mask: "url(#path-1095-inside-100_1396_24002)"
  })), _path996 || (_path996 = /*#__PURE__*/React.createElement("path", {
    d: "M101.815 102.942L93.2671 104.395L93.5603 102.502L102.106 101.134L101.815 102.942Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path997 || (_path997 = /*#__PURE__*/React.createElement("path", {
    d: "M111.342 96.9654L103.251 98.5642L103.841 97.1715L111.929 95.5985L111.342 96.9654Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path998 || (_path998 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9985 137.954L65.5093 135.548L67.2681 137.083L64.9334 139.643L62.9985 137.954Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path999 || (_path999 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4949 134.344L73.0849 135.276L69.6748 138.083L67.9118 137.048L71.4949 134.344Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1000 || (_path1000 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0373 141.386L65.9693 143.754L63.7707 142.46L65.0229 140.202L67.0373 141.386Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask101 || (_mask101 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1102-inside-101_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.8482 127.788L51.2926 128.005L49.9973 123.023L49.4643 122.469L50.8482 127.788Z"
  }))), _path1001 || (_path1001 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8482 127.788L50.4611 127.889L50.5074 128.067L50.6726 128.148L50.8482 127.788ZM51.2926 128.005L51.1171 128.365L51.8986 128.746L51.6797 127.905L51.2926 128.005ZM49.9973 123.023L50.3845 122.922L50.3581 122.821L50.2856 122.745L49.9973 123.023ZM49.4643 122.469L49.7526 122.191L48.692 121.088L49.0772 122.569L49.4643 122.469ZM50.6726 128.148L51.1171 128.365L51.4681 127.646L51.0237 127.429L50.6726 128.148ZM51.6797 127.905L50.3845 122.922L49.6102 123.123L50.9055 128.106L51.6797 127.905ZM50.2856 122.745L49.7526 122.191L49.176 122.746L49.709 123.3L50.2856 122.745ZM49.0772 122.569L50.4611 127.889L51.2353 127.688L49.8514 122.368L49.0772 122.569Z",
    fill: "white",
    mask: "url(#path-1102-inside-101_1396_24002)"
  })), _path1002 || (_path1002 = /*#__PURE__*/React.createElement("path", {
    d: "M139.092 89.9675L140.037 91.352L133.592 93.9872L132.69 92.6096L139.092 89.9675Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1003 || (_path1003 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5693 133.282L65.2301 135.264L62.7188 137.671L60.8932 135.494L63.5693 133.282Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1004 || (_path1004 = /*#__PURE__*/React.createElement("path", {
    d: "M126.366 88.7006L131.751 86.5364L132.071 86.5162L126.736 88.6938L126.366 88.7006Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1005 || (_path1005 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4108 127.675L65.2393 125.241L70.7479 123.213L71.8039 125.417L66.4108 127.675Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1006 || (_path1006 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2433 128.192L67.598 130.333L63.6568 132.728L62.1585 130.366L66.2433 128.192Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1007 || (_path1007 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6865 132.814L60.3632 135.452L58.7908 137.333L56.9662 134.465L58.6865 132.814Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1008 || (_path1008 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9557 127.904L53.4273 131.939L53.08 132.317L51.5425 128.105L51.9557 127.904Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1009 || (_path1009 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2632 139.878L67.5921 137.324L69.3942 138.382L67.2479 141.045L65.2632 139.878Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1010 || (_path1010 = /*#__PURE__*/React.createElement("path", {
    d: "M135.818 102.865L128.021 105.124L127.782 103.169L135.572 100.901L135.818 102.865Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1011 || (_path1011 = /*#__PURE__*/React.createElement("path", {
    d: "M54.8654 131.097L56.4764 134.413L55.6274 135.58L53.9005 132.029L54.8654 131.097Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1012 || (_path1012 = /*#__PURE__*/React.createElement("path", {
    d: "M100.395 124.436L101.126 123.466L108.325 121.322L107.648 122.212L100.395 124.436Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1013 || (_path1013 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8679 132.259L83.937 132.225L83.8695 132.259L83.8679 132.259Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1014 || (_path1014 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2195 86.2307L47.0744 91.0549L46.3147 88.1541L47.4872 83.1861L48.2195 86.2307Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1015 || (_path1015 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3461 113.603L76.5328 115.259L76.172 112.847L84.0241 111.386L84.3461 113.603Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1016 || (_path1016 = /*#__PURE__*/React.createElement("path", {
    d: "M114.486 92.736L115.044 92.2291L121.73 90.5154L121.109 91.0786L114.486 92.736Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1017 || (_path1017 = /*#__PURE__*/React.createElement("path", {
    d: "M137.782 88.543L138.82 89.6459L132.443 92.2773L131.453 91.1669L137.782 88.543Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1018 || (_path1018 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8181 130.576L63.3305 132.96L60.6566 135.17L58.9947 132.554L61.8181 130.576Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1019 || (_path1019 = /*#__PURE__*/React.createElement("path", {
    d: "M127.426 88.8445L133.297 86.4477L134.154 86.6118L128.256 89.0442L127.426 88.8445Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1020 || (_path1020 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1053 138.247L73.4768 135.471L75.0249 135.961L71.8268 138.794L70.1053 138.247Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1021 || (_path1021 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0673 135.711L80.4367 132.97L81.5606 133.023L77.3414 135.774L76.0673 135.711Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1022 || (_path1022 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9195 145.488L85.8396 142.937L86.1087 142.767L84.1588 145.355L83.9195 145.488Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1023 || (_path1023 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3675 64.1341L53.1027 60.743L53.8252 64.4829L51.1164 67.8233L50.3675 64.1341Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1024 || (_path1024 = /*#__PURE__*/React.createElement("path", {
    d: "M119.502 112.807L119.723 110.949L127.624 109.158L127.397 110.983L119.502 112.807Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1025 || (_path1025 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3355 143.915L67.4035 141.547L69.4229 142.192L68.5422 144.622L66.3355 143.915Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1026 || (_path1026 = /*#__PURE__*/React.createElement("path", {
    d: "M136.354 87.4637L137.429 88.2555L131.149 90.8594L130.123 90.0469L136.354 87.4637Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1027 || (_path1027 = /*#__PURE__*/React.createElement("path", {
    d: "M110.081 118.932L110.635 117.386L118.46 115.477L117.924 116.951L110.081 118.932Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1028 || (_path1028 = /*#__PURE__*/React.createElement("path", {
    d: "M134.847 86.7599L135.881 87.2281L129.742 89.773L128.754 89.273L134.847 86.7599Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1029 || (_path1029 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7973 118.081L69.9966 119.916L69.3515 117.341L76.2185 115.738L76.7973 118.081Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1030 || (_path1030 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6329 141.2L69.764 138.556L71.5508 139.124L69.6037 141.829L67.6329 141.2Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1031 || (_path1031 = /*#__PURE__*/React.createElement("path", {
    d: "M64.868 125.389L66.049 127.842L61.9631 130.017L60.6562 127.312L64.868 125.389Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1032 || (_path1032 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8934 65.2184L83.5408 63.2706L85.8384 67.737L86.2421 69.5886L83.8934 65.2184Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1033 || (_path1033 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7101 106.89L84.2693 108.289L84.3679 106.128L92.8131 104.872L92.7101 106.89Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1034 || (_path1034 = /*#__PURE__*/React.createElement("path", {
    d: "M68.855 145.082L71.0568 145.201L71.1485 147.228L68.7648 147.096L68.855 145.082Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1035 || (_path1035 = /*#__PURE__*/React.createElement("path", {
    d: "M70.596 122.84L65.0849 124.869L64.1218 122.187L69.7296 120.41L70.596 122.84Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1036 || (_path1036 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4721 119.07L93.8231 115.655L93.8299 115.924L93.4798 119.321L93.4721 119.07Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1037 || (_path1037 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0155 129.436L58.4787 132.455L56.7671 134.098L55.1752 130.82L57.0155 129.436Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1038 || (_path1038 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4892 148.212L81.8264 146.148L82.729 146.265L80.2894 148.416L79.4892 148.212Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1039 || (_path1039 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4311 53.6292L59.8638 52.0805L60.2914 55.6594L56.8644 57.1941L56.4311 53.6292Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1040 || (_path1040 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4173 128.094L92.9663 127.604L98.9307 125.372L98.4653 125.786L92.4173 128.094Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1041 || (_path1041 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1685 53.2812L68.4276 51.6855L68.4369 48.6357L72.0335 50.2871L72.1685 53.2812Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1042 || (_path1042 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6271 147.585L73.9622 147.064L74.6874 148.541L72.1852 149.095L71.6271 147.585Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1043 || (_path1043 = /*#__PURE__*/React.createElement("path", {
    d: "M112.139 95.1504L104.107 96.7124L104.786 95.6055L112.812 94.0652L112.139 95.1504Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1044 || (_path1044 = /*#__PURE__*/React.createElement("path", {
    d: "M60.303 127.497L61.6214 130.225L58.8017 132.201L57.3523 129.21L60.303 127.497Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1045 || (_path1045 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3094 148.734L77.7085 147.469L78.7114 148.278L76.1705 149.614L75.3094 148.734Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1046 || (_path1046 = /*#__PURE__*/React.createElement("path", {
    d: "M102.19 100.712L93.6599 102.077L94.128 100.362L102.647 99.076L102.19 100.712Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1047 || (_path1047 = /*#__PURE__*/React.createElement("path", {
    d: "M135.504 100.505L127.711 102.774L127.288 100.872L135.065 98.6048L135.504 100.505Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1048 || (_path1048 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1428 93.0283L47.669 95.2906L47.0804 100.04L46.538 97.9407L47.1428 93.0283Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1049 || (_path1049 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3737 138.845L75.4935 136.081L76.9162 136.151L73.964 138.925L72.3737 138.845Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1050 || (_path1050 = /*#__PURE__*/React.createElement("path", {
    d: "M120.076 90.5263L122.427 89.9096L122.383 89.9349L120.076 90.5263Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask102 || (_mask102 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1153-inside-102_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.5829 131.559L91.4718 128.667L89.9539 129.483L83.936 132.445L85.5829 131.559Z"
  }))), _path1051 || (_path1051 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5829 131.559L85.4066 131.2L85.4 131.203L85.3935 131.207L85.5829 131.559ZM91.4718 128.667L91.6612 129.019L91.2955 128.308L91.4718 128.667ZM89.9539 129.483L90.1306 129.842L90.137 129.838L90.1433 129.835L89.9539 129.483ZM83.936 132.445L83.7466 132.092L84.1126 132.803L83.936 132.445ZM85.7592 131.918L91.6481 129.026L91.2955 128.308L85.4066 131.2L85.7592 131.918ZM91.2825 128.315L89.7646 129.13L90.1433 129.835L91.6612 129.019L91.2825 128.315ZM89.7773 129.124L83.7593 132.086L84.1126 132.803L90.1306 129.842L89.7773 129.124ZM84.1254 132.797L85.7723 131.911L85.3935 131.207L83.7466 132.092L84.1254 132.797Z",
    fill: "white",
    mask: "url(#path-1153-inside-102_1396_24002)"
  })), _path1052 || (_path1052 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3595 127.045L54.6933 130.709L53.7405 131.63L52.3117 127.712L53.3595 127.045Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1053 || (_path1053 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4489 135.528L82.2688 133.038L82.915 132.888L79.2275 135.349L78.4489 135.528Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1054 || (_path1054 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9833 110.984L76.1326 112.444L75.9985 110.021L83.8705 108.757L83.9833 110.984Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1055 || (_path1055 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9434 144.685L69.8183 142.272L71.7891 142.375L71.099 144.802L68.9434 144.685Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1056 || (_path1056 = /*#__PURE__*/React.createElement("path", {
    d: "M101.402 122.97L102.102 121.624L109.373 119.544L108.717 120.792L101.402 122.97Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1057 || (_path1057 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0579 141.885L71.9732 139.224L73.6819 139.311L71.946 141.984L70.0579 141.885Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1058 || (_path1058 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7139 125.022L60.5027 126.945L59.4272 123.968L63.7436 122.32L64.7139 125.022Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1059 || (_path1059 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4205 60.3433L80.0817 57.9025L82.9146 62.0616L83.3452 64.4404L80.4205 60.3433Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1060 || (_path1060 = /*#__PURE__*/React.createElement("path", {
    d: "M119.745 110.533L119.78 108.574L127.704 106.813L127.661 108.738L119.745 110.533Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1061 || (_path1061 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8333 127.519L51.4253 127.717L50.2548 123.215L50.7129 123.202L51.8333 127.519Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1062 || (_path1062 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3144 102.696L47.5734 103.811L47.4721 108.154L47.2121 107.163L47.3144 102.696Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1063 || (_path1063 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5777 53.4878L72.4464 50.5776L75.9159 53.212L76.1814 56.069L72.5777 53.4878Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1064 || (_path1064 = /*#__PURE__*/React.createElement("path", {
    d: "M110.749 116.948L111.15 115.17L119.001 113.334L118.609 115.031L110.749 116.948Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1065 || (_path1065 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1416 115.345L69.2744 116.948L68.8657 114.285L75.7791 112.921L76.1416 115.345Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1066 || (_path1066 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6143 120.027L64.006 121.805L63.2816 118.948L68.9654 117.437L69.6143 120.027Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1067 || (_path1067 = /*#__PURE__*/React.createElement("path", {
    d: "M126.591 98.6971L134.338 96.4405L134.955 98.2179L127.182 100.484L126.591 98.6971Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1068 || (_path1068 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9115 117.868L48.9622 117.946L49.6951 122.424L49.6505 122.377L48.9115 117.868Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1069 || (_path1069 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6453 125.734L56.852 129.059L55.0199 130.437L53.7068 126.829L55.6453 125.734Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask103 || (_mask103 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1173-inside-103_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.057 115.462L48.5625 116.964L48.1687 111.412L47.6385 109.58L48.057 115.462Z"
  }))), _path1070 || (_path1070 = /*#__PURE__*/React.createElement("path", {
    d: "M48.057 115.462L47.658 115.491L47.6616 115.541L47.6779 115.59L48.057 115.462ZM48.5625 116.964L48.1834 117.092L48.9615 116.936L48.5625 116.964ZM48.1687 111.412L48.5677 111.383L48.5647 111.341L48.5529 111.3L48.1687 111.412ZM47.6385 109.58L48.0227 109.469L47.2395 109.608L47.6385 109.58ZM47.6779 115.59L48.1834 117.092L48.9416 116.837L48.4361 115.335L47.6779 115.59ZM48.9615 116.936L48.5677 111.383L47.7697 111.44L48.1635 116.993L48.9615 116.936ZM48.5529 111.3L48.0227 109.469L47.2543 109.691L47.7845 111.523L48.5529 111.3ZM47.2395 109.608L47.658 115.491L48.456 115.434L48.0375 109.552L47.2395 109.608Z",
    fill: "white",
    mask: "url(#path-1173-inside-103_1396_24002)"
  })), _path1071 || (_path1071 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6128 56.3972L76.3599 53.6765L79.5763 57.1734L79.9465 59.8404L76.6128 56.3972Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1072 || (_path1072 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1445 127.127L57.1979 128.838L56.0041 125.549L59.0597 124.124L60.1445 127.127Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask104 || (_mask104 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1177-inside-104_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.611 90.976L125.281 88.9209L123.829 89.3339L116.238 91.3248L117.611 90.976Z"
  }))), _path1073 || (_path1073 = /*#__PURE__*/React.createElement("path", {
    d: "M117.611 90.976L117.709 91.3638L117.714 91.3624L117.611 90.976ZM125.281 88.9209L125.39 89.3056L125.177 88.5345L125.281 88.9209ZM123.829 89.3339L123.931 89.7209L123.939 89.7186L123.829 89.3339ZM116.238 91.3248L116.136 90.9379L116.336 91.7125L116.238 91.3248ZM117.714 91.3624L125.384 89.3073L125.177 88.5345L117.507 90.5897L117.714 91.3624ZM125.171 88.5362L123.72 88.9491L123.939 89.7186L125.39 89.3056L125.171 88.5362ZM123.728 88.947L116.136 90.9379L116.339 91.7117L123.931 89.7208L123.728 88.947ZM116.336 91.7125L117.709 91.3637L117.512 90.5884L116.139 90.9371L116.336 91.7125Z",
    fill: "white",
    mask: "url(#path-1177-inside-104_1396_24002)"
  })), _path1074 || (_path1074 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8515 104.463L84.4145 105.718L84.7187 103.679L93.1461 102.562L92.8515 104.463Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1075 || (_path1075 = /*#__PURE__*/React.createElement("path", {
    d: "M113.117 93.6007L105.202 95.1196L105.886 94.3517L113.792 92.85L113.117 93.6007Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1076 || (_path1076 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4286 127.005L94.2048 125.968L100.441 123.712L99.7397 124.643L93.4286 127.005Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask105 || (_mask105 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1182-inside-105_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3721 122.323L92.9922 125.085L91.7568 130.838L92.0986 128.257L93.3721 122.323Z"
  }))), _path1077 || (_path1077 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3721 122.323L93.7683 122.378L92.981 122.239L93.3721 122.323ZM92.9922 125.085L93.3833 125.169L93.3865 125.154L93.3885 125.139L92.9922 125.085ZM91.7568 130.838L91.3603 130.785L92.1479 130.922L91.7568 130.838ZM92.0986 128.257L91.7075 128.174L91.7041 128.189L91.7021 128.205L92.0986 128.257ZM92.9758 122.269L92.596 125.03L93.3885 125.139L93.7683 122.378L92.9758 122.269ZM92.6012 125.001L91.3658 130.754L92.1479 130.922L93.3833 125.169L92.6012 125.001ZM92.1534 130.89L92.4951 128.31L91.7021 128.205L91.3603 130.785L92.1534 130.89ZM92.4897 128.341L93.7632 122.407L92.981 122.239L91.7075 128.174L92.4897 128.341Z",
    fill: "white",
    mask: "url(#path-1182-inside-105_1396_24002)"
  })), _path1078 || (_path1078 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5474 147.196L71.4558 145.172L73.58 144.695L73.8479 146.683L71.5474 147.196Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1079 || (_path1079 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7123 138.767L77.4932 136.153L78.6611 135.885L76.0327 138.466L74.7123 138.767Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask106 || (_mask106 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1186-inside-106_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.9296 94.8574L93.3205 98.7412L93.9627 105.694L93.5803 101.901L92.9296 94.8574Z"
  }))), _path1080 || (_path1080 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9296 94.8574L93.3276 94.8174L92.5313 94.8942L92.9296 94.8574ZM93.3205 98.7412L93.7188 98.7044L93.7185 98.7011L93.3205 98.7412ZM93.9627 105.694L93.5647 105.734L94.361 105.657L93.9627 105.694ZM93.5803 101.901L93.1819 101.938L93.1823 101.941L93.5803 101.901ZM92.5316 94.8975L92.9225 98.7812L93.7185 98.7011L93.3276 94.8174L92.5316 94.8975ZM92.9222 98.7779L93.5644 105.731L94.361 105.657L93.7188 98.7044L92.9222 98.7779ZM94.3607 105.654L93.9782 101.861L93.1823 101.941L93.5647 105.734L94.3607 105.654ZM93.9786 101.864L93.3279 94.8206L92.5313 94.8942L93.1819 101.938L93.9786 101.864Z",
    fill: "white",
    mask: "url(#path-1186-inside-106_1396_24002)"
  })), _path1081 || (_path1081 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8799 81.1304L89.7034 79.4663L91.0097 83.9971L91.1837 85.6477L89.8799 81.1304Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1082 || (_path1082 = /*#__PURE__*/React.createElement("path", {
    d: "M102.779 98.6538L94.2882 99.9363L94.9043 98.4573L103.376 97.245L102.779 98.6538Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1083 || (_path1083 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7325 72.5346L49.5209 76.5294L48.6722 72.9279L50.9238 68.8392L51.7325 72.5346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1084 || (_path1084 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8005 130.741L87.2012 130.383L91.6667 128.229L91.3611 128.502L86.8005 130.741Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1085 || (_path1085 = /*#__PURE__*/React.createElement("path", {
    d: "M125.706 96.7062L133.407 94.4716L134.18 96.0695L126.444 98.3228L125.706 96.7062Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask107 || (_mask107 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1193-inside-107_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.1064 134.569L85.5834 131.561L83.9363 132.446L79.3068 135.535L81.1064 134.569Z"
  }))), _path1086 || (_path1086 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1064 134.569L81.2957 134.921L81.3131 134.912L81.3295 134.901L81.1064 134.569ZM85.5834 131.561L85.8065 131.893L85.394 131.208L85.5834 131.561ZM83.9363 132.446L83.7469 132.094L83.7301 132.103L83.7143 132.114L83.9363 132.446ZM79.3068 135.535L79.0848 135.203L79.4961 135.888L79.3068 135.535ZM81.3295 134.901L85.8065 131.893L85.3603 131.229L80.8833 134.237L81.3295 134.901ZM85.394 131.208L83.7469 132.094L84.1257 132.799L85.7728 131.913L85.394 131.208ZM83.7143 132.114L79.0848 135.203L79.5288 135.868L84.1583 132.779L83.7143 132.114ZM79.4961 135.888L81.2957 134.921L80.9171 134.216L79.1175 135.183L79.4961 135.888Z",
    fill: "white",
    mask: "url(#path-1193-inside-107_1396_24002)"
  })), _mask108 || (_mask108 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1195-inside-108_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.027 91.0079L126.777 88.8906L125.283 88.9178L117.613 90.9729L119.027 91.0079Z"
  }))), _path1087 || (_path1087 = /*#__PURE__*/React.createElement("path", {
    d: "M119.027 91.0079L119.018 91.4077L119.076 91.4092L119.133 91.3937L119.027 91.0079ZM126.777 88.8906L126.883 89.2765L126.77 88.4907L126.777 88.8906ZM125.283 88.9178L125.276 88.5179L125.227 88.5187L125.18 88.5314L125.283 88.9178ZM117.613 90.9729L117.51 90.5866L117.603 91.3728L117.613 90.9729ZM119.133 91.3937L126.883 89.2765L126.672 88.5048L118.922 90.622L119.133 91.3937ZM126.77 88.4907L125.276 88.5179L125.29 89.3177L126.784 89.2906L126.77 88.4907ZM125.18 88.5314L117.51 90.5866L117.717 91.3593L125.387 89.3042L125.18 88.5314ZM117.603 91.3728L119.018 91.4077L119.037 90.608L117.623 90.5731L117.603 91.3728Z",
    fill: "white",
    mask: "url(#path-1195-inside-108_1396_24002)"
  })), _path1088 || (_path1088 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4876 141.886L74.1633 139.306L75.7244 138.949L74.2162 141.495L72.4876 141.886Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1089 || (_path1089 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5328 144.746L72.2107 142.362L74.0823 141.938L73.5802 144.286L71.5328 144.746Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1090 || (_path1090 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8654 108.352L75.9974 109.615L76.0933 107.251L83.9645 106.182L83.8654 108.352Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1091 || (_path1091 = /*#__PURE__*/React.createElement("path", {
    d: "M119.764 108.169L119.607 106.171L127.552 104.443L127.698 106.406L119.764 108.169Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1092 || (_path1092 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6247 121.939L59.3099 123.586L58.4987 120.416L62.8951 119.061L63.6247 121.939Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1093 || (_path1093 = /*#__PURE__*/React.createElement("path", {
    d: "M102.281 121.15L102.866 119.492L110.166 117.509L109.614 119.052L102.281 121.15Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1094 || (_path1094 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3363 146.921L76.5558 145.746L77.446 147.153L75.0668 148.409L74.3363 146.921Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1095 || (_path1095 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2307 126.648L52.1917 127.31L51.1054 123.125L52.2168 122.731L53.2307 126.648Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1096 || (_path1096 = /*#__PURE__*/React.createElement("path", {
    d: "M111.215 114.744L111.437 112.797L119.309 111.042L119.088 112.903L111.215 114.744Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask109 || (_mask109 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1206-inside-109_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7551 130.839L90.8585 132.768L89.136 137.733L89.9615 136.006L91.7551 130.839Z"
  }))), _path1097 || (_path1097 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7551 130.839L92.133 130.97L91.3924 130.67L91.7551 130.839ZM90.8585 132.768L90.4958 132.599L90.4873 132.617L90.4806 132.637L90.8585 132.768ZM89.136 137.733L88.7581 137.601L89.4969 137.905L89.136 137.733ZM89.9615 136.006L90.3224 136.178L90.3321 136.158L90.3394 136.137L89.9615 136.006ZM91.3924 130.67L90.4958 132.599L91.2213 132.936L92.1178 131.007L91.3924 130.67ZM90.4806 132.637L88.7581 137.601L89.5139 137.864L91.2364 132.899L90.4806 132.637ZM89.4969 137.905L90.3224 136.178L89.6007 135.833L88.7751 137.56L89.4969 137.905ZM90.3394 136.137L92.133 130.97L91.3772 130.708L89.5837 135.875L90.3394 136.137Z",
    fill: "white",
    mask: "url(#path-1206-inside-109_1396_24002)"
  })), _path1098 || (_path1098 = /*#__PURE__*/React.createElement("path", {
    d: "M124.664 94.9484L132.303 92.7467L133.199 94.1147L125.52 96.343L124.664 94.9484Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1099 || (_path1099 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7358 112.521L68.8242 113.884L68.665 111.207L75.601 110.086L75.7358 112.521Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1100 || (_path1100 = /*#__PURE__*/React.createElement("path", {
    d: "M119.757 91.0201L126.778 89.102L127.475 89.2696L120.446 91.2232L119.757 91.0201Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1101 || (_path1101 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8831 117.044L63.2004 118.555L62.7375 115.599L68.4721 114.365L68.8831 117.044Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1102 || (_path1102 = /*#__PURE__*/React.createElement("path", {
    d: "M114.255 92.3544L106.617 93.8052L107.116 93.441L114.74 92.0025L114.255 92.3544Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1103 || (_path1103 = /*#__PURE__*/React.createElement("path", {
    d: "M60.252 51.9552L63.8959 51.4415L64.3197 55.0506L60.682 55.5541L60.252 51.9552Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1104 || (_path1104 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0409 147.224L80.2669 145.253L81.4275 145.968L79.0675 148.052L78.0409 147.224Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1105 || (_path1105 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9387 123.739L55.8875 125.162L54.9851 121.658L58.1202 120.54L58.9387 123.739Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1106 || (_path1106 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5202 125.346L53.5887 126.438L52.5934 122.592L54.6067 121.801L55.5202 125.346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1107 || (_path1107 = /*#__PURE__*/React.createElement("path", {
    d: "M123.493 93.4723L131.05 91.3147L132.027 92.4102L124.425 94.6012L123.493 93.4723Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1108 || (_path1108 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2267 102.148L84.8135 103.264L85.3074 101.412L93.6978 100.423L93.2267 102.148Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1109 || (_path1109 = /*#__PURE__*/React.createElement("path", {
    d: "M128.25 89.4654L129.183 89.9371L121.855 92.004L120.959 91.4919L128.25 89.4654Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1110 || (_path1110 = /*#__PURE__*/React.createElement("path", {
    d: "M86.216 142.23L87.9594 138.846L88.5692 138.399L86.775 141.876L86.216 142.23Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1111 || (_path1111 = /*#__PURE__*/React.createElement("path", {
    d: "M129.689 90.2095L130.688 91.0009L123.195 93.1401L122.241 92.3103L129.689 90.2095Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1112 || (_path1112 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4909 125.439L95.2427 123.979L101.554 121.806L100.863 123.134L94.4909 125.439Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1113 || (_path1113 = /*#__PURE__*/React.createElement("path", {
    d: "M82.128 145.784L84.228 142.988L85.301 142.989L83.1023 145.91L82.128 145.784Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1114 || (_path1114 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4347 60.361L56.5611 57.8504L57.266 61.7022L54.171 64.1723L53.4347 60.361Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1115 || (_path1115 = /*#__PURE__*/React.createElement("path", {
    d: "M77.27 137.817L79.4272 135.699L80.0222 135.379L77.9836 137.434L77.27 137.817Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1116 || (_path1116 = /*#__PURE__*/React.createElement("path", {
    d: "M103.578 96.8139L95.1546 98.0193L95.8751 96.8297L104.271 95.6839L103.578 96.8139Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1117 || (_path1117 = /*#__PURE__*/React.createElement("path", {
    d: "M50.122 81.1388L48.4647 85.5524L47.6917 82.3386L49.3923 77.7865L50.122 81.1388Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1118 || (_path1118 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4071 118.177L49.9065 118.361L50.6321 122.806L50.167 122.819L49.4071 118.177Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1119 || (_path1119 = /*#__PURE__*/React.createElement("path", {
    d: "M119.555 105.773L119.208 103.8L127.172 102.104L127.505 104.043L119.555 105.773Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1120 || (_path1120 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2299 146.525L73.9652 144.562L75.9659 143.497L76.3956 145.379L74.2299 146.525Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1121 || (_path1121 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7335 129.681L88.5384 128.6L93.4427 126.317L92.7278 127.272L87.7335 129.681Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask110 || (_mask110 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1232-inside-110_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7496 133.097L87.0886 130.214L85.5847 131.561L81.1077 134.569L82.7496 133.097Z"
  }))), _path1122 || (_path1122 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7496 133.097L82.5282 132.764L82.5041 132.78L82.4826 132.799L82.7496 133.097ZM87.0886 130.214L87.3554 130.512L86.8672 129.881L87.0886 130.214ZM85.5847 131.561L85.8078 131.893L85.8308 131.877L85.8515 131.859L85.5847 131.561ZM81.1077 134.569L80.8407 134.271L81.3308 134.901L81.1077 134.569ZM82.9709 133.43L87.3099 130.547L86.8672 129.881L82.5282 132.764L82.9709 133.43ZM86.8218 129.916L85.3179 131.263L85.8515 131.859L87.3554 130.512L86.8218 129.916ZM85.3616 131.229L80.8847 134.236L81.3308 134.901L85.8078 131.893L85.3616 131.229ZM81.3747 134.866L83.0166 133.395L82.4826 132.799L80.8407 134.271L81.3747 134.866Z",
    fill: "white",
    mask: "url(#path-1232-inside-110_1396_24002)"
  })), _mask111 || (_mask111 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1234-inside-111_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.036 93.2511L115.58 91.6389L116.918 91.1014L108.387 92.7066L107.036 93.2511Z"
  }))), _path1123 || (_path1123 = /*#__PURE__*/React.createElement("path", {
    d: "M107.036 93.2511L106.886 92.8801L107.11 93.6441L107.036 93.2511ZM115.58 91.6389L115.654 92.0319L115.693 92.0246L115.729 92.01L115.58 91.6389ZM116.918 91.1014L117.067 91.4726L116.844 90.7083L116.918 91.1014ZM108.387 92.7066L108.313 92.3135L108.274 92.3208L108.237 92.3356L108.387 92.7066ZM107.11 93.6441L115.654 92.0319L115.506 91.2458L106.962 92.858L107.11 93.6441ZM115.729 92.01L117.067 91.4726L116.769 90.7303L115.431 91.2677L115.729 92.01ZM116.844 90.7083L108.313 92.3135L108.461 93.0997L116.992 91.4945L116.844 90.7083ZM108.237 92.3356L106.886 92.8801L107.185 93.6221L108.536 93.0776L108.237 92.3356Z",
    fill: "white",
    mask: "url(#path-1234-inside-111_1396_24002)"
  })), _path1124 || (_path1124 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9998 105.775L76.1362 106.844L76.457 104.611L84.3053 103.727L83.9998 105.775Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1125 || (_path1125 = /*#__PURE__*/React.createElement("path", {
    d: "M102.979 119.05L103.399 117.142L110.717 115.279L110.315 117.058L102.979 119.05Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1126 || (_path1126 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8797 141.159L76.2762 138.802L77.6047 138.091L76.3542 140.371L74.8797 141.159Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1127 || (_path1127 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8132 118.665L58.4193 120.019L57.8974 116.74L62.3469 115.688L62.8132 118.665Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask112 || (_mask112 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1240-inside-112_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.962 105.697L94.0488 109.249L94.0299 115.934L93.9431 112.531L93.962 105.697Z"
  }))), _path1128 || (_path1128 = /*#__PURE__*/React.createElement("path", {
    d: "M93.962 105.697L94.3618 105.687L93.562 105.696L93.962 105.697ZM94.0488 109.249L94.4489 109.25L94.4487 109.239L94.0488 109.249ZM94.0299 115.934L93.6301 115.944L94.4299 115.935L94.0299 115.934ZM93.9431 112.531L93.543 112.53L93.5432 112.541L93.9431 112.531ZM93.5621 105.707L93.6489 109.259L94.4487 109.239L94.3618 105.687L93.5621 105.707ZM93.6488 109.248L93.6299 115.933L94.4299 115.935L94.4488 109.25L93.6488 109.248ZM94.4298 115.923L94.343 112.521L93.5432 112.541L93.6301 115.944L94.4298 115.923ZM94.3431 112.532L94.362 105.698L93.562 105.696L93.5431 112.53L94.3431 112.532Z",
    fill: "white",
    mask: "url(#path-1240-inside-112_1396_24002)"
  })), _path1129 || (_path1129 = /*#__PURE__*/React.createElement("path", {
    d: "M111.457 112.386L111.484 110.332L119.379 108.665L119.344 110.628L111.457 112.386Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1130 || (_path1130 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0345 144.07L74.5195 141.802L76.2451 140.88L75.9204 143.067L74.0345 144.07Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1131 || (_path1131 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4408 112.419L48.5905 112.724L48.9006 117.115L48.7584 116.897L48.4408 112.419Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1132 || (_path1132 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3622 74.8582L87.094 72.3517L89.0696 77.2712L89.3339 79.7628L87.3622 74.8582Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1133 || (_path1133 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9611 89.8534L47.8749 94.4075L47.2881 91.8849L48.4095 87.1606L48.9611 89.8534Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1134 || (_path1134 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5942 109.683L68.6623 110.804L68.7566 108.191L75.6907 107.307L75.5942 109.683Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1135 || (_path1135 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4278 113.966L62.6957 115.199L62.5085 112.228L68.2676 111.273L68.4278 113.966Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1136 || (_path1136 = /*#__PURE__*/React.createElement("path", {
    d: "M119.119 103.409L118.593 101.524L126.575 99.8618L127.084 101.714L119.119 103.409Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1137 || (_path1137 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1328 122.336L51.0257 122.728L50.3174 118.388L51.473 118.273L52.1328 122.336Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1138 || (_path1138 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8285 100.002L85.4623 100.989L86.1203 99.3831L94.4503 98.5096L93.8285 100.002Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1139 || (_path1139 = /*#__PURE__*/React.createElement("path", {
    d: "M104.56 95.2402L96.258 96.3733L97.0084 95.523L105.275 94.4372L104.56 95.2402Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1140 || (_path1140 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9377 105.317L48.0971 105.973L47.9992 110.109L47.8388 109.555L47.9377 105.317Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1141 || (_path1141 = /*#__PURE__*/React.createElement("path", {
    d: "M47.354 101.095L47.9195 96.5317L48.2626 98.2521L47.7148 102.65L47.354 101.095Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1142 || (_path1142 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0352 120.148L54.9042 121.265L54.3199 117.639L57.5081 116.838L58.0352 120.148Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask113 || (_mask113 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1256-inside-113_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.387 92.7086L116.918 91.1035L118.316 90.9459L109.8 92.5499L108.387 92.7086Z"
  }))), _path1143 || (_path1143 = /*#__PURE__*/React.createElement("path", {
    d: "M108.387 92.7086L108.313 92.3155L108.431 93.1061L108.387 92.7086ZM116.918 91.1035L116.873 90.706L116.858 90.7077L116.844 90.7104L116.918 91.1035ZM118.316 90.9459L118.39 91.339L118.271 90.5484L118.316 90.9459ZM109.8 92.5499L109.845 92.9474L109.86 92.9457L109.874 92.943L109.8 92.5499ZM108.46 93.1017L116.992 91.4966L116.844 90.7104L108.313 92.3155L108.46 93.1017ZM116.963 91.501L118.361 91.3434L118.271 90.5484L116.873 90.706L116.963 91.501ZM118.242 90.5528L109.726 92.1568L109.874 92.943L118.39 91.339L118.242 90.5528ZM109.756 92.1524L108.342 92.3111L108.431 93.1061L109.845 92.9474L109.756 92.1524Z",
    fill: "white",
    mask: "url(#path-1256-inside-113_1396_24002)"
  })), _path1144 || (_path1144 = /*#__PURE__*/React.createElement("path", {
    d: "M77.7745 146.926L76.8862 145.521L78.9346 143.7L79.9697 144.981L77.7745 146.926Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1145 || (_path1145 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4279 123.492L96.056 121.686L102.39 119.644L101.808 121.295L95.4279 123.492Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1146 || (_path1146 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5225 121.405L52.5147 122.195L51.8677 118.212L53.9307 117.732L54.5225 121.405Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask114 || (_mask114 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1261-inside-114_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9031 135.983L82.7493 133.095L81.1074 134.567L78.105 137.594L79.9031 135.983Z"
  }))), _path1147 || (_path1147 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9031 135.983L80.17 136.281L80.1793 136.273L80.188 136.264L79.9031 135.983ZM82.7493 133.095L83.0342 133.376L82.4824 132.797L82.7493 133.095ZM81.1074 134.567L80.8404 134.269L80.8317 134.277L80.8234 134.285L81.1074 134.567ZM78.105 137.594L77.821 137.312L78.372 137.892L78.105 137.594ZM80.188 136.264L83.0342 133.376L82.4645 132.814L79.6182 135.702L80.188 136.264ZM82.4824 132.797L80.8404 134.269L81.3744 134.865L83.0163 133.393L82.4824 132.797ZM80.8234 134.285L77.821 137.312L78.389 137.876L81.3914 134.849L80.8234 134.285ZM78.372 137.892L80.17 136.281L79.6362 135.685L77.8381 137.296L78.372 137.892Z",
    fill: "white",
    mask: "url(#path-1261-inside-114_1396_24002)"
  })), _path1148 || (_path1148 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7207 55.046L64.2986 51.45L68.0441 51.9971L68.4595 55.5985L64.7207 55.046Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask115 || (_mask115 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1264-inside-115_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.6208 87.8846L92.0274 91.8574L93.3205 98.7427L92.9296 94.859L91.6208 87.8846Z"
  }))), _path1149 || (_path1149 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6208 87.8846L92.014 87.8109L91.2229 87.9254L91.6208 87.8846ZM92.0274 91.8574L91.6294 91.8981L91.6312 91.9147L91.6342 91.9312L92.0274 91.8574ZM93.3205 98.7427L92.9274 98.8165L93.7185 98.7026L93.3205 98.7427ZM92.9296 94.859L93.3276 94.8189L93.3259 94.802L93.3227 94.7852L92.9296 94.859ZM91.2229 87.9254L91.6294 91.8981L92.4253 91.8166L92.0188 87.8439L91.2229 87.9254ZM91.6342 91.9312L92.9274 98.8165L93.7136 98.6689L92.4205 91.7835L91.6342 91.9312ZM93.7185 98.7026L93.3276 94.8189L92.5316 94.899L92.9225 98.7828L93.7185 98.7026ZM93.3227 94.7852L92.014 87.8109L91.2277 87.9584L92.5364 94.9327L93.3227 94.7852Z",
    fill: "white",
    mask: "url(#path-1264-inside-115_1396_24002)"
  })), _path1150 || (_path1150 = /*#__PURE__*/React.createElement("path", {
    d: "M118.467 101.145L117.782 99.4079L125.778 97.7774L126.445 99.4832L118.467 101.145Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1151 || (_path1151 = /*#__PURE__*/React.createElement("path", {
    d: "M111.466 109.926L111.292 107.831L119.212 106.255L119.37 108.257L111.466 109.926Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1152 || (_path1152 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8526 128.011L89.66 126.431L94.6663 124.224L93.9345 125.645L88.8526 128.011Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1153 || (_path1153 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5913 132.294L84.3289 131.3L87.5899 129.201L86.9474 130.064L83.5913 132.294Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1154 || (_path1154 = /*#__PURE__*/React.createElement("path", {
    d: "M103.46 116.716L103.688 114.626L111.022 112.896L110.8 114.847L103.46 116.716Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1155 || (_path1155 = /*#__PURE__*/React.createElement("path", {
    d: "M111.237 92.5793L110.962 92.535L118.319 91.1493L118.575 91.1902L111.237 92.5793Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1156 || (_path1156 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3849 103.314L76.5497 104.196L77.0806 102.161L84.8822 101.45L84.3849 103.314Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask116 || (_mask116 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1273-inside-116_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0303 115.931L93.6299 118.889L92.9918 125.084L93.3716 122.322L94.0303 115.931Z"
  }))), _path1157 || (_path1157 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0303 115.931L94.4282 115.972L93.6339 115.877L94.0303 115.931ZM93.6299 118.889L93.2333 118.835L93.232 118.848L93.6299 118.889ZM92.9918 125.084L92.5939 125.043L93.388 125.138L92.9918 125.084ZM93.3716 122.322L93.7681 122.377L93.7695 122.363L93.3716 122.322ZM93.6339 115.877L93.2335 118.835L94.0263 118.942L94.4267 115.985L93.6339 115.877ZM93.232 118.848L92.5939 125.043L93.3897 125.125L94.0278 118.93L93.232 118.848ZM93.388 125.138L93.7678 122.377L92.9753 122.268L92.5955 125.029L93.388 125.138ZM93.7695 122.363L94.4282 115.972L93.6324 115.89L92.9737 122.281L93.7695 122.363Z",
    fill: "white",
    mask: "url(#path-1273-inside-116_1396_24002)"
  })), _path1158 || (_path1158 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2195 68.3289L53.9258 64.9913L54.7052 68.8621L52.049 72.1193L51.2195 68.3289Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1159 || (_path1159 = /*#__PURE__*/React.createElement("path", {
    d: "M62.301 115.287L57.8549 116.338L57.6378 113.039L62.1124 112.293L62.301 115.287Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1160 || (_path1160 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2384 139.593L78.2641 137.723L79.2263 136.86L78.3099 138.635L77.2384 139.593Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1161 || (_path1161 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5196 142.298L83.8155 142.869L81.7103 145.671L80.5354 144.947L82.5196 142.298Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1162 || (_path1162 = /*#__PURE__*/React.createElement("path", {
    d: "M117.614 99.0316L116.797 97.4984L124.803 95.8982L125.601 97.4031L117.614 99.0316Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1163 || (_path1163 = /*#__PURE__*/React.createElement("path", {
    d: "M105.706 93.9742L97.6533 95.0318L98.2783 94.5722L106.289 93.5482L105.706 93.9742Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1164 || (_path1164 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7455 145.11L76.325 143.269L78.1578 141.635L78.7265 143.349L76.7455 145.11Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1165 || (_path1165 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3265 69.2096L84.0094 66.2799L86.5448 70.9973L86.8568 73.9132L84.3265 69.2096Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1166 || (_path1166 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0183 113.091L49.5546 113.491L49.8648 117.915L49.3455 117.724L49.0183 113.091Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1167 || (_path1167 = /*#__PURE__*/React.createElement("path", {
    d: "M112.687 93.194L111.915 92.8598L119.713 91.3837L120.466 91.7085L112.687 93.194Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1168 || (_path1168 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6447 98.0886L86.3574 98.9577L87.1374 97.6536L95.3761 96.8808L94.6447 98.0886Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1169 || (_path1169 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7256 106.897L68.7987 107.78L69.1421 105.306L76.0483 104.651L75.7256 106.897Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1170 || (_path1170 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3829 142.683L76.689 140.621L78.2275 139.245L78.0596 141.187L76.3829 142.683Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1171 || (_path1171 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2599 110.868L62.5052 111.823L62.599 108.919L68.3549 108.239L68.2599 110.868Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1172 || (_path1172 = /*#__PURE__*/React.createElement("path", {
    d: "M116.585 97.1348L115.673 95.8545L123.679 94.2827L124.57 95.5385L116.585 97.1348Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1173 || (_path1173 = /*#__PURE__*/React.createElement("path", {
    d: "M114.088 94.1748L113.161 93.5095L121.098 91.9938L122.005 92.6441L114.088 94.1748Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1174 || (_path1174 = /*#__PURE__*/React.createElement("path", {
    d: "M56.9244 57.6043L60.3549 56.0681L61.0321 59.9918L57.6373 61.4996L56.9244 57.6043Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1175 || (_path1175 = /*#__PURE__*/React.createElement("path", {
    d: "M115.396 95.5014L114.441 94.5145L122.43 92.9699L123.365 93.9368L115.396 95.5014Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1176 || (_path1176 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4293 131.066L92.2372 127.298L92.3841 126.964L91.5666 130.771L91.4293 131.066Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1177 || (_path1177 = /*#__PURE__*/React.createElement("path", {
    d: "M111.237 107.429L110.865 105.361L118.814 103.875L119.162 105.852L111.237 107.429Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1178 || (_path1178 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1681 121.227L96.6178 119.147L102.963 117.265L102.542 119.172L96.1681 121.227Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1179 || (_path1179 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4547 142.589L86.2375 139.12L87.4497 138.959L85.5786 142.59L84.4547 142.589Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1180 || (_path1180 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8757 55.6947L68.4655 52.1389L72.1973 53.7306L72.6004 57.2876L68.8757 55.6947Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1181 || (_path1181 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4599 116.432L54.2757 117.233L54.0282 113.582L57.2407 113.1L57.4599 116.432Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1182 || (_path1182 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2019 138.166L89.6111 134.095L90.4289 133.395L88.9689 137.603L88.2019 138.166Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask117 || (_mask117 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1300-inside-117_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.4801 133.853L84.19 131.151L82.7482 133.094L79.902 135.981L81.4801 133.853Z"
  }))), _path1183 || (_path1183 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4801 133.853L81.1977 133.57L81.1766 133.591L81.1588 133.615L81.4801 133.853ZM84.19 131.151L84.5112 131.39L83.9076 130.868L84.19 131.151ZM82.7482 133.094L83.0331 133.374L83.0527 133.354L83.0694 133.332L82.7482 133.094ZM79.902 135.981L79.5807 135.743L80.1869 136.262L79.902 135.981ZM81.7626 134.137L84.4724 131.435L83.9076 130.868L81.1977 133.57L81.7626 134.137ZM83.8688 130.913L82.427 132.855L83.0694 133.332L84.5112 131.39L83.8688 130.913ZM82.4633 132.813L79.6171 135.701L80.1869 136.262L83.0331 133.374L82.4633 132.813ZM80.2233 136.22L81.8014 134.092L81.1588 133.615L79.5807 135.743L80.2233 136.22Z",
    fill: "white",
    mask: "url(#path-1300-inside-117_1396_24002)"
  })), _path1184 || (_path1184 = /*#__PURE__*/React.createElement("path", {
    d: "M103.708 114.207L103.727 112.001L111.083 110.414L111.057 112.473L103.708 114.207Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1185 || (_path1185 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4261 117.877L50.2696 117.992L49.9631 113.62L51.1429 113.786L51.4261 117.877Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask118 || (_mask118 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1304-inside-118_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.2015 94.3826L107.035 93.2535L108.386 92.709L99.5987 93.8168L98.2015 94.3826Z"
  }))), _path1186 || (_path1186 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2015 94.3826L98.0514 94.0118L98.2523 94.7793L98.2015 94.3826ZM107.035 93.2535L107.086 93.6502L107.137 93.6437L107.185 93.6245L107.035 93.2535ZM108.386 92.709L108.536 93.08L108.336 92.3121L108.386 92.709ZM99.5987 93.8168L99.5487 93.4199L99.497 93.4265L99.4486 93.446L99.5987 93.8168ZM98.2523 94.7793L107.086 93.6502L106.984 92.8567L98.1508 93.9858L98.2523 94.7793ZM107.185 93.6245L108.536 93.08L108.237 92.338L106.886 92.8825L107.185 93.6245ZM108.336 92.3121L99.5487 93.4199L99.6488 94.2137L108.436 93.1058L108.336 92.3121ZM99.4486 93.446L98.0514 94.0118L98.3517 94.7533L99.7489 94.1876L99.4486 93.446Z",
    fill: "white",
    mask: "url(#path-1304-inside-118_1396_24002)"
  })), _path1187 || (_path1187 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8619 64.3477L80.512 61.1598L83.5084 65.3572L83.8523 68.5339L80.8619 64.3477Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1188 || (_path1188 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8806 117.334L51.8213 117.813L51.5434 113.798L53.6296 113.632L53.8806 117.334Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1189 || (_path1189 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4725 106.978L48.7081 107.599L48.6058 111.852L48.3686 111.368L48.4725 106.978Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1190 || (_path1190 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8529 125.911L90.5324 123.937L95.5651 121.879L94.9433 123.667L89.8529 125.911Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1191 || (_path1191 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0099 101.041L77.2302 101.75L77.9452 99.9776L85.6736 99.4209L85.0099 101.041Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1192 || (_path1192 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5515 76.7547L50.4144 80.5951L49.6561 77.1115L51.852 73.1453L52.5515 76.7547Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1193 || (_path1193 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7033 130.586L85.5458 128.93L89.0128 126.818L88.2548 128.3L84.7033 130.586Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1194 || (_path1194 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0263 57.4957L72.632 54.0168L76.2323 56.5957L76.6197 60.0712L73.0263 57.4957Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1195 || (_path1195 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6557 96.449L87.4986 97.2143L88.3314 96.2613L96.4291 95.5726L95.6557 96.449Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1196 || (_path1196 = /*#__PURE__*/React.createElement("path", {
    d: "M110.778 104.973L110.219 102.997L118.201 101.6L118.727 103.487L110.778 104.973Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1197 || (_path1197 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1883 142.072L80.2379 144.677L79.2101 143.405L81.0309 140.965L82.1883 142.072Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1198 || (_path1198 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0575 60.4086L76.6829 57.0481L80.0366 60.5119L80.4046 63.8649L77.0575 60.4086Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask119 || (_mask119 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1318-inside-119_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.3193 98.7393L93.4193 102.443L94.0483 109.244L93.9615 105.692L93.3193 98.7393Z"
  }))), _path1199 || (_path1199 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3193 98.7393L93.7176 98.7025L92.9195 98.75L93.3193 98.7393ZM93.4193 102.443L93.0194 102.453L93.0198 102.466L93.021 102.479L93.4193 102.443ZM94.0483 109.244L93.65 109.281L94.4482 109.234L94.0483 109.244ZM93.9615 105.692L94.3614 105.682L94.3611 105.669L94.3598 105.655L93.9615 105.692ZM92.9195 98.75L93.0194 102.453L93.8191 102.432L93.7192 98.7285L92.9195 98.75ZM93.021 102.479L93.65 109.281L94.4466 109.207L93.8176 102.406L93.021 102.479ZM94.4482 109.234L94.3614 105.682L93.5616 105.702L93.6484 109.254L94.4482 109.234ZM94.3598 105.655L93.7176 98.7025L92.921 98.776L93.5632 105.729L94.3598 105.655Z",
    fill: "white",
    mask: "url(#path-1318-inside-119_1396_24002)"
  })), _path1200 || (_path1200 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1029 111.893L57.6328 112.638L57.7277 109.411L62.1976 108.966L62.1029 111.893Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask120 || (_mask120 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1321-inside-120_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5995 93.8144L108.387 92.7066L109.8 92.5479L101.064 93.6501L99.5995 93.8144Z"
  }))), _path1201 || (_path1201 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5995 93.8144L99.5495 93.4176L99.6441 94.212L99.5995 93.8144ZM108.387 92.7066L108.342 92.3091L108.337 92.3098L108.387 92.7066ZM109.8 92.5479L109.85 92.9447L109.756 92.1504L109.8 92.5479ZM101.064 93.6501L101.109 94.0476L101.114 94.0469L101.064 93.6501ZM99.6495 94.2113L108.437 93.1035L108.337 92.3098L99.5495 93.4176L99.6495 94.2113ZM108.431 93.1041L109.845 92.9454L109.756 92.1504L108.342 92.3091L108.431 93.1041ZM109.75 92.151L101.014 93.2532L101.114 94.0469L109.85 92.9447L109.75 92.151ZM101.019 93.2526L99.5549 93.4169L99.6441 94.212L101.109 94.0476L101.019 93.2526Z",
    fill: "white",
    mask: "url(#path-1321-inside-120_1396_24002)"
  })), _path1202 || (_path1202 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1232 104.244L69.2289 104.898L69.8067 102.639L76.6579 102.195L76.1232 104.244Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1203 || (_path1203 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7793 136.659L80.0731 136.09L80.2898 135.798L80.0268 136.326L79.7793 136.659Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1204 || (_path1204 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3088 85.1886L90.1205 83.4073L91.4232 87.9207L91.6014 89.6623L90.3088 85.1886Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1205 || (_path1205 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9756 103.78L48.508 99.5061L48.7489 100.728L48.234 104.844L47.9756 103.78Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1206 || (_path1206 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3873 107.83L62.6383 108.509L63.0096 105.756L68.7332 105.339L68.3873 107.83Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1207 || (_path1207 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7965 84.9667L49.2223 89.14L48.6306 86.2518L50.2601 81.9123L50.7965 84.9667Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1208 || (_path1208 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6772 118.715L96.9165 116.433L103.275 114.731L103.047 116.826L96.6772 118.715Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1209 || (_path1209 = /*#__PURE__*/React.createElement("path", {
    d: "M103.705 111.6L103.509 109.351L110.896 107.909L111.071 110.01L103.705 111.6Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1210 || (_path1210 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4954 93.0827L48.4821 97.3142L48.0773 95.2843L49.1303 90.8694L49.4954 93.0827Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1211 || (_path1211 = /*#__PURE__*/React.createElement("path", {
    d: "M110.091 102.614L109.367 100.794L117.382 99.4803L118.068 101.218L110.091 102.614Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1212 || (_path1212 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7755 140.637L79.0266 142.981L78.4742 141.315L80.0956 139.136L80.7755 140.637Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1213 || (_path1213 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5109 140.597L78.6635 138.831L79.9806 137.057L79.9388 138.677L78.5109 140.597Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1214 || (_path1214 = /*#__PURE__*/React.createElement("path", {
    d: "M102.56 93.6917L102.464 93.6762L109.797 92.7511L109.842 92.7585L102.56 93.6917Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1215 || (_path1215 = /*#__PURE__*/React.createElement("path", {
    d: "M49.0969 108.079L49.661 108.72L49.5556 112.995L48.9888 112.573L49.0969 108.079Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1216 || (_path1216 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8633 99.0033L78.1734 99.5572L79.0312 98.1052L86.6538 97.6815L85.8633 99.0033Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1217 || (_path1217 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8365 95.1402L88.9202 95.8135L89.6713 95.2572L97.5191 94.6383L96.8365 95.1402Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1218 || (_path1218 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2304 112.701L54.022 113.182L54.1192 109.607L57.3263 109.439L57.2304 112.701Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1219 || (_path1219 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2245 132.831L82.9598 131.383L84.6857 129.739L84.0263 131.035L82.2245 132.831Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1220 || (_path1220 = /*#__PURE__*/React.createElement("path", {
    d: "M84.407 138.678L85.8163 139.063L84.0349 142.529L82.7294 141.954L84.407 138.678Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1221 || (_path1221 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6466 123.458L91.1327 121.173L96.1748 119.306L95.726 121.382L90.6466 123.458Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1222 || (_path1222 = /*#__PURE__*/React.createElement("path", {
    d: "M109.198 100.415L108.338 98.8096L116.385 97.5718L117.201 99.1027L109.198 100.415Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1223 || (_path1223 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4186 59.8848L60.7391 55.9476L64.3742 55.4443L65.0152 59.3967L61.4186 59.8848Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1224 || (_path1224 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2598 64.616L57.35 62.1499L58.0841 66.1527L55.053 68.556L54.2598 64.616Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1225 || (_path1225 = /*#__PURE__*/React.createElement("path", {
    d: "M104.067 94.3317L103.303 93.9996L111.21 92.9864L111.923 93.2949L104.067 94.3317Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1226 || (_path1226 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7633 128.329L86.4927 126.193L90.013 124.215L89.3495 126.143L85.7633 128.329Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask121 || (_mask121 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1348-inside-121_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.0487 109.248L93.6462 112.411L93.6295 118.89L94.0298 115.932L94.0487 109.248Z"
  }))), _path1227 || (_path1227 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0487 109.248L94.4487 109.249L93.6519 109.197L94.0487 109.248ZM93.6462 112.411L93.2494 112.36L93.2463 112.385L93.2462 112.41L93.6462 112.411ZM93.6295 118.89L93.2295 118.889L94.0258 118.943L93.6295 118.89ZM94.0298 115.932L94.4262 115.986L94.4298 115.959L94.4298 115.933L94.0298 115.932ZM93.6519 109.197L93.2494 112.36L94.043 112.461L94.4455 109.298L93.6519 109.197ZM93.2462 112.41L93.2295 118.889L94.0295 118.891L94.0462 112.412L93.2462 112.41ZM94.0258 118.943L94.4262 115.986L93.6335 115.878L93.2331 118.836L94.0258 118.943ZM94.4298 115.933L94.4487 109.249L93.6487 109.247L93.6298 115.931L94.4298 115.933Z",
    fill: "white",
    mask: "url(#path-1348-inside-121_1396_24002)"
  })), _path1228 || (_path1228 = /*#__PURE__*/React.createElement("path", {
    d: "M108.121 98.4401L107.165 97.1015L115.237 95.9313L116.145 97.2058L108.121 98.4401Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1229 || (_path1229 = /*#__PURE__*/React.createElement("path", {
    d: "M105.522 95.3601L104.566 94.6732L112.614 93.611L113.518 94.2596L105.522 95.3601Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1230 || (_path1230 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0574 108.934L51.2409 109.381L51.1383 113.382L49.9518 113.214L50.0574 108.934Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1231 || (_path1231 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6229 113.226L51.5383 113.392L51.6392 109.456L53.7214 109.599L53.6229 113.226Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1232 || (_path1232 = /*#__PURE__*/React.createElement("path", {
    d: "M110.845 107.51L103.454 108.952L103.045 106.731L110.471 105.435L110.845 107.51Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1233 || (_path1233 = /*#__PURE__*/React.createElement("path", {
    d: "M106.884 96.7364L105.887 95.7079L113.967 94.5957L114.913 95.5724L106.884 96.7364Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1234 || (_path1234 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7833 101.785L69.952 102.227L70.7383 100.25L77.5049 99.9956L76.7833 101.785Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1235 || (_path1235 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9336 116.013L96.9443 113.605L103.326 112.093L103.307 114.306L96.9336 116.013Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1236 || (_path1236 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2287 108.557L57.765 109.001L58.1683 105.936L62.6031 105.779L62.2287 108.557Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1237 || (_path1237 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4032 138.696L87.803 134.637L89.1278 134.276L87.6552 138.53L86.4032 138.696Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1238 || (_path1238 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1567 94.1862L90.8676 94.761L91.1209 94.6579L98.3367 94.1133L98.1567 94.1862Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1239 || (_path1239 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8058 104.937L63.0931 105.354L63.7268 102.832L69.3885 102.658L68.8058 104.937Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask122 || (_mask122 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1362-inside-122_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.6384 133.592L82.7968 131.262L81.4801 133.857L80.197 136.432L81.6384 133.592Z"
  }))), _path1240 || (_path1240 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6384 133.592L81.9951 133.773L81.9965 133.77L81.6384 133.592ZM82.7968 131.262L83.155 131.441L82.4401 131.081L82.7968 131.262ZM81.4801 133.857L81.1234 133.676L81.1221 133.678L81.4801 133.857ZM80.197 136.432L79.839 136.253L80.5537 136.613L80.197 136.432ZM81.9965 133.77L83.155 131.441L82.4387 131.084L81.2802 133.414L81.9965 133.77ZM82.4401 131.081L81.1234 133.676L81.8368 134.038L83.1535 131.443L82.4401 131.081ZM81.1221 133.678L79.839 136.253L80.555 136.61L81.8381 134.035L81.1221 133.678ZM80.5537 136.613L81.995 133.773L81.2817 133.411L79.8403 136.25L80.5537 136.613Z",
    fill: "white",
    mask: "url(#path-1362-inside-122_1396_24002)"
  })), _path1241 || (_path1241 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3736 125.991L92.8511 121.333L93.2874 120.26L92.7961 125.03L92.3736 125.991Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1242 || (_path1242 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5012 105.927L49.0297 101.702L49.3195 102.692L48.8106 106.742L48.5012 105.927Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1243 || (_path1243 = /*#__PURE__*/React.createElement("path", {
    d: "M87.819 78.9922L87.5252 76.3366L89.4878 81.2186L89.7631 83.8228L87.819 78.9922Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1244 || (_path1244 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9233 97.2647L79.3734 97.6844L80.309 96.6038L87.7771 96.2879L86.9233 97.2647Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1245 || (_path1245 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3993 141.724L81.2519 140.626L82.7902 137.611L84.0465 138.507L82.3993 141.724Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1246 || (_path1246 = /*#__PURE__*/React.createElement("path", {
    d: "M89.759 133.447L90.7472 128.82L91.7076 127.86L90.6786 132.659L89.759 133.447Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1247 || (_path1247 = /*#__PURE__*/React.createElement("path", {
    d: "M102.955 106.342L102.348 104.22L109.82 103.065L110.38 105.046L102.955 106.342Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1248 || (_path1248 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1911 120.722L91.4461 118.209L96.5007 116.559L96.2611 118.845L91.1911 120.722Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1249 || (_path1249 = /*#__PURE__*/React.createElement("path", {
    d: "M93.1518 99.9394L92.3518 95.6868L92.3116 94.4579L93.12 98.7621L93.1518 99.9394Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1250 || (_path1250 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1578 72.621L54.7974 69.3838L55.4432 73.2022L52.877 76.3323L52.1578 72.621Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1251 || (_path1251 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5107 135.609L80.3609 137.869L80.3966 136.483L81.4668 134.374L81.5107 135.609Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask123 || (_mask123 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1375-inside-123_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.0731 94.4597L99.599 93.8162L101.063 93.6519L92.6223 94.2855L91.0731 94.4597Z"
  }))), _path1252 || (_path1252 = /*#__PURE__*/React.createElement("path", {
    d: "M91.0731 94.4597L91.0284 94.0622L91.1032 94.8586L91.0731 94.4597ZM99.599 93.8162L99.6291 94.2151L99.6363 94.2146L99.6436 94.2137L99.599 93.8162ZM101.063 93.6519L101.108 94.0494L101.033 93.253L101.063 93.6519ZM92.6223 94.2855L92.5924 93.8866L92.585 93.8872L92.5776 93.888L92.6223 94.2855ZM91.1032 94.8586L99.6291 94.2151L99.5689 93.4174L91.043 94.0608L91.1032 94.8586ZM99.6436 94.2137L101.108 94.0494L101.019 93.2544L99.5543 93.4187L99.6436 94.2137ZM101.033 93.253L92.5924 93.8866L92.6523 94.6844L101.093 94.0507L101.033 93.253ZM92.5776 93.888L91.0284 94.0622L91.1178 94.8572L92.667 94.683L92.5776 93.888Z",
    fill: "white",
    mask: "url(#path-1375-inside-123_1396_24002)"
  })), _path1253 || (_path1253 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4894 137.316L81.0176 140.201L80.36 138.749L81.7277 136.06L82.4894 137.316Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1254 || (_path1254 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2478 130.557L83.988 128.381L85.8937 126.705L85.2196 128.679L83.2478 130.557Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1255 || (_path1255 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3581 109.036L54.1555 109.204L54.5948 105.803L57.7661 105.935L57.3581 109.036Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1256 || (_path1256 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4201 59.3913L64.7821 55.4573L68.5135 56.0087L69.1115 59.9438L65.4201 59.3913Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1257 || (_path1257 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9216 113.2L96.6973 110.743L103.115 109.429L103.312 111.687L96.9216 113.2Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1258 || (_path1258 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6123 125.664L87.1384 123.161L90.6762 121.385L90.194 123.652L86.6123 125.664Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1259 || (_path1259 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9173 95.8509L48.9723 99.7843L48.6698 98.2504L49.6561 94.1313L49.9173 95.8509Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1260 || (_path1260 = /*#__PURE__*/React.createElement("path", {
    d: "M102.22 103.835L101.437 101.88L108.961 100.858L109.686 102.681L102.22 103.835Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1261 || (_path1261 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6883 99.5909L70.9561 99.844L71.9103 98.2116L78.558 98.119L77.6883 99.5909Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1262 || (_path1262 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6535 103.252L50.2293 104.16L49.7209 108.183L49.1198 107.5L49.6535 103.252Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1263 || (_path1263 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1642 95.8717L80.8525 96.1811L81.745 95.515L88.9637 95.2795L88.1642 95.8717Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask124 || (_mask124 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1388-inside-124_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6241 94.2859L101.065 93.6522L102.558 93.8947L94.206 94.5442L92.6241 94.2859Z"
  }))), _path1264 || (_path1264 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6241 94.2859L92.5941 93.887L92.5596 94.6806L92.6241 94.2859ZM101.065 93.6522L101.129 93.2574L101.082 93.2498L101.035 93.2533L101.065 93.6522ZM102.558 93.8947L102.589 94.2935L102.622 93.4998L102.558 93.8947ZM94.206 94.5442L94.1415 94.9389L94.189 94.9467L94.237 94.943L94.206 94.5442ZM92.654 94.6847L101.095 94.0511L101.035 93.2533L92.5941 93.887L92.654 94.6847ZM101.001 94.047L102.494 94.2895L102.622 93.4998L101.129 93.2574L101.001 94.047ZM102.527 93.4959L94.1749 94.1454L94.237 94.943L102.589 94.2935L102.527 93.4959ZM94.2704 94.1494L92.6885 93.8911L92.5596 94.6806L94.1415 94.9389L94.2704 94.1494Z",
    fill: "white",
    mask: "url(#path-1388-inside-124_1396_24002)"
  })), _path1265 || (_path1265 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5413 81.1894L52.6492 77.4013L53.1367 80.7595L51.1043 84.3956L50.5413 81.1894Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1266 || (_path1266 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6756 105.377L58.25 105.534L58.9475 102.718L63.3161 102.828L62.6756 105.377Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1267 || (_path1267 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1967 105.753L53.7508 109.205L51.6683 109.062L52.1462 105.313L54.1967 105.753Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1268 || (_path1268 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2472 88.4347L49.7751 92.3229L49.3716 89.8771L50.9075 85.8051L51.2472 88.4347Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1269 || (_path1269 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5132 102.253L63.8691 102.426L64.7395 100.21L70.3079 100.254L69.5132 102.253Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1270 || (_path1270 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8178 73.4129L84.4524 70.2881L86.9697 74.9679L87.3097 78.0412L84.8178 73.4129Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1271 || (_path1271 = /*#__PURE__*/React.createElement("path", {
    d: "M101.267 101.497L100.339 99.7724L107.918 98.871L108.778 100.477L101.267 101.497Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1272 || (_path1272 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5621 138.304L85.876 134.477L87.3766 134.64L85.9795 138.691L84.5621 138.304Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1273 || (_path1273 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7116 61.903L61.101 60.3979L61.7764 64.4858L58.4536 65.9487L57.7116 61.903Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1274 || (_path1274 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5959 104.45L51.7612 105.174L51.2773 108.971L50.0817 108.519L50.5959 104.45Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1275 || (_path1275 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8097 95.0253L95.0197 94.6812L102.522 94.0978L103.229 94.4051L95.8097 95.0253Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1276 || (_path1276 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4595 117.784L91.4625 115.127L96.5421 113.71L96.5314 116.128L91.4595 117.784Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1277 || (_path1277 = /*#__PURE__*/React.createElement("path", {
    d: "M103.062 109.028L96.6413 110.343L96.1863 107.915L102.652 106.797L103.062 109.028Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask125 || (_mask125 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1403-inside-125_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.7548 130.308L83.817 128.265L82.7975 131.262L81.639 133.591L82.7548 130.308Z"
  }))), _path1278 || (_path1278 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7548 130.308L82.3999 130.124L82.3859 130.151L82.3761 130.18L82.7548 130.308ZM83.817 128.265L84.1957 128.393L83.4621 128.08L83.817 128.265ZM82.7975 131.262L83.1557 131.44L83.1676 131.416L83.1762 131.39L82.7975 131.262ZM81.639 133.591L81.2603 133.462L81.9972 133.769L81.639 133.591ZM83.1098 130.493L84.172 128.449L83.4621 128.08L82.3999 130.124L83.1098 130.493ZM83.4384 128.136L82.4188 131.133L83.1762 131.39L84.1957 128.393L83.4384 128.136ZM82.4394 131.083L81.2809 133.413L81.9972 133.769L83.1557 131.44L82.4394 131.083ZM82.0178 133.72L83.1336 130.437L82.3761 130.18L81.2603 133.462L82.0178 133.72Z",
    fill: "white",
    mask: "url(#path-1403-inside-125_1396_24002)"
  })), _path1279 || (_path1279 = /*#__PURE__*/React.createElement("path", {
    d: "M100.117 99.3974L99.088 97.9593L106.716 97.1629L107.67 98.499L100.117 99.3974Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1280 || (_path1280 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3526 96.1183L96.3328 95.3848L103.981 94.7455L104.917 95.4184L97.3526 96.1183Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1281 || (_path1281 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5301 60.0424L68.9399 56.1583L72.6534 57.7466L73.2036 61.6178L69.5301 60.0424Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1282 || (_path1282 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8023 97.5858L97.7324 96.482L105.393 95.7732L106.383 96.7945L98.8023 97.5858Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1283 || (_path1283 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6771 110.582L93.2349 105.82L93.3984 104.391L93.8473 109.244L93.6771 110.582Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1284 || (_path1284 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5548 94.8592L82.7796 95.0802L83.3022 94.8662L89.9789 94.6866L89.5548 94.8592Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1285 || (_path1285 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7776 96.6079L78.8197 97.7142L72.2359 97.8059L73.2953 96.5717L79.7776 96.6079Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1286 || (_path1286 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1973 122.687L87.4714 119.917L91.0254 118.38L90.7705 120.893L87.1973 122.687Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1287 || (_path1287 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1357 127.716L84.692 125.05L86.6558 123.52L86.1454 125.948L84.1357 127.716Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1288 || (_path1288 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3915 68.604L80.9651 65.1763L83.9409 69.3424L84.3362 72.7238L81.3915 68.604Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1289 || (_path1289 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2011 138.122L82.9548 137.233L84.16 133.707L85.4919 134.362L84.2011 138.122Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1290 || (_path1290 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9123 134.192L88.8774 129.647L90.2892 129.053L89.2707 133.822L87.9123 134.192Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1291 || (_path1291 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7279 132.047L81.8732 134.556L81.84 133.62L82.6475 131.244L82.7279 132.047Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1292 || (_path1292 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5437 102.683L57.8367 105.536L54.671 105.404L55.4389 102.272L58.5437 102.683Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1293 || (_path1293 = /*#__PURE__*/React.createElement("path", {
    d: "M73.6374 61.8285L73.0992 58.0416L76.6792 60.6075L77.1789 64.3684L73.6374 61.8285Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1294 || (_path1294 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1592 100.714L50.1114 96.7505L50.414 98.1287L49.5058 101.897L49.1592 100.714Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1295 || (_path1295 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0954 107.528L95.4242 105.207L101.95 104.279L102.56 106.41L96.0954 107.528Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1296 || (_path1296 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9011 94.1177L90.4757 89.1918L90.3802 86.8762L91.8281 91.8871L91.9011 94.1177Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1297 || (_path1297 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6285 64.7097L77.1451 61.0711L80.4776 64.5121L80.9256 68.1135L77.6285 64.7097Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1298 || (_path1298 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6672 136.84L81.9317 135.626L83.005 132.474L83.8197 133.467L82.6672 136.84Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1299 || (_path1299 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8562 120.26L92.8666 115.101L93.4429 113.539L93.4292 118.85L92.8562 120.26Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1300 || (_path1300 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4543 98.1969L70.4854 99.8545L64.9467 99.8106L66.0139 97.9674L71.4543 98.1969Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1301 || (_path1301 = /*#__PURE__*/React.createElement("path", {
    d: "M91.439 114.717L91.1832 112.003L96.303 110.826L96.5285 113.297L91.439 114.717Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1302 || (_path1302 = /*#__PURE__*/React.createElement("path", {
    d: "M90.8202 128.18L91.333 123.136L92.3916 121.902L91.8539 127.147L90.8202 128.18Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask126 || (_mask126 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1429-inside-126_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.2604 94.6705L91.0732 94.4602L92.6225 94.286L84.927 94.4824L83.2604 94.6705Z"
  }))), _path1303 || (_path1303 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2604 94.6705L83.2156 94.273L83.2712 95.0703L83.2604 94.6705ZM91.0732 94.4602L91.0839 94.8601L91.101 94.8596L91.1179 94.8577L91.0732 94.4602ZM92.6225 94.286L92.6672 94.6835L92.6123 93.8861L92.6225 94.286ZM84.927 94.4824L84.9168 94.0826L84.8994 94.083L84.8821 94.085L84.927 94.4824ZM83.2712 95.0703L91.0839 94.8601L91.0624 94.0604L83.2497 94.2706L83.2712 95.0703ZM91.1179 94.8577L92.6672 94.6835L92.5778 93.8885L91.0285 94.0627L91.1179 94.8577ZM92.6123 93.8861L84.9168 94.0826L84.9372 94.8823L92.6327 94.6859L92.6123 93.8861ZM84.8821 94.085L83.2156 94.273L83.3053 95.068L84.9718 94.8799L84.8821 94.085Z",
    fill: "white",
    mask: "url(#path-1429-inside-126_1396_24002)"
  })), _path1304 || (_path1304 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3184 100.188L63.4364 102.433L59.0819 102.324L60.0482 99.8394L64.3184 100.188Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1305 || (_path1305 = /*#__PURE__*/React.createElement("path", {
    d: "M55.136 68.9982L58.1519 66.607L58.7242 70.5838L55.7946 72.8922L55.136 68.9982Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1306 || (_path1306 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0501 102.176L54.2704 105.357L52.2181 104.917L53.0592 101.459L55.0501 102.176Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1307 || (_path1307 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2936 104.823L94.4302 102.683L101.026 101.934L101.813 103.896L95.2936 104.823Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1308 || (_path1308 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0891 95.5074L80.1476 96.2101L73.7988 96.1746L74.8552 95.3808L81.0891 95.5074Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1309 || (_path1309 = /*#__PURE__*/React.createElement("path", {
    d: "M49.738 102.64L50.6798 98.7319L51.2435 99.9261L50.3525 103.609L49.738 102.64Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1310 || (_path1310 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1631 64.3832L61.4854 60.2813L65.0767 59.7941L65.6829 63.9156L62.1631 64.3832Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1311 || (_path1311 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2459 128.928L83.7024 126.736L84.0603 126.117L83.6264 128.196L83.2459 128.928Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1312 || (_path1312 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5732 91.4695L50.2041 95.0744L49.9056 93.1084L51.3431 89.3113L51.5732 91.4695Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask127 || (_mask127 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1440-inside-127_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.927 94.4825L92.6226 94.2861L94.2043 94.5444L86.6307 94.7619L84.927 94.4825Z"
  }))), _path1313 || (_path1313 = /*#__PURE__*/React.createElement("path", {
    d: "M84.927 94.4825L84.9168 94.0827L84.8623 94.8773L84.927 94.4825ZM92.6226 94.2861L92.687 93.8914L92.6499 93.8853L92.6124 93.8863L92.6226 94.2861ZM94.2043 94.5444L94.2158 94.9443L94.2688 94.1497L94.2043 94.5444ZM86.6307 94.7619L86.566 95.1566L86.6038 95.1628L86.6422 95.1617L86.6307 94.7619ZM84.9372 94.8824L92.6328 94.686L92.6124 93.8863L84.9168 94.0827L84.9372 94.8824ZM92.5581 94.6809L94.1399 94.9392L94.2688 94.1497L92.687 93.8914L92.5581 94.6809ZM94.1929 94.1446L86.6192 94.362L86.6422 95.1617L94.2158 94.9443L94.1929 94.1446ZM86.6954 94.3671L84.9917 94.0878L84.8623 94.8773L86.566 95.1566L86.6954 94.3671Z",
    fill: "white",
    mask: "url(#path-1440-inside-127_1396_24002)"
  })), _path1314 || (_path1314 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4848 119.479L87.4813 116.54L91.0633 115.263L91.0601 117.933L87.4848 119.479Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1315 || (_path1315 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5721 100.271L52.696 101.264L51.8475 104.752L50.6657 104.018L51.5721 100.271Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1316 || (_path1316 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2599 102.297L93.2395 100.408L99.9102 99.8192L100.841 101.549L94.2599 102.297Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1317 || (_path1317 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7551 124.496L85.0485 121.486L87.0447 120.176L86.7729 122.923L84.7551 124.496Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1318 || (_path1318 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9702 76.8491L55.5083 73.7533L55.9188 77.3593L53.4749 80.3255L52.9702 76.8491Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1319 || (_path1319 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9813 134.085L86.8847 129.803L88.4535 129.715L87.4905 134.25L85.9813 134.085Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1320 || (_path1320 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2491 110.428L91.125 111.606L90.6147 108.922L95.7913 107.985L96.2491 110.428Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1321 || (_path1321 = /*#__PURE__*/React.createElement("path", {
    d: "M88.3649 95.2962L87.5301 94.9317L94.1658 94.7412L94.8911 95.0572L88.3649 95.2962Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1322 || (_path1322 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2105 85.0209L53.2035 81.4552L53.4783 84.4357L51.5734 87.8306L51.2105 85.0209Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1323 || (_path1323 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0142 100.028L91.8847 98.453L98.6275 98.0038L99.6567 99.4423L93.0142 100.028Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1324 || (_path1324 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7934 96.5429L71.7069 97.8085L66.3206 97.5813L67.525 96.1676L72.7934 96.5429Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1325 || (_path1325 = /*#__PURE__*/React.createElement("path", {
    d: "M90.0286 96.4804L88.9169 95.6799L95.7157 95.4309L96.7162 96.1506L90.0286 96.4804Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1326 || (_path1326 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6443 99.7737L58.6625 102.298L55.5657 101.888L56.6367 99.113L59.6443 99.7737Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1327 || (_path1327 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5907 98.0706L90.4185 96.8617L97.2155 96.5265L98.2801 97.6249L91.5907 98.0706Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1328 || (_path1328 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3117 94.8437L81.637 95.1199L75.7525 95.0004L76.5478 94.6729L82.3117 94.8437Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1329 || (_path1329 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0369 83.1285L87.8858 80.2295L89.9146 85.271L90.0303 88.0755L88.0369 83.1285Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1330 || (_path1330 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9859 104.483L92.0051 99.2823L92.2157 97.127L93.2179 102.455L92.9859 104.483Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1331 || (_path1331 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5571 128.09L83.0004 130.759L82.9563 130.319L83.4951 127.732L83.5571 128.09Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1332 || (_path1332 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5783 97.9239L64.4916 99.8009L60.2446 99.4543L61.4401 97.3732L65.5783 97.9239Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1333 || (_path1333 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5971 133.971L84.2733 133.319L85.1021 129.366L86.486 129.757L85.5971 133.971Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1334 || (_path1334 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9339 132.98L83.1459 132.019L83.887 128.467L84.7286 129.189L83.9339 132.98Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1335 || (_path1335 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5233 108.532L89.774 105.964L95.0232 105.259L95.6988 107.595L90.5233 108.532Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1336 || (_path1336 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4551 116.121L87.1647 113.111L90.7916 112.106L91.0494 114.84L87.4551 116.121Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1337 || (_path1337 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9634 94.0378L50.6694 97.435L50.3268 95.8748L51.6928 92.2782L51.9634 94.0378Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1338 || (_path1338 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9341 129.19L89.4274 124.282L90.9001 123.426L90.3759 128.583L88.9341 129.19Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1339 || (_path1339 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0876 63.9116L65.4839 59.807L69.1717 60.3588L69.7015 64.4597L66.0876 63.9116Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask128 || (_mask128 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1468-inside-128_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.5115 94.4723L83.2599 94.6723L84.9264 94.4842L78.3247 94.2666L76.5115 94.4723Z"
  }))), _path1340 || (_path1340 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5115 94.4723L76.4664 94.0748L76.4996 94.8721L76.5115 94.4723ZM83.2599 94.6723L83.248 95.0721L83.2765 95.073L83.3047 95.0698L83.2599 94.6723ZM84.9264 94.4842L84.9713 94.8817L84.9396 94.0845L84.9264 94.4842ZM78.3247 94.2666L78.3379 93.8668L78.3086 93.8659L78.2796 93.8692L78.3247 94.2666ZM76.4996 94.8721L83.248 95.0721L83.2717 94.2725L76.5233 94.0724L76.4996 94.8721ZM83.3047 95.0698L84.9713 94.8817L84.8816 94.0868L83.215 94.2748L83.3047 95.0698ZM84.9396 94.0845L78.3379 93.8668L78.3115 94.6664L84.9132 94.884L84.9396 94.0845ZM78.2796 93.8692L76.4664 94.0748L76.5566 94.8697L78.3698 94.6641L78.2796 93.8692Z",
    fill: "white",
    mask: "url(#path-1468-inside-128_1396_24002)"
  })), _path1341 || (_path1341 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2599 98.9716L55.1712 101.793L53.1776 101.075L54.3562 98.0026L56.2599 98.9716Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1342 || (_path1342 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8009 125.767L84.0864 122.823L84.5852 122.11L84.3154 124.877L83.8009 125.767Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1343 || (_path1343 = /*#__PURE__*/React.createElement("path", {
    d: "M58.52 66.3577L61.83 64.9004L62.3127 68.9802L59.0992 70.3829L58.52 66.3577Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1344 || (_path1344 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7852 114.166L92.2791 108.754L92.9248 106.79L93.4439 112.38L92.7852 114.166Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1345 || (_path1345 = /*#__PURE__*/React.createElement("path", {
    d: "M85.057 121.003L85.0486 117.775L87.0806 116.725L87.084 119.673L85.057 121.003Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1346 || (_path1346 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2557 95.332L73.1427 96.1684L67.9828 95.8008L69.2287 94.8587L74.2557 95.332Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1347 || (_path1347 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3416 122.51L91.3475 117.195L92.4676 115.673L92.4565 121.211L91.3416 122.51Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1348 || (_path1348 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6456 105.577L88.6847 103.209L94.0189 102.721L94.8873 104.874L89.6456 105.577Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1349 || (_path1349 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6839 96.1288L51.4359 99.3948L50.8363 98.1246L52.1626 94.6425L52.6839 96.1288Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1350 || (_path1350 = /*#__PURE__*/React.createElement("path", {
    d: "M85.097 77.6626L84.8833 74.3737L87.4252 79.0942L87.5918 82.2909L85.097 77.6626Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1351 || (_path1351 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9618 96.5191L54.0193 97.7664L52.8337 100.857L51.6904 99.8465L52.9618 96.5191Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask129 || (_mask129 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1481-inside-129_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.326 94.2666L84.9278 94.4842L86.6315 94.7636L80.1823 94.5716L78.326 94.2666Z"
  }))), _path1352 || (_path1352 = /*#__PURE__*/React.createElement("path", {
    d: "M78.326 94.2666L78.3392 93.8668L78.2612 94.6613L78.326 94.2666ZM84.9278 94.4842L84.9925 94.0895L84.9669 94.0853L84.941 94.0845L84.9278 94.4842ZM86.6315 94.7636L86.6196 95.1634L86.6962 94.3688L86.6315 94.7636ZM80.1823 94.5716L80.1174 94.9663L80.1437 94.9706L80.1704 94.9714L80.1823 94.5716ZM78.3129 94.6664L84.9146 94.884L84.941 94.0845L78.3392 93.8668L78.3129 94.6664ZM84.8631 94.879L86.5668 95.1583L86.6962 94.3688L84.9925 94.0895L84.8631 94.879ZM86.6434 94.3638L80.1942 94.1718L80.1704 94.9714L86.6196 95.1634L86.6434 94.3638ZM80.2471 94.1769L78.3909 93.8719L78.2612 94.6613L80.1174 94.9663L80.2471 94.1769Z",
    fill: "white",
    mask: "url(#path-1481-inside-129_1396_24002)"
  })), _path1353 || (_path1353 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0363 97.2712L59.8152 99.3967L56.8206 98.7389L58.1571 96.3988L61.0363 97.2712Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1354 || (_path1354 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0594 96.0954L65.8201 97.55L61.7229 97.0047L63.0923 95.3871L67.0594 96.0954Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1355 || (_path1355 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6567 88.4993L53.5237 85.1721L53.6785 87.7081L51.9077 90.8537L51.6567 88.4993Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1356 || (_path1356 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1061 112.713L86.5331 109.732L90.2237 108.998L90.7385 111.706L87.1061 112.713Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1357 || (_path1357 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1159 64.5597L69.5923 60.5065L73.2658 62.0819L73.7158 66.1079L70.1159 64.5597Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1358 || (_path1358 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5099 102.823L87.3763 100.731L92.8027 100.44L93.8276 102.337L88.5099 102.823Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask130 || (_mask130 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1489-inside-130_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.177 123.822L83.8934 122.753L83.514 126.666L83.7616 128.095L84.177 123.822Z"
  }))), _path1359 || (_path1359 = /*#__PURE__*/React.createElement("path", {
    d: "M84.177 123.822L84.5751 123.861L84.5821 123.789L84.5636 123.719L84.177 123.822ZM83.8934 122.753L84.28 122.65L83.4953 122.714L83.8934 122.753ZM83.514 126.666L83.1159 126.627L83.1107 126.681L83.1199 126.734L83.514 126.666ZM83.7616 128.095L83.3675 128.163L84.1597 128.134L83.7616 128.095ZM84.5636 123.719L84.28 122.65L83.5068 122.855L83.7903 123.925L84.5636 123.719ZM83.4953 122.714L83.1159 126.627L83.9122 126.704L84.2915 122.792L83.4953 122.714ZM83.1199 126.734L83.3675 128.163L84.1557 128.027L83.9082 126.598L83.1199 126.734ZM84.1597 128.134L84.5751 123.861L83.7788 123.783L83.3635 128.056L84.1597 128.134Z",
    fill: "white",
    mask: "url(#path-1489-inside-130_1396_24002)"
  })), _path1360 || (_path1360 = /*#__PURE__*/React.createElement("path", {
    d: "M86.9423 129.402L87.401 124.779L89.0135 124.415L88.5211 129.314L86.9423 129.402Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1361 || (_path1361 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8651 73.3452L58.7696 71.0564L59.0794 74.8505L56.2856 77.0392L55.8651 73.3452Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1362 || (_path1362 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0748 95.1789L81.2085 94.8L86.5868 94.9601L87.3239 95.2819L82.0748 95.1789Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1363 || (_path1363 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7065 98.231L90.1842 92.9809L90.3913 90.3347L91.9513 95.7259L91.7065 98.231Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1364 || (_path1364 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7388 72.9584L81.455 69.3832L84.4286 73.5432L84.6554 77.0355L81.7388 72.9584Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1365 || (_path1365 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7112 94.5842L74.7587 94.9764L69.9914 94.5276L71.0832 94.0755L75.7112 94.5842Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1366 || (_path1366 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1486 100.346L85.8956 98.6012L91.4121 98.4784L92.5434 100.056L87.1486 100.346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1367 || (_path1367 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5511 80.8602L55.9576 77.9393L56.1344 81.2056L53.8387 83.9802L53.5511 80.8602Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1368 || (_path1368 = /*#__PURE__*/React.createElement("path", {
    d: "M83.888 96.4704L82.6678 95.5912L88.2602 95.7009L89.3463 96.4829L83.888 96.4704Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1369 || (_path1369 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5948 98.2072L84.2976 96.87L89.8842 96.8827L91.0508 98.0858L85.5948 98.2072Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1370 || (_path1370 = /*#__PURE__*/React.createElement("path", {
    d: "M74.1417 66.3151L73.7004 62.3666L77.2479 64.911L77.6187 68.8106L74.1417 66.3151Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1371 || (_path1371 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0193 117.338L84.6937 114.011L86.7756 113.24L87.0688 116.279L85.0193 117.338Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1372 || (_path1372 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0521 69.1429L77.6917 65.3524L81.0038 68.7715L81.2993 72.4944L78.0521 69.1429Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1373 || (_path1373 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7873 128.708L83.9697 128.006L84.3461 124.135L85.1915 124.585L84.7873 128.708Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1374 || (_path1374 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0902 122.119L84.0795 118.749L84.6495 118.15L84.6578 121.308L84.0902 122.119Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1375 || (_path1375 = /*#__PURE__*/React.createElement("path", {
    d: "M85.165 128.963L85.5843 124.686L86.9965 124.795L86.5442 129.353L85.165 128.963Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1376 || (_path1376 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4395 109.339L85.6014 106.484L89.3734 106.014L90.1293 108.605L86.4395 109.339Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1377 || (_path1377 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7964 96.226L56.4335 98.6128L54.5275 97.6427L56.0068 95.0399L57.7964 96.226Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1378 || (_path1378 = /*#__PURE__*/React.createElement("path", {
    d: "M62.219 64.7792L65.7302 64.3127L66.1117 68.4351L62.704 68.8782L62.219 64.7792Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1379 || (_path1379 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9833 91.533L53.7414 88.4099L53.9358 90.5208L52.279 93.4552L51.9833 91.533Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1380 || (_path1380 = /*#__PURE__*/React.createElement("path", {
    d: "M68.704 94.7555L67.3886 95.7502L63.5 95.0559L64.9619 93.9445L68.704 94.7555Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1381 || (_path1381 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4401 123.81L89.4401 118.672L90.9465 117.534L90.9404 122.939L89.4401 123.81Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1382 || (_path1382 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5824 94.259L76.5125 94.267L72.8517 93.8646L73.0412 93.8429L76.5824 94.259Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1383 || (_path1383 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6808 95.2585L61.2678 96.9275L58.4115 96.0621L59.9622 94.2209L62.6808 95.2585Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1384 || (_path1384 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1273 107.937L91.0937 102.477L91.7622 100.155L92.8279 105.806L92.1273 107.937Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1385 || (_path1385 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7042 94.7635L54.2171 97.3799L53.1396 96.1089L54.7395 93.2839L55.7042 94.7635Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1386 || (_path1386 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5137 92.8675L52.9395 95.6471L52.3888 94.0768L54.0696 91.0997L54.5137 92.8675Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1387 || (_path1387 = /*#__PURE__*/React.createElement("path", {
    d: "M91.297 116.591L90.7839 111.158L91.932 109.338L92.4623 115.008L91.297 116.591Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1388 || (_path1388 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4692 106.101L84.3964 103.467L88.2642 103.245L89.2329 105.632L85.4692 106.101Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1389 || (_path1389 = /*#__PURE__*/React.createElement("path", {
    d: "M84.631 113.61L83.9913 110.303L86.1408 109.816L86.7211 112.836L84.631 113.61Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask131 || (_mask131 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1521-inside-131_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.1636 119.362L83.8805 118.671L83.8934 122.752L84.177 123.821L84.1636 119.362Z"
  }))), _path1390 || (_path1390 = /*#__PURE__*/React.createElement("path", {
    d: "M84.1636 119.362L84.5636 119.361L84.5633 119.283L84.5337 119.21L84.1636 119.362ZM83.8805 118.671L84.2506 118.519L83.4805 118.672L83.8805 118.671ZM83.8934 122.752L83.4934 122.753L83.4936 122.805L83.5068 122.855L83.8934 122.752ZM84.177 123.821L83.7904 123.924L84.577 123.82L84.177 123.821ZM84.5337 119.21L84.2506 118.519L83.5103 118.823L83.7934 119.514L84.5337 119.21ZM83.4805 118.672L83.4934 122.753L84.2934 122.751L84.2805 118.67L83.4805 118.672ZM83.5068 122.855L83.7904 123.924L84.5636 123.719L84.2801 122.65L83.5068 122.855ZM84.577 123.82L84.5636 119.361L83.7636 119.363L83.777 123.822L84.577 123.82Z",
    fill: "white",
    mask: "url(#path-1521-inside-131_1396_24002)"
  })), _path1391 || (_path1391 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8472 92.1414L87.8143 87.105L87.9859 84.0787L90.0729 89.2575L89.8472 92.1414Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask132 || (_mask132 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1524-inside-132_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.041 93.6416L78.3256 94.2625L80.1816 94.5675L75.0761 93.9763L73.041 93.6416Z"
  }))), _path1392 || (_path1392 = /*#__PURE__*/React.createElement("path", {
    d: "M73.041 93.6416L73.0877 93.2443L72.9761 94.0363L73.041 93.6416ZM78.3256 94.2625L78.3905 93.8678L78.3814 93.8663L78.3723 93.8652L78.3256 94.2625ZM80.1816 94.5675L80.1356 94.9649L80.2465 94.1728L80.1816 94.5675ZM75.0761 93.9763L75.0111 94.371L75.0206 94.3725L75.03 94.3736L75.0761 93.9763ZM72.9943 94.0389L78.2789 94.6598L78.3723 93.8652L73.0877 93.2443L72.9943 94.0389ZM78.2608 94.6572L80.1167 94.9622L80.2465 94.1728L78.3905 93.8678L78.2608 94.6572ZM80.2276 94.1702L75.1221 93.5789L75.03 94.3736L80.1356 94.9649L80.2276 94.1702ZM75.141 93.5816L73.1059 93.2469L72.9761 94.0363L75.0111 94.371L75.141 93.5816Z",
    fill: "white",
    mask: "url(#path-1524-inside-132_1396_24002)"
  })), _path1393 || (_path1393 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8886 84.5492L56.1463 81.8203L56.1882 84.6681L54.0529 87.2396L53.8886 84.5492Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1394 || (_path1394 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0354 118.214L83.6823 114.627L84.3117 114.222L84.6402 117.578L84.0354 118.214Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1395 || (_path1395 = /*#__PURE__*/React.createElement("path", {
    d: "M59.151 70.7947L62.3444 69.4007L62.5351 73.318L59.4655 74.6471L59.151 70.7947Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1396 || (_path1396 = /*#__PURE__*/React.createElement("path", {
    d: "M84.2224 103.077L82.9594 100.753L86.9311 100.752L88.0713 102.856L84.2224 103.077Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1397 || (_path1397 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4144 93.9165L69.1515 94.4393L65.578 93.6648L66.995 93.0752L70.4144 93.9165Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1398 || (_path1398 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4163 124.364L87.4104 119.526L89.0405 118.869L89.0405 123.997L87.4163 124.364Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1399 || (_path1399 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5133 68.4331L66.1329 64.3216L69.7438 64.8693L70.0175 68.9716L66.5133 68.4331Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1400 || (_path1400 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1573 94.6706L76.3795 94.33L80.1292 94.7643L80.7737 95.0462L77.1573 94.6706Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1401 || (_path1401 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6171 94.0082L58.0243 95.8993L56.2355 94.7137L57.9683 92.6477L59.6171 94.0082Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1402 || (_path1402 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2037 124.14L84.3764 123.7L84.3641 119.609L85.1937 119.792L85.2037 124.14Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1403 || (_path1403 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3329 77.5095L59.0938 75.3465L59.1454 78.8303L56.5153 80.8801L56.3329 77.5095Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1404 || (_path1404 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7247 100.351L81.3334 98.4161L85.4051 98.6038L86.6594 100.35L82.7247 100.351Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1405 || (_path1405 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1473 96.0918L77.832 95.1436L81.9583 95.5721L83.1257 96.4132L79.1473 96.0918Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1406 || (_path1406 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6046 124.286L85.5943 119.803L87.0103 119.617L87.0161 124.395L85.6046 124.286Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1407 || (_path1407 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5267 93.7697L62.9837 94.9429L60.3078 93.9216L62.0059 92.6244L64.5267 93.7697Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1408 || (_path1408 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0178 97.9997L79.5873 96.5253L83.7316 96.8602L85.0157 98.184L81.0178 97.9997Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1409 || (_path1409 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8969 109.913L82.9626 106.744L85.1968 106.533L86.0462 109.426L83.8969 109.913Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1410 || (_path1410 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4539 86.4202L84.9638 81.8063L85.0759 78.4691L87.6355 83.2177L87.4539 86.4202Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1411 || (_path1411 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0882 87.8209L56.2038 85.2735L56.2816 87.6862L54.2954 90.0702L54.0882 87.8209Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1412 || (_path1412 = /*#__PURE__*/React.createElement("path", {
    d: "M90.887 101.744L89.3406 96.4249L89.9956 93.7734L91.5943 99.2871L90.887 101.744Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1413 || (_path1413 = /*#__PURE__*/React.createElement("path", {
    d: "M71.963 93.5644L71.0676 93.6666L68.1071 92.9382L69.1451 92.8187L71.963 93.5644Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1414 || (_path1414 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7042 92.338L55.9579 94.42L54.9753 92.9129L56.8596 90.6583L57.7042 92.338Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1415 || (_path1415 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4054 118.196L88.9061 112.971L90.4179 111.535L90.9376 117.038L89.4054 118.196Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1416 || (_path1416 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4261 69.0727L70.155 65.0093L73.7596 66.5595L73.9245 70.5816L70.4261 69.0727Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask133 || (_mask133 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1550-inside-133_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.7188 114.831L83.4731 114.525L83.8809 118.668L84.164 119.359L83.7188 114.831Z"
  }))), _path1417 || (_path1417 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7188 114.831L84.1169 114.791L84.1052 114.673L84.0304 114.58L83.7188 114.831ZM83.4731 114.525L83.7848 114.275L82.9436 113.229L83.0751 114.565L83.4731 114.525ZM83.8809 118.668L83.4829 118.707L83.4886 118.765L83.5108 118.82L83.8809 118.668ZM84.164 119.359L83.7939 119.511L84.5621 119.32L84.164 119.359ZM84.0304 114.58L83.7848 114.275L83.1615 114.776L83.4072 115.081L84.0304 114.58ZM83.0751 114.565L83.4829 118.707L84.279 118.629L83.8712 114.486L83.0751 114.565ZM83.5108 118.82L83.7939 119.511L84.5342 119.207L84.2511 118.516L83.5108 118.82ZM84.5621 119.32L84.1169 114.791L83.3207 114.87L83.7659 119.398L84.5621 119.32Z",
    fill: "white",
    mask: "url(#path-1550-inside-133_1396_24002)"
  })), _path1418 || (_path1418 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6129 114.199L82.9105 110.579L83.6032 110.397L84.2583 113.783L83.6129 114.199Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1419 || (_path1419 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3608 90.6157L56.3591 88.2173L56.69 90.2369L54.8259 92.4672L54.3608 90.6157Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1420 || (_path1420 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6792 110.571L89.6528 105.177L90.7972 103.056L91.8644 108.693L90.6792 110.571Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1421 || (_path1421 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8309 106.354L81.6383 103.433L83.9703 103.48L85.0552 106.144L82.8309 106.354Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1422 || (_path1422 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5813 81.2584L81.704 77.2397L81.7378 73.6459L84.6981 77.7839L84.5813 81.2584Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1423 || (_path1423 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7378 69.2764L66.1317 68.8352L66.191 72.8059L62.9299 73.2212L62.7378 69.2764Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1424 || (_path1424 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3336 70.7849L74.1713 66.8265L77.6627 69.3322L77.7232 73.2194L74.3336 70.7849Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask134 || (_mask134 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1559-inside-134_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.1595 92.6166L73.0404 93.6435L75.0753 93.9782L71.3956 92.9839L69.1595 92.6166Z"
  }))), _path1425 || (_path1425 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1595 92.6166L69.2244 92.2219L69.0572 93.0033L69.1595 92.6166ZM73.0404 93.6435L72.938 94.0302L72.9566 94.0351L72.9755 94.0382L73.0404 93.6435ZM75.0753 93.9782L75.0104 94.3729L75.1796 93.592L75.0753 93.9782ZM71.3956 92.9839L71.5 92.5978L71.4804 92.5925L71.4605 92.5892L71.3956 92.9839ZM69.0572 93.0033L72.938 94.0302L73.1427 93.2568L69.2619 92.2299L69.0572 93.0033ZM72.9755 94.0382L75.0104 94.3729L75.1402 93.5835L73.1053 93.2488L72.9755 94.0382ZM75.1796 93.592L71.5 92.5978L71.2913 93.3701L74.9709 94.3643L75.1796 93.592ZM71.4605 92.5892L69.2244 92.2219L69.0947 93.0113L71.3308 93.3786L71.4605 92.5892Z",
    fill: "white",
    mask: "url(#path-1559-inside-134_1396_24002)"
  })), _path1426 || (_path1426 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5075 92.8461L64.917 93.5079L62.479 92.4002L64.2345 91.666L66.5075 92.8461Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1427 || (_path1427 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6752 92.3715L59.9046 93.7241L58.2633 92.3699L60.1934 90.8895L61.6752 92.3715Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1428 || (_path1428 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3071 76.8132L78.1266 73.5313L78.0675 69.7302L81.3419 73.11L81.3071 76.8132Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1429 || (_path1429 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1349 79.3493L59.033 82.4355L56.5835 84.336L56.5399 81.3718L59.1349 79.3493Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1430 || (_path1430 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3468 119.198L83.9353 115.013L84.7319 114.931L85.1662 119.378L84.3468 119.198Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1431 || (_path1431 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3835 119.107L86.9083 114.192L88.5287 113.228L89.0271 118.444L87.3835 119.107Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1432 || (_path1432 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4593 103.028L80.0624 100.461L82.4969 100.737L83.7669 103.075L81.4593 103.028Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1433 || (_path1433 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5324 73.7552L62.4383 77.3823L59.5421 78.627L59.4896 75.0728L62.5324 73.7552Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask135 || (_mask135 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1569-inside-135_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.3951 92.9824L75.0748 93.9767L77.1041 94.8652L73.6267 93.9599L71.3951 92.9824Z"
  }))), _path1434 || (_path1434 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3951 92.9824L71.4995 92.5963L71.2346 93.3488L71.3951 92.9824ZM75.0748 93.9767L75.2352 93.6103L75.2079 93.5983L75.1791 93.5905L75.0748 93.9767ZM77.1041 94.8652L77.0033 95.2523L77.2645 94.4988L77.1041 94.8652ZM73.6267 93.9599L73.4662 94.3263L73.4952 94.339L73.5259 94.347L73.6267 93.9599ZM71.2908 93.3686L74.9705 94.3628L75.1791 93.5905L71.4995 92.5963L71.2908 93.3686ZM74.9144 94.3431L76.9437 95.2316L77.2645 94.4988L75.2352 93.6103L74.9144 94.3431ZM77.2049 94.4781L73.7275 93.5728L73.5259 94.347L77.0033 95.2523L77.2049 94.4781ZM73.7872 93.5935L71.5556 92.616L71.2346 93.3488L73.4662 94.3263L73.7872 93.5935Z",
    fill: "white",
    mask: "url(#path-1569-inside-135_1396_24002)"
  })), _path1435 || (_path1435 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5728 119.407L85.1276 114.848L86.5223 114.358L86.9923 119.22L85.5728 119.407Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1436 || (_path1436 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8161 110.192L81.7896 106.715L82.5517 106.76L83.5096 110.01L82.8161 110.192Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1437 || (_path1437 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0884 95.7835L87.0643 90.7788L87.6751 87.8247L89.7715 93.0186L89.0884 95.7835Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1438 || (_path1438 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8134 100.029L78.291 97.9127L80.8149 98.3774L82.197 100.3L79.8134 100.029Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1439 || (_path1439 = /*#__PURE__*/React.createElement("path", {
    d: "M75.8794 95.3361L74.6118 94.4221L77.0189 95.0488L78.1495 95.8637L75.8794 95.3361Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask136 || (_mask136 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1576-inside-136_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.8496 110.356L82.6779 110.434L83.4723 114.528L83.718 114.834L82.8496 110.356Z"
  }))), _path1440 || (_path1440 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8496 110.356L83.2423 110.28L83.1458 109.783L82.6844 109.992L82.8496 110.356ZM82.6779 110.434L82.5127 110.07L82.2251 110.201L82.2852 110.511L82.6779 110.434ZM83.4723 114.528L83.0796 114.605L83.0985 114.702L83.1607 114.779L83.4723 114.528ZM83.718 114.834L83.4063 115.084L84.1106 114.758L83.718 114.834ZM82.6844 109.992L82.5127 110.07L82.8432 110.799L83.0149 110.721L82.6844 109.992ZM82.2852 110.511L83.0796 114.605L83.865 114.452L83.0706 110.358L82.2852 110.511ZM83.1607 114.779L83.4063 115.084L84.0296 114.583L83.7839 114.278L83.1607 114.779ZM84.1106 114.758L83.2423 110.28L82.4569 110.433L83.3253 114.91L84.1106 114.758Z",
    fill: "white",
    mask: "url(#path-1576-inside-136_1396_24002)"
  })), _path1441 || (_path1441 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9381 97.4419L76.4128 95.8703L78.9726 96.4653L80.3514 97.8863L77.9381 97.4419Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1442 || (_path1442 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9714 90.5598L58.0126 92.0622L57.155 90.3565L59.274 88.725L59.9714 90.5598Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1443 || (_path1443 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5329 92.4892L67.0177 92.6636L64.9151 91.572L66.5929 91.3772L68.5329 92.4892Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1444 || (_path1444 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0172 82.9514L58.9442 85.6007L56.6729 87.356L56.5916 84.8334L59.0172 82.9514Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1445 || (_path1445 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9529 73.3319L66.5916 72.8088L66.5324 68.8403L70.0305 69.3779L69.9529 73.3319Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1446 || (_path1446 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8248 112.496L87.8362 107.33L89.3245 105.591L90.3608 111.038L88.8248 112.496Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1447 || (_path1447 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7026 87.8408L58.973 86.0864L59.1574 88.3091L57.0457 89.9349L56.7026 87.8408Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1448 || (_path1448 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9168 91.3643L62.026 92.155L60.5639 90.6927L62.6276 89.8255L63.9168 91.3643Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1449 || (_path1449 = /*#__PURE__*/React.createElement("path", {
    d: "M89.4991 104.62L87.9823 99.4195L89.0929 97.0009L90.6746 102.441L89.4991 104.62Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1450 || (_path1450 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6537 106.304L80.36 103.139L81.1899 103.39L82.3976 106.348L81.6537 106.304Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1451 || (_path1451 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8793 114.614L83.0758 110.471L83.8233 110.13L84.6745 114.533L83.8793 114.614Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1452 || (_path1452 = /*#__PURE__*/React.createElement("path", {
    d: "M86.7713 90.2213L84.3222 85.6905L84.8624 82.4626L87.4024 87.1688L86.7713 90.2213Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1453 || (_path1453 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4197 92.6179L69.2273 92.422L67.6922 91.542L69.0175 91.7591L70.4197 92.6179Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1454 || (_path1454 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4099 77.8288L62.1416 81.073L59.4396 82.2267L59.5441 79.0605L62.4099 77.8288Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1455 || (_path1455 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1793 73.2107L65.9268 76.9027L62.8428 77.2877L62.9379 73.6234L66.1793 73.2107Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask137 || (_mask137 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1593-inside-137_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.578 106.049L81.5151 106.496L82.6771 110.432L82.8488 110.354L81.578 106.049Z"
  }))), _path1456 || (_path1456 = /*#__PURE__*/React.createElement("path", {
    d: "M81.578 106.049L81.9617 105.936L81.1819 105.993L81.578 106.049ZM81.5151 106.496L81.119 106.441L81.107 106.527L81.1315 106.61L81.5151 106.496ZM82.6771 110.432L82.2935 110.545L82.4236 110.986L82.8423 110.796L82.6771 110.432ZM82.8488 110.354L83.014 110.718L83.3309 110.575L83.2324 110.241L82.8488 110.354ZM81.1819 105.993L81.119 106.441L81.9112 106.552L81.9741 106.104L81.1819 105.993ZM81.1315 106.61L82.2935 110.545L83.0607 110.319L81.8988 106.383L81.1315 106.61ZM82.8423 110.796L83.014 110.718L82.6836 109.99L82.5118 110.068L82.8423 110.796ZM83.2324 110.241L81.9617 105.936L81.1944 106.162L82.4652 110.467L83.2324 110.241Z",
    fill: "white",
    mask: "url(#path-1593-inside-137_1396_24002)"
  })), _path1457 || (_path1457 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8382 113.768L85.9042 108.914L87.487 107.639L88.4736 112.795L86.8382 113.768Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1458 || (_path1458 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7159 74.8904L70.3509 73.4347L70.428 69.5086L73.9293 71.0188L73.7159 74.8904Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1459 || (_path1459 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1534 102.662L78.6854 99.9657L79.5596 100.376L80.9314 102.897L80.1534 102.662Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1460 || (_path1460 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0651 114.445L84.1948 109.944L85.5428 109.148L86.4672 113.952L85.0651 114.445Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1461 || (_path1461 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6195 88.5098L61.9189 87.5389L62.445 89.4701L60.3233 90.3616L59.6195 88.5098Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask138 || (_mask138 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1600-inside-138_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.0884 91.571L71.3952 92.9838L73.6268 93.9613L71.5392 92.6443L69.0884 91.571Z"
  }))), _path1462 || (_path1462 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0884 91.571L69.2489 91.2046L68.8795 91.9122L69.0884 91.571ZM71.3952 92.9838L71.1863 93.3249L71.2096 93.3392L71.2347 93.3502L71.3952 92.9838ZM73.6268 93.9613L73.4663 94.3277L73.8402 93.623L73.6268 93.9613ZM71.5392 92.6443L71.7526 92.306L71.7272 92.2899L71.6997 92.2779L71.5392 92.6443ZM68.8795 91.9122L71.1863 93.3249L71.6041 92.6427L69.2974 91.2299L68.8795 91.9122ZM71.2347 93.3502L73.4663 94.3277L73.7873 93.5949L71.5557 92.6174L71.2347 93.3502ZM73.8402 93.623L71.7526 92.306L71.3258 92.9826L73.4134 94.2996L73.8402 93.623ZM71.6997 92.2779L69.2489 91.2046L68.928 91.9375L71.3788 93.0107L71.6997 92.2779Z",
    fill: "white",
    mask: "url(#path-1600-inside-138_1396_24002)"
  })), _path1463 || (_path1463 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3269 91.2323L63.0757 89.7387L65.2039 89.4889L66.2767 91.0058L64.3269 91.2323Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1464 || (_path1464 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9966 85.2177L81.1904 81.3018L81.6374 77.834L84.5511 81.9036L83.9966 85.2177Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1465 || (_path1465 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3486 99.3636L76.8662 97.304L77.7009 97.7806L79.0905 99.7119L78.3486 99.3636Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1466 || (_path1466 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3771 77.4383L74.1055 75.0867L74.3162 71.2629L77.7186 73.7066L77.3771 77.4383Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask139 || (_mask139 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1606-inside-139_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.5402 92.6406L73.6278 93.9577L75.7946 95.5201L73.9208 94.3573L71.5402 92.6406Z"
  }))), _path1467 || (_path1467 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5402 92.6406L71.7536 92.3023L71.3062 92.9651L71.5402 92.6406ZM73.6278 93.9577L73.8617 93.6332L73.8517 93.626L73.8412 93.6194L73.6278 93.9577ZM75.7946 95.5201L75.5837 95.86L76.0285 95.1957L75.7946 95.5201ZM73.9208 94.3573L73.6869 94.6818L73.6981 94.6899L73.7099 94.6972L73.9208 94.3573ZM71.3267 92.9789L73.4143 94.296L73.8412 93.6194L71.7536 92.3023L71.3267 92.9789ZM73.3938 94.2821L75.5606 95.8445L76.0285 95.1957L73.8617 93.6332L73.3938 94.2821ZM76.0055 95.1802L74.1317 94.0174L73.7099 94.6972L75.5837 95.86L76.0055 95.1802ZM74.1548 94.0329L71.7741 92.3162L71.3062 92.9651L73.6869 94.6818L74.1548 94.0329Z",
    fill: "white",
    mask: "url(#path-1606-inside-139_1396_24002)"
  })), _path1468 || (_path1468 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1025 81.5246L61.853 84.333L59.3509 85.395L59.4261 82.6674L62.1025 81.5246Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1469 || (_path1469 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7812 98.8982L85.8129 94.0429L86.8611 91.3382L88.9177 96.4231L87.7812 98.8982Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1470 || (_path1470 = /*#__PURE__*/React.createElement("path", {
    d: "M76.29 96.5141L75.1954 95.3862L75.6678 95.6793L76.7113 96.7546L76.29 96.5141Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1471 || (_path1471 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8352 80.9187L77.7517 77.7379L78.0874 74.0691L81.292 77.3758L80.8352 80.9187Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1472 || (_path1472 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7096 106.86L86.2569 101.897L87.693 99.8581L89.2206 105.095L87.7096 106.86Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1473 || (_path1473 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3515 85.8292L61.8407 84.7726L61.8512 87.1324L59.5405 88.108L59.3515 85.8292Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask140 || (_mask140 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1614-inside-140_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M79.9374 102.035L80.0155 102.829L81.5156 106.499L81.5785 106.051L79.9374 102.035Z"
  }))), _path1474 || (_path1474 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9374 102.035L80.3077 101.884L79.5393 102.074L79.9374 102.035ZM80.0155 102.829L79.6174 102.868L79.6231 102.926L79.6452 102.98L80.0155 102.829ZM81.5156 106.499L81.1453 106.65L81.7056 108.021L81.9117 106.555L81.5156 106.499ZM81.5785 106.051L81.9746 106.107L81.9896 106L81.9488 105.9L81.5785 106.051ZM79.5393 102.074L79.6174 102.868L80.4136 102.789L80.3355 101.996L79.5393 102.074ZM79.6452 102.98L81.1453 106.65L81.8858 106.348L80.3858 102.677L79.6452 102.98ZM81.9117 106.555L81.9746 106.107L81.1824 105.996L81.1195 106.443L81.9117 106.555ZM81.9488 105.9L80.3077 101.884L79.5671 102.186L81.2082 106.203L81.9488 105.9Z",
    fill: "white",
    mask: "url(#path-1614-inside-140_1396_24002)"
  })), _path1475 || (_path1475 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9754 110.077L81.8061 106.115L82.4881 105.518L83.7299 109.733L82.9754 110.077Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1476 || (_path1476 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5129 77.4144L66.3262 76.9125L66.5792 73.2136L69.9286 73.7348L69.5129 77.4144Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1477 || (_path1477 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7502 90.9855L65.7381 89.5543L67.859 89.9002L68.6974 91.3045L66.7502 90.9855Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1478 || (_path1478 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8821 77.3097L65.4338 80.6275L62.5507 80.9809L62.8227 77.6917L65.8821 77.3097Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1479 || (_path1479 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7937 108.49L84.4263 103.835L85.9436 102.252L87.3925 107.202L85.7937 108.49Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1480 || (_path1480 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8325 89.3679L62.3064 87.4369L64.7286 87.149L65.0659 89.1056L62.8325 89.3679Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1481 || (_path1481 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0902 109.541L82.82 105.229L84.0959 104.132L85.449 108.739L84.0902 109.541Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _mask141 || (_mask141 = /*#__PURE__*/React.createElement("mask", {
    id: "path-1623-inside-141_1396_24002",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.9703 98.4175L78.2178 99.523L80.0168 102.828L79.9388 102.034L77.9703 98.4175Z"
  }))), _path1482 || (_path1482 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9703 98.4175L78.3216 98.2263L77.5799 98.5049L77.9703 98.4175ZM78.2178 99.523L77.8275 99.6104L77.8398 99.665L77.8665 99.7142L78.2178 99.523ZM80.0168 102.828L79.6655 103.019L80.4149 102.788L80.0168 102.828ZM79.9388 102.034L80.3368 101.995L80.3289 101.914L80.2901 101.843L79.9388 102.034ZM77.5799 98.5049L77.8275 99.6104L78.6082 99.4356L78.3606 98.3301L77.5799 98.5049ZM77.8665 99.7142L79.6655 103.019L80.3682 102.636L78.5692 99.3317L77.8665 99.7142ZM80.4149 102.788L80.3368 101.995L79.5407 102.073L79.6188 102.867L80.4149 102.788ZM80.2901 101.843L78.3216 98.2263L77.6189 98.6087L79.5874 102.225L80.2901 101.843Z",
    fill: "white",
    mask: "url(#path-1623-inside-141_1396_24002)"
  })), _path1483 || (_path1483 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5663 93.5742L83.2003 89.2038L84.1599 86.2332L86.6359 90.8141L85.5663 93.5742Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1484 || (_path1484 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2279 91.412L68.4741 90.1492L70.5167 91.0429L71.1139 92.2378L69.2279 91.412Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1485 || (_path1485 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3715 81.0406L64.9299 83.9227L62.2604 84.2446L62.5139 81.3909L65.3715 81.0406Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1486 || (_path1486 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6571 105.716L80.1635 102.061L80.762 101.21L82.3525 105.107L81.6571 105.716Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1487 || (_path1487 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8872 84.3283L64.7057 86.7471L62.2508 87.039L62.2402 84.6474L64.8872 84.3283Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1488 || (_path1488 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0844 101.448L84.2075 96.829L85.5636 94.4997L87.5415 99.3786L86.0844 101.448Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1489 || (_path1489 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1036 78.9046L69.9043 77.5167L70.318 73.8543L73.6792 75.3084L73.1036 78.9046Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1490 || (_path1490 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8086 98.6142L76.3482 96.5851L76.3036 96.446L77.7836 98.5028L77.8086 98.6142Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1491 || (_path1491 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6965 92.5082L71.2052 91.5251L73.1044 92.8944L73.4702 93.7872L71.6965 92.5082Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1492 || (_path1492 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0903 94.2478L73.845 93.649L75.5487 95.4046L75.7144 95.9213L74.0903 94.2478Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1493 || (_path1493 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9143 88.7862L80.2171 85.0261L81.065 81.8182L83.8912 85.7621L82.9143 88.7862Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1494 || (_path1494 = /*#__PURE__*/React.createElement("path", {
    d: "M65.472 89.1058L65.1384 87.1708L67.6236 87.5735L67.7647 89.4797L65.472 89.1058Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1495 || (_path1495 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8193 81.1158L65.8337 80.6404L66.2839 77.3085L69.4518 77.8074L68.8193 81.1158Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1496 || (_path1496 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5957 81.348L73.4754 79.1036L74.0456 75.5413L77.3216 77.8958L76.5957 81.348Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1497 || (_path1497 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6732 104.829L81.0413 100.831L82.2199 99.4432L83.9622 103.721L82.6732 104.829Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1498 || (_path1498 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8967 84.6684L76.9454 81.6247L77.662 78.2166L80.7578 81.4102L79.8967 84.6684Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1499 || (_path1499 = /*#__PURE__*/React.createElement("path", {
    d: "M84.271 103.419L82.5093 99.0945L83.9339 97.2163L85.8046 101.82L84.271 103.419Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1500 || (_path1500 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9598 101.655L78.1927 98.4082L78.6874 97.3091L80.575 100.78L79.9598 101.655Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1501 || (_path1501 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9923 96.4069L81.7443 92.2615L82.9945 89.6617L85.3674 94.045L83.9923 96.4069Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1502 || (_path1502 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6465 87.1696L65.1081 86.7583L65.2902 84.3327L68.027 84.7727L67.6465 87.1696Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1503 || (_path1503 = /*#__PURE__*/React.createElement("path", {
    d: "M68.1736 89.583L68.0355 87.7175L70.5228 88.8041L70.4724 90.5887L68.1736 89.583Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1504 || (_path1504 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0999 84.3809L65.3332 83.9362L65.7772 81.0382L68.7385 81.5096L68.0999 84.3809Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1505 || (_path1505 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9303 98.0198L75.9454 95.2614L76.314 93.9256L78.4416 96.8838L77.9303 98.0198Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1506 || (_path1506 = /*#__PURE__*/React.createElement("path", {
    d: "M72.212 82.5346L69.2074 81.2277L69.8382 77.9284L73.0244 79.3109L72.212 82.5346Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1507 || (_path1507 = /*#__PURE__*/React.createElement("path", {
    d: "M73.1167 92.4126L70.8666 90.7903L70.9156 89.0575L73.3438 90.8075L73.1167 92.4126Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1508 || (_path1508 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8468 100.44L78.9029 96.8661L79.9602 95.2072L82.0398 99.0361L80.8468 100.44Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1509 || (_path1509 = /*#__PURE__*/React.createElement("path", {
    d: "M75.627 94.9116L73.481 92.7004L73.7006 91.1491L76.0088 93.528L75.627 94.9116Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1510 || (_path1510 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3083 98.6939L80.204 94.8195L81.5102 92.6663L83.7489 96.7946L82.3083 98.6939Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1511 || (_path1511 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4852 91.8745L78.9311 88.3173L80.0519 85.4765L82.7519 89.2403L81.4852 91.8745Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1512 || (_path1512 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5888 88.3967L68.0322 87.2798L68.4107 84.8955L71.1648 86.0962L70.5888 88.3967Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1513 || (_path1513 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5129 84.8412L72.5751 82.7264L73.3815 79.5265L76.4944 81.7657L75.5129 84.8412Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1514 || (_path1514 = /*#__PURE__*/React.createElement("path", {
    d: "M71.274 85.7072L68.4858 84.4915L69.1231 81.6263L72.1054 82.9236L71.274 85.7072Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1515 || (_path1515 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6339 87.9846L75.8475 85.1117L76.819 82.0677L79.7683 85.1094L78.6339 87.9846Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1516 || (_path1516 = /*#__PURE__*/React.createElement("path", {
    d: "M78.6591 96.5055L76.4618 93.4505L77.3753 91.5468L79.7307 94.8241L78.6591 96.5055Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1517 || (_path1517 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9587 94.4504L77.5735 91.1316L78.7382 88.733L81.2798 92.2727L79.9587 94.4504Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1518 || (_path1518 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4591 90.398L70.9528 88.5918L71.5228 86.3153L74.2189 88.2574L73.4591 90.398Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1519 || (_path1519 = /*#__PURE__*/React.createElement("path", {
    d: "M76.1743 93.1242L73.7884 90.6652L74.5383 88.5525L77.1007 91.1939L76.1743 93.1242Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1520 || (_path1520 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3652 87.8685L71.6339 85.9012L72.4596 83.1369L75.3781 85.2379L74.3652 87.8685Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _path1521 || (_path1521 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2861 90.8096L74.69 88.1337L75.6931 85.5284L78.4635 88.3847L77.2861 90.8096Z",
    stroke: "white",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1396_24002",
    x1: 96,
    y1: 192,
    x2: 95.9998,
    y2: 0.00000388065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#317049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43854A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrvUsd);
export default __webpack_public_path__ + "static/media/crvUSD.7fbdd864239c52c8006616b6361a9767.svg";
export { ForwardRef as ReactComponent };